// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./image/login_page.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./image/Bannerimage.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projectoverview_page_container {
    padding: 0px;
    padding-inline-start: 0rem !important;
    padding-inline-end: 0rem !important;
}


html {
    width: 100%;
    height: 100%;
    margin: 0;
    /* overflow: hidden; */
    position: absolute !important;
    top: 0;
    left: 0;
    overflow-x: hidden;
    max-width: 100%;
    min-height: 100% !important;
}

body {
    -webkit-overflow-scrolling: auto;
    /* Stops scrolling immediately */
    width: 100%;
    margin: 0;
    /*overflow: hidden;*/
    position: absolute !important;
    top: 0;
    left: 0;
    /*overflow-x: hidden;*/
    max-width: 100%;
    min-height: 100% !important;

}

.block_tb_dt li:last-child {
    display: none;
}

.tble_fd .chakra-checkbox__control {

    display: none;
}

.tble_fd tr td:first-child {

    /*display: none;*/
}

.bg_strip_btn_save .chakra-text {
    margin-right: 15px;
}

body::-webkit-scrollbar:horizontal {
    display: none;
}

.blog_design_mt {
    margin: 30px 8px 20px !important;
}

.searchBox_searchPage input.ais-SearchBox-input {
    -webkit-appearance: none !important;
}

.ProductImageSearchPage {
    object-fit: contain;
}


.side-menuct {
    padding-inline-start: 0rem !important;
    padding-inline-end: 0rem !important;
}

.lt_pr_4sbmt_de {
    display: flex;
}

.box_width_30 {
    max-width: 450px;
    width: 30%;
    min-width: 300px;
    background: #F7F7F7;
    /* Dropy */

    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

.box_width_70 {
    width: 100%;
    min-width: 70%;
    max-width: 100%;
}

.List_db1 {
    padding: 0px;
    margin-inline-start: 0em !important;
    margin: 0px;
    list-style-type: none !important;
}

.List_main {
    background-color: #592C82;
    height: 88px;
    display: block;
    text-align: left;

}

.content__block_brandpage {
    margin-top: 75px !important;
    margin-bottom: 75px !important;
}

.List_main {
    background-color: #592C82 !important;
    height: 88px;
    display: block;
    text-align: left;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    /* identical to box height, or 100% */

    display: flex;
    align-items: center;
    padding-left: 30px;
    letter-spacing: 0.18px;
    border: 0px solid #C4C4C4 !important;
    color: #FFFFFF !important;
}

.List_main .chakra-avatar {
    background-color: transparent;
    max-width: 36px;
    margin-right: 13px;
}

.List_main .user_nm_db {
    padding-top: 4px;

}

.List_db1 {
    color: #F7F7F7;
    padding-bottom: 30px;
}

.List_db1 li {
    padding: 24px 30px 24px;
    /* background-color: #000; */
    text-align: left;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 120% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    background-color: #fff;
    color: #000000;
    transition: all 0.3s ease-in;
    border: 1px solid #C4C4C4;
}

.List_db1 li:hover {

    letter-spacing: 0.15px;
    border-left: 8px solid #F58220;
    color: #F58220;
    transition: all 0.3s ease-in;
}

.list_dt_01 {
    height: 60px;

    background: #592C82 !important;
}

.list_dt_01 {
    font-weight: 700;
    font-size: 16px !important;
    line-height: 24px;
    /* identical to box height, or 150% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    border-left: 0px solid #F58220 !important;
    color: #FFFFFF !important;
}

.list_dt_01 .chakra-avatar {
    background-color: transparent;
    max-width: 36px;
    margin-right: 15.5px;

}

/* .list_dt{


} */
.list_dt_01:hover {
    border-left: 0px solid #F58220 !important;
}

.list_db2 li {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 120% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;

    color: #000000;

}

.lg_out {
    background-color: transparent !important;
    font-weight: 700;
    font-size: 20px !important;
    line-height: 24px;
    /* identical to box height, or 120% */


    letter-spacing: 0.15px;
    text-transform: inherit !important;
    color: #000000 !important;
    height: 76px;

}

.lg_out .chakra-avatar {

    margin-right: 9px;
}

.pd_bm {
    padding-bottom: 0px !important;
}

.project_br {
    -webkit-padding-start: 0rem !important;
    /* padding-inline-start: 1rem;
    -webkit-padding-end: 1rem; */
    padding-inline-end: 0rem !important;
}

.bd_crum {
    background: #F2F2F2;
    width: 100%;
    text-align: left;
    color: #000;
    /* height: 107px; */
    padding: 20px 43px;
}

.pages_project_bar_sub_heading {
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    /* identical to box height, or 120% */

    display: flex;
    align-items: center;
    letter-spacing: 1.5px;

    /* Black 90 (Text) */

    color: #1A1A1A;


}

.pages_project_bar_heading {
    font-style: normal;
    font-weight: 700;
    font-size: 34px;
    line-height: 36px;
    /* identical to box height, or 106% */

    display: flex;
    align-items: center;

    /* Black 90 (Text) */

    color: #1A1A1A;

}

.bd_crum .chakra-avatar {
    background-color: transparent;
    margin-left: 17px;
}

.bd_crum a {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;

    letter-spacing: 1.25px;
    text-transform: uppercase;
    color: #EC7700;
    transition: all 0.3s ease-in;
}

.bd_crum a:hover {
    transition: all 0.3s ease-in;
    color: #1A1A1A;
}

.bg_color_acrhove {
    background: #F2F2F2;
    text-align: left;
    margin: 20px 35px;
    gap: 20px;
    padding: 5px 20px;

}

.articleproducts_mt_content {
    padding: 15px;
    /* height: 100%; */
    display: block;
    min-height: 150px;
}

.articleproducts_mt {
    position: relative;
}

.ArticleProductButton {
    display: block;
    padding: 7px;
    width: 90%;
    position: absolute;

    left: 50%;
    transform: translate(-50%, -50%);
    bottom: -10px;
}

.productpricearticlepage {
    display: none;
}

.bg_color_acrhove .chakra-avatar {
    background-color: transparent;
    max-width: 36px;
    /* margin-right: 13px; */
}

.dt_archive {
    padding-top: 0px;
    display: inline-block;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    /* identical to box height */


    letter-spacing: 0.1px;
    text-transform: uppercase;

    color: #000000;
}

.header_center_mt {
    padding: 7px 0px !important;
}

.lt_brder {
    position: relative;
}

.lt_brder:after {
    content: '';
    position: absolute;
    height: 45px;
    border-right: 1px solid #C4C4C4;
    right: -18px;
}

.lt_pr {
    margin-left: 27px;
}

.flx_sp_bt {
    justify-content: end !important;
    border: none !important;
    padding: 5px 10px 5px !important;
    margin-bottom: 0px !important;
}

.sp_qtdt {
    width: 150px;
}

.color_strip {
    background: #E9EAEB;
    display: flex;
    height: 40px;
    justify-content: space-between;
    padding: 12px 15px 4px;
    margin: 0px 35px 0px 35px;
    position: relative;
}

.tb_grid h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 120% */


    letter-spacing: 0.15px;

    /* Black 90 (Text) */

    color: #1A1A1A;

}

.tb_grid .chakra-avatar {
    background-color: transparent;

}

.color_strip a {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    right: 0px;
    top: -4px;

    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    text-decoration-line: underline;

    color: #F58220 !important;
}

.bgFlx {
    background: #F7F7F7;
    display: flex;
    justify-content: space-between;
    margin: 0px 34px 20px 35px;
    padding: 12px 15px 4px;
}

.bgFlx p {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */
    padding: 17px 0px 10px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;
}

img.image-360 {

    height: 44px;
    object-fit: contain;
}

.bgFlx h3 {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    letter-spacing: 0.25px;
    text-align: left;
    padding-bottom: 40px;
    color: #000000;
}

.wd_50_prview {
    max-width: 50%;
    width: 100%;
}

.bg_pj {
    background: #E9EAEB;
    /* margin: 0px 35px 0px 35px; */
    display: flex;
    justify-content: space-between;
    padding: 14px 15px 10px;
    position: relative;
    height: 40px;
}

.bg_pj h2 {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    /* Black 90 (Text) */

    color: #1A1A1A;
}

.bg_pj a {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    text-decoration-line: underline;
    position: absolute;
    right: 0;
    top: -3px;
    right: 0px;
    color: #F58220;
}

.bg_pj .chakra-avatar {
    background-color: transparent;
}

.dt_frman {
    height: 256px;

    /* margin: 0px 35px 0px 35px; */

    padding: 14px 15px 10px;
    background: #F7F7F7;
}

.dt_frman p {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */
    padding: 10px 0px 17px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;

}

.dt_frman ul {
    list-style-type: none;
    padding: 0px 0px 0px 0px;
    margin: 0px;
    text-align: left;
}

.smith_jhn {
    font-style: normal;
    font-weight: 700 !important;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    letter-spacing: 0.25px;

    color: #000000;

}

.dt_frman li {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    /* or 143% */

    letter-spacing: 0.25px;

    color: #000000;
    display: flex;
    justify-content: space-between;
}

.space_sd {
    margin: 0px 17px 0px 35px;
}

.chakra-modal__content .css-z7mtfw {
    align-items: center;
    gap: 20px;
}

.chakra-modal__content .orange_button_drillcut {
    margin-top: 0px !important;
}

.space_sd1 {
    margin: 0px 35px 0px 17px;
}

.ht_rm {
    height: auto;
    margin-bottom: 21px;
}

.lmPs {
    background: #FFFFFF;
    border: 0px solid #E2E2E2 !important;
    border-radius: 4px;
}

.lmPs .checkbox__control {
    border: 0px !important;;
}

.cl_bf {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    padding-left: 10px;
    letter-spacing: 0.15px;

    color: #000000;

}

.st_lt {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px !important;
    /* identical to box height, or 143% */

    letter-spacing: 0.25px;
    padding: 12px 0px 3px !important;
    color: #000000;

}

.button_list_dt {
    list-style-type: none !important;
    padding: 0px;
    margin: 0px;
    display: flex;
    justify-content: space-around;
    padding: 27px 15px 10px;
}

.wd_50_prview-wd-1 {
    position: relative;
}

.button_list_dt li {
    background-color: #592C82;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);

    width: 13%;
    transition: all .5s ease-in-out;
    height: 104px;
    position: relative;
    text-align: center;
}

.button_list_dt li:hover {
    transform: scale(1.1);
}

.button_list_dt span {
    font-weight: 700;
    font-size: 12.5px;
    line-height: 20px;

    text-align: center;
    letter-spacing: 0.25px;
    color: #FFFFFF;
}

.button_list_dt .chakra-avatar {
    background-color: transparent;
    display: block;
    margin: 0px auto;
    margin-top: 17px;
}

.button_list_dt img {
    border-radius: 0px !important;
}

.projcts_lt {
    height: 80px;
    position: relative;
    padding-left: 20px;
}

.projcts_lt:after {
    position: absolute;
    content: '';
    left: 0px;
    height: 100%;
    border-left: 8px solid #F58220 !important;
}

.mob_v {
    padding-left: 10px;
}

.hd_dtp {
    display: none;
}

.options_txt {
    background: #F2F2F2;
    height: 60px;
    margin: 20px 35px;
    padding: 5px 20px;
}

.options_txt p {

    text-align: left;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    color: #000000;
    display: flex;
    align-items: center;
}

.options_txt .chakra-avatar {
    background-color: transparent;
}

.options_txt {
    display: none;
}

.rmv_brder {
    position: inherit;
}

/* qoutes page css start */
.tab_bar {
    background: #592C82;
    height: 49px;
    color: #fff;
    margin: 20px 35px;
    border-bottom: none !important;
}

.tab_bar button {
    text-transform: uppercase;
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 17px;
    /* identical to box height */

    display: flex;
    align-items: center;
    letter-spacing: 0.1px;
    text-transform: uppercase;

    /* color: #FFFFFF; */
    padding-top: 11px;
    opacity: 0.5;
}

.search_filter {
    width: auto !important;
}

.tab_bar button[aria-selected=true] {
    color: #FFFFFF !important;
    opacity: 1 !important;


    position: relative;
}

.tab_bar button[aria-selected=true]:after {
    width: 0;
    position: absolute;
    content: '';
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 9px solid #fff;
    bottom: -1px;

}

.search_filter input {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
    width: 330px;
    /* width: 100%; */
    height: 40px;
    position: relative;
    padding-left: 40px;
    font-size: 12px;
}

.search_filter input {
}

.search_filter input:focus,
.search_filter input[data-focus] {
    box-shadow: none !important;
    border-color: #C4C4C4 !important;
}

.search_filter input::placeholder {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;

    color: #000000;

    opacity: 0.5;
}

.bx_flx_filt {
    display: flex;
    justify-content: space-between;
    margin: 0px 19px;
}

.bx_flx_filt img {
    position: absolute;
    z-index: 9;
    top: 11px;
    left: 13px;
}

.tab_dt {
    padding-top: 0px !important;
}

.tab_dt a {
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    /* identical to box height, or 373% */

    display: flex;
    align-items: center;
    text-align: right;

    /* Orange */

    color: #EC7700;
}

.footer_logo_main_logo {
    max-width: 241px;
    width: 100%;
}

.tble_dt {
    margin: 5px 19px;
}

.tble_dt th {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */


    letter-spacing: 0.1px;
    text-transform: uppercase;

    color: #000000;
}

.tble_dt td {
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */
    overflow: hidden;
    text-overflow: ellipsis;

    letter-spacing: 0.25px;

    color: #000000;
    padding-top: 12px;
    padding-bottom: 12px;
    border-bottom: 0px !important;
    position: relative;
}

.tble_dt span {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;

    letter-spacing: 0.25px;

    /* Orange */

    color: #EC7700;

}

.main_th {
    background: #E9EAEB;
}

.tble_dt tr:nth-child(even) {
    background: #F2F2F2;
}

.hd_menu {
    display: none;
}

.block_tb_dt {
    padding: 0px;
    margin: 0px;
    background: #F2F2F2;
    list-style-type: none !important;
    margin-inline-start: 0em !important;
    padding: 29px 15px 15px;
    display: none;
    margin-bottom: 11px;
}

.lt_tbl_mb {
    margin-bottom: 127px;
}

.block_tb_dt p {

    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    width: 35%;
    min-width: 35%;
    display: block;


}

.block_tb_dt span {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    letter-spacing: 0.25px;

    color: #000000;
}

.block_tb_dt li {
    display: flex;
    text-align: left;
    height: 27px;
}

.block_tb_dt button {
    background: #EC7700;
    border-radius: 5px;
    font-weight: 700;
    font-size: 12px;
    /* line-height: 56px; */
    /* display: flex; */
    /* align-items: center; */
    text-align: center;
    color: #FFFFFF;
    text-transform: uppercase;
    width: 100%;
    padding: 0px;
    margin: 0px;
    height: 24px;
    margin-top: 10px;
}

.block_tb_dt button:hover {
    color: #EC7700;

}

.block_tb_dt button:focus,
.block_tb_dt button[data-focus] {
    box-shadow: none !important;
}

.model_dt {

    background: #F2F2F2 !important;
    border: 10px solid #F2F2F2;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%) !important;

}

.model_dt h2 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 120% */

    display: block;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    padding-top: 25px;

}

.model_dt p {
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    padding-top: 18px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;

    color: #000000;
}

.model_dt button {
    background: #EC7700;
    border-radius: 5px;
    font-weight: 700;
    font-size: 15px;
    line-height: 14px;
    /* or 93% */
    /* max-width: 154px; */
    height: 44px;
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    margin: 0px 5px;
    color: #FFFFFF;
    transition: all 0.3s ease-in;
    border: 1px solid transparent;
}

.model_dt button:hover {
    color: #EC7700;
    background-color: #FFFFFF;
    transition: all 0.3s ease-in;
    border: 1px solid rgb(185, 185, 185);
}

.model_dt button:focus,
.model_dt button[data-focus] {
    box-shadow: none !important;
}

.model_dt .chakra-modal__footer {
    justify-content: center;
}

..half_width_class_mt {
    width: 50%;
}

.model_dt span {
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    /* display: inline-block; */
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    text-decoration-line: underline;
    color: #000000;
    padding: 5px 0px 25px;
    cursor: pointer;
}

.flx_bx_stp {
    display: flex;
    justify-content: space-between;
}

.flx_bx_stp .chakra-avatar {
    margin-right: 2px;
}

.cstm_project {
    max-height: 190px;
    overflow-y: auto;
}

.cstm_project a {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    text-decoration-line: underline;
    color: #F58220;
    padding: 10px 0px 16px;
}

.option_form {
    margin: 20px 35px 0px 35px;
}

.bg_form_qoutes {
    background: #F6F6F6;
    padding: 30px 15px 1px;
}

.bg_form_qoutes .chakra-switch__track {
    background: #fff;
    border: 1px solid #E2E2E2;
}

.bg_form_qoutes .chakra-switch__thumb {
    background: #EC7700 !important;
}

.bg_form_qoutes .chakra-switch__track[aria-checked=true],
.bg_form_qoutes .chakra-switch__track[data-checked] {
    border: none !important;
    box-shadow: none !important;
    background: #e9eaeb !important;
}

.bg_form_qoutes .chakra-switch__track[data-focus] {
    box-shadow: none !important;
}

.bg_form_qoutes p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */


    letter-spacing: 0.15px;
    padding: 4px 0px 0px 14px;
    color: #000000;
}

.form_options_block label {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 9px;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
}

.form_options_block input {
    background: #FFFFFF;
    border-radius: 5px;

}

.form_options_block textarea {
    background: #FFFFFF;
    border-radius: 5px;
    height: 121px;

}

.form_options_block {
    margin-bottom: 20px;
}

.tg_switchblck {
    margin-bottom: 30px;
}

.form_options_block input:focus,
.form_options_block input[data-focus] {
    z-index: 1;
    border-color: transparent;
    box-shadow: none;
}

.form_options_block textarea:focus,
.form_options_block textarea[data-focus] {
    z-index: 1;
    border-color: transparent;
    box-shadow: none;
}

.option_table thead {
    background: #F2F2F2;
    height: 49px;

}

.warning_table thead {
    background: #FF000060;
    height: 49px;
}

.warning_table tr:nth-child(even) {
    background: rgb(255 0 0 / 40%);
}

.warning_table tr:nth-child(odd) {
    background: rgb(255 0 0 / 20%);
}

.option_table {
    margin-top: 7px;
}

.option_table th {
    font-size: 12px;
    line-height: 16px;
    /* display: flex; */
    /* align-items: center; */
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
}

.option_table input {
    background: #F2F2F2;
    border-radius: 5px;
    height: 40px;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */

    border: none;
    letter-spacing: 0.1px;

    color: #000000;
}

.dt_ip_wd {
    max-width: 85px;
    width: 100%;
    text-align: center;
    font-weight: 700 !important;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */


    align-items: center;
    text-align: center;
    letter-spacing: 0.18px;

    /* Black 90 (Text) */

    color: #1A1A1A;

}

.option_table td {
    border-bottom: 0px !important;
}

.option_table .chakra-avatar {
    background-color: transparent;
}

.price_inline_td {
    font-weight: 700 !important;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */


    align-items: center;
    text-align: center;
    letter-spacing: 0.18px;

    /* Black 90 (Text) */

    color: #1A1A1A;
}

.option_table tr:nth-child(even) {
    background: rgb(242 242 242 / 50%);
}

.option_table input:focus,
.option_table input[data-focus] {
    z-index: 1;
    /*border-color: transparent !important;*/
    box-shadow: none !important;
}

.price_dt a {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    text-decoration-line: underline;
    color: #F58220;
    margin: 70px 0px 9px;
}

.overlaybody {
    z-index: auto !important;
}

.price_dt {


    border-bottom: 1px solid #C4C4C4;
}

.price_dt_summry {
    list-style-type: none !important;
    padding: 0px;
    margin: 0px;
    float: right;
    margin-top: 50px;
    margin-right: 70px;
}

.option_table .css-womqfz {
    /* right: 0px;
    top: 527px;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); */
}

.price_dt_summry li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.price_tl_pr {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 120% */
    /* float:left; */

    letter-spacing: 0.15px;
    text-align: left;
    color: #000000;

}

.option_table th:first-child {
    width: 148px;
}

.option_table th:nth-child(2) {
    width: 148px;
}

.price_tl_pr1 {
    width: 150px;
    font-weight: 700;
    font-size: 20px;
    /* float:right; */
    line-height: 24px;
    /* identical to box height, or 120% */


    text-align: right;
    letter-spacing: 0.15px;
    display: flex;
    justify-content: flex-end;
    color: #000000;

}

.gst_bl {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    /* text-align: left; */
    letter-spacing: 0.15px;
    text-transform: uppercase;
    float: left;
    color: #000000;
}

.gst_bl_inside {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    /* text-align: left; */
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;
}

.gst_bl_1 {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    /* text-align: right;
float: right; */
    letter-spacing: 0.15px;
    text-transform: uppercase;
    text-align: right;
    display: block;
    color: #000000;
}

.slider_image_mt {
    background-size: contain;
    /*height: 400px;*/
    width: 100%;
}

/*.slider_image_mt img {*/
/*    height: 400px;*/
/*}*/

.drillcuttv_popup_close_btn {
    z-index: 9;
}

.chakra-popover__popper.css-1qq679y {
    z-index: 1500 !important;
}

.price_dt_summry li:last-child {
    margin-top: 30px;
    margin-bottom: 75px;
}

.spec_table {
    border: 1.5px solid #C4C4C4;
    overflow-x: auto;
}

.spec_card {
    border-top: 1px solid #C4C4C4;
    padding-bottom: 33px;
    margin: 40px 100px 0;
}

.spec_table th {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */
    height: 50px;
    /* display: flex;
align-items: center; */
    letter-spacing: 0.15px;
    text-transform: uppercase;
    border-bottom: 1px solid #C4C4C4;
    color: #000000;

}

.spec_table td {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.1px;
    border-bottom: 1px solid #C4C4C4;
    color: #000000;
    text-align: left;
}

.spec_card h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    /* identical to box height, or 100% */
    text-align: left;
    letter-spacing: 0.18px;

    /* Black 90 (Text) */

    color: #1A1A1A;
    padding: 25px 0px 20px;

}

.spec_card h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 100% */
    text-align: left;
    letter-spacing: 0.18px;

    /* Black 90 (Text) */

    color: #1A1A1A;
    padding: 25px 0px 20px;

}

.spec_card .chakra-table__container {
    /*max-width: 1000px;*/
    width: 100%;
    margin: 0px auto;
    display: block;
}

.block_feat_inner {
    width: 100%;
    margin: 0px auto;
    display: block;
}

.block_feat h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    /* identical to box height, or 100% */

    letter-spacing: 0.18px;
    text-align: left;
    /* Black 90 (Text) */

    color: #1A1A1A;
}

.block_feat p {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;
    text-align: left;
    letter-spacing: 0.25px;
    color: #000000;
    padding-top: 10px;
}

.block_feat {
    border-bottom: 1px solid #C4C4C4;
    padding-bottom: 27px;
    margin: 40px 100px 33px;
}

.btn_1dwnlod {
    background: #FFFFFF !important;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25) !important;
    margin-right: 23px;
    transition: all 0.3s ease-in;
    padding: 0px;
    height: 58px !important;
    padding-inline-start: 0px !important;;
    justify-content: flex-start !important;
    width: 325px !important;;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */
    margin-top: 16px;
    letter-spacing: 0.1px;

    color: #000000;

}

.mb_hd_rill {
    display: none;
}

.btn_1dwnlod:hover {
    transition: all 0.3s ease-in;
    background: #fcfcfc !important;
}

.btn_1dwnlod span {
    background: #F2F2F2;
    padding: 10px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    margin-right: 33px;
}

.productImageBackground {

    height: auto !important;
    justify-content: center;
}

.collectionImage {
    height: auto !important;
}

.collection_title_collectionPage {

    padding-bottom: 16px !important;
}

.brand_logo_aboutuspage {
    max-width: 1000px;
}

.css-1nravos {
    max-width: 320px;
    margin-bottom: 0px;
    box-shadow: 3px 3px 4px rgb(0 0 0 / 25%);
}

.brand__page .brands_image.css-1nravos a {
    padding: 10px;
    min-width: 237px !important;
    background: #EC7700;
    font-size: 10px;
    padding: 0 !important;
    color: #fff !important;
}

.brand__page .brands_image .css-0 a {
    font-size: 14px !important;
    font-weight: bold;
    letter-spacing: 0.5px;

}

.brand__page .brands_image img, .bg_image img {
    width: 100%;
    max-width: 237px;
    min-height: 210px;
    object-fit: contain;
    background: #f1f1f1;
}

.brands_image img,
.bg_image img {
    width: 100%;
    max-width: 160px;
    min-height: 166px;
    object-fit: contain;
    background: #f1f1f1;
}

.brands_image p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    font-size: 10px;
    line-height: 14px;
    padding: 30px 15px;
}

.css-1wkijx5 .brands_image {

    margin-bottom: 0px !important;
}

.brand_logo_aboutuspage .css-70qvj9 .css-0 a {
    /* background: #000; */
    background: #ec7700;
    border-radius: 5px;
    display: block;
    height: 22px;
    line-height: 30px;
    margin: 20px auto auto;
    min-width: 0 !important;
    min-width: auto !important;
    padding: 84px;
    max-width: 173px;
    width: 100%;
    height: 32px;
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: -55px
}

.brand__page .brands_image .css-0 {
    position: relative;
}

.btn_1dwnlod img {
    max-width: 34px;
}

.bg_color_btn_dwn span {
    background: #EC7700 !important;
}

.bloc_two_feat {
    padding-bottom: 0;
    border-bottom: none;
}

.top_border {
    border-top: 1px solid #C4C4C4;
    padding-top: 25px;
    margin-top: 25px;
}

.bot_border {
    border-bottom: 1px solid #C4C4C4;
    padding-bottom: 25px;
    margin-bottom: 25px;
}

.top_border_only {
    border-bottom: 1px solid #C4C4C4;
}

.pd_rm_signup {
    padding: 0px !important;
}

.signUp_tb button {
    width: 100%;
    background: #F2F2F2;
    border-radius: 10px 10px 0px 0px;
    border: none;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #1A1A1A;
}

.signUp_tb button:focus,
.signUp_tb button[data-focus] {
    box-shadow: none !important;
}

.signUp_tb .chakra-tabs__tab-panels {
    background: #cbd5e0;
}

.signUp_tb {
    margin-top: 60px;
}

.pd_lft_signup {
    padding: 0px 16px;
}

/* .signUp_tb .form_controll{
    grid-gap: inherit!important;
} */
.video_block_bg_img {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    position: relative;
    max-width: 670px;
    width: 100%;
    margin: 0px auto;
    display: block;
    background-position: center center;
    background-size: cover;
    height: 380px;
}

.video_block_bg_img:before {
    content: "";
    position: absolute;
    background: rgba(242, 242, 242, 0.5);
    width: 100%;
    height: 100%;
    display: block;
}

.video_block_bg_img img {
    z-index: 999;
    position: absolute;
    background-color: #fff;
    border-radius: 50%;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.video_block_bg_img p {

    position: absolute;
    bottom: 0px;
    background-color: #eee;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    letter-spacing: 0.18px;
    color: #1A1A1A;
    height: 85px;
    /* top: 50%; */

    padding-top: 29px;

}

.video_block {
    border-bottom: 1px solid #C4C4C4;
    padding-bottom: 44px;
    margin: 40px 100px 33px;
}

.rectangle-bottom:after {
    display: block;
    height: 0px;
    content: "";
    position: absolute;
    width: 100%;
    border-left: 38.5px solid transparent;
    border-right: 38.5px solid transparent;
    border-top: 21px solid #1384b8;
}

.rect_bx_ribon {
    background-color: #1384B8;
    max-width: 77px;
    /* position: relative; */
    /* height: 200px; */
    position: absolute;
    width: 77px;
    right: 6px;
    z-index: 99;
}

.card_bloc_slider {
    position: relative;
    padding: 10px;
    margin-bottom: 20px;
    margin-top: 20px;
}

.productContent {
    position: relative;
}

.productContent span,
.card_bloc_slider span {
    background: #F5C582;
    border-radius: 3px;
    /* padding: 10px 20px; */
    position: absolute;
    left: 10px;
    height: 20px;
    width: 63px;
    font-weight: 700;
    font-size: 9px;
    line-height: 21px;
    /* display: flex; */
    align-items: center;
    text-align: center;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    color: #4D4D4D;
    top: -11px;
}

.productContent span {
    width: 80px;
}

.rect_bx_ribon p {

    font-weight: 700;
    font-size: 11px;
    line-height: 13px;
    /* display: flex; */
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    text-align: center;
    position: relative;
    padding-top: 7px;
}

.main_slider_block {

    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
    margin: 0px 10px;
}

.Img_block_pd_slide {
    background: #F2F2F2;
    position: relative;
    height: 191px;
}

.rect_bx_ribon {
    margin: 0px auto;
}

.card_bloc_slider {
    position: relative;
}

.Img_block_pd_slide img {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
}

.card_bloc_slider h2 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #592C82;
    padding-top: 7px;
    text-align: left;
}

.card_bloc_slider p {
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    display: flex;
    align-items: center;
    letter-spacing: 1.5px;
    color: #4D4D4D;
    padding-top: 2px;
}

.card_bloc_slider a {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    /* display: flex; */
    text-align: right;
    letter-spacing: 0.18px;
    text-decoration-line: underline;
    color: #1A1A1A;
    text-align: right;
    display: block;
    padding-top: 5px;
}

.card_bloc_slider button {
    background: #EC7700;
    border-radius: 5px;
    width: 100%;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    transition: all 0.3s ease-in;
    margin: 10px 0px;
}

.card_bloc_slider button:focus,
.card_bloc_slider button[data-focus] {

    box-shadow: none !important;
}

.card_bloc_slider button:hover {
    color: #EC7700;
    background: #fcfcfc;

}

.cstm_slider_pd .slick-dots li button {
    width: 16px !important;
    height: 16px !important;
}

.cstm_slider_pd .slick-dots li button:before {

    font-size: 16px !important;
    opacity: 1 !important;
    color: #f2f2f2 !important;
}

.cstm_slider_pd .slick-dots li.slick-active button:before {
    color: #EC7700 !important;
}

.wd_60_pd_slider {
    max-width: 60%;
    width: 100%;
    background-color: #f2f2f2;
    overflow: hidden;
}

.wd_40_pd_details {

    max-width: 40%;
    width: 100%;
    padding: 57px 40px 30px;

    max-width: 40%;
    width: 100%;
    padding: 57px 40px 30px;
    position: relative;

}


.main_slider_block_prduct {
    height: 554px;
    background: #F2F2F2;
    position: relative;
}

.Img_block_pd_slide_prduct img {
    /* top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
    position: absolute;
}

.zoom-root-container img + div + div {
    z-index: 33 !important;
    width: 1460px !important;
    height: 1186px !important;
    left: 0 !important;
    margin-left: 0 !important;
}

.slick_dt_pd_main .slick-dots {
    bottom: 20px !important;

}

.right_arrow_pd_cp {
    /*right: 225px !important;*/
    top: 50% !important;
    background-color: transparent !important;
    box-shadow: none !important;
}


.slick_dt_pd_main .slick-dots li button:before {
    font-size: 16px !important;
    opacity: 1 !important;
    color: #fff !important;
}

.right_arrow_pd_cp svg {
    fill: #C4C4C4;
}

.left_arrow_pd_cp svg {
    fill: #C4C4C4;
}

.main_block_slider {
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%) !important;
    display: flex;
    margin: 40px 101px 0px;
    /* overflow: hidden; */
}

.cstm_pslider {
    padding: 0px;
    padding-inline-start: 0rem !important;
    padding-inline-end: 0rem !important;
}

.cstm_pslider .mini_container_mt {
    padding: 0px;
    padding-inline-start: 0rem !important;
    padding-inline-end: 0rem !important;
}

.cstm_pslider .Logo_icons_full_width {
    padding: 0px;
}

.slick_dt_pd_main {
    background-color: #f2f2f2;
}

.capliry_p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    text-align: left;
    letter-spacing: 0.4px;

    /* Black 90 (Text) */

    color: #1A1A1A;
}

.capliry_h2 {
    font-weight: 700;
    font-size: 34px !important;
    line-height: 36px !important;
    /* identical to box height, or 106% */

    text-align: left;

    /* Drillcut Purple */

    color: #592C82;

}

.capliry_span {

    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    /* or 120% */

    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    /* or 120% */
    margin-top: 5px;


    display: flex;
    align-items: center;
    letter-spacing: 1.5px;

    /* Black 70 */

    color: #4D4D4D;
    padding-top: 5px;
}

.flx_bx_stp .css-k008qs {

    gap: 20px;
}

.brand__page {
    max-width: 1490px;
    margin-bottom: 100px;
}

.brand__page .css-1wkijx5 {

    grid-gap: 23px 20px !important;
    margin-top: 0px !important;
}

.brand__page p {
    font-size: 14px;
    line-height: 18px;
    padding: 0px 15px 20px 15px !important;
    height: 55px;
}

.content__block__brandpage {
    max-width: 850px !important;
    margin-top: 75px !important;
    margin-bottom: 75px !important;
}

.capliry_span_2 {

    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    /* or 120% */

    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    /* or 120% */


    display: flex;
    align-items: center;
    letter-spacing: 1.5px;

    /* Black 70 */

    color: #4D4D4D;
    padding-top: 7px;
}

.capliry_h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 24px;
    /* identical to box height, or 80% */

    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.18px;
    padding-top: 9px;
    color: #1A1A1A;
}

.stock_data {
    position: relative;
    width: 100%;
    margin: 10px 0px 15px;
}

.stock_data select {
    background: #F2F2F2;
    border-radius: 2px;
    border: none;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;

    /* display: flex; */
    /* align-items: center; */
    letter-spacing: 1.5px;
    color: #1A1A1A;
    padding-left: 37px;
    height: 32px;
    position: relative;
}

.stock_data select:focus,
.stock_data select[data-focus] {
    z-index: unset;
    border-color: transparent !important;
    box-shadow: none !important;
}

.stock_data img {
    position: absolute;
    z-index: 8;
    top: 8.3px;
    left: 9px;
}

.capliry_p_1 {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #000000;
    text-align: left;
    margin-bottom: 37px;
}

.select_size {
    background: #FFFFFF !important;
    border: 1px solid #C4C4C4 !important;
    border-radius: 5px !important;
    font-weight: 400;
    font-size: 14px !important;
    line-height: 16px !important;
    /* identical to box height, or 100% */


    letter-spacing: 0.1px;
    height: 32px;
    color: #000000;


}

.select_size:focus,
.select_size[data-focus] {
    z-index: unset;
    /* border-color: transparent!important; */
    box-shadow: none !important;
}

.qty_flx {
    display: flex;
    justify-content: space-between;
    margin: 20px 0px;
}

.qty_flx label {
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    /* identical to box height, or 120% */


    text-align: left;
    letter-spacing: 1.5px;

    color: #000000;
}

.qty_flx input {
    background: #F2F2F2;
    border-radius: 5px;
    height: 40px;
    max-width: 80px;
    width: 100%;
    display: block;
    text-align: center
}

.qty_flx .chakra-form-control {
    width: auto !important;
    margin-right: 14px;
}

.qty_flx button:focus,
.qty_flx button[data-focus] {
    z-index: unset;
    border-color: transparent !important;
    box-shadow: none !important;
}

.qty_flx input:focus,
.qty_flx input[data-focus] {
    z-index: unset;
    border-color: transparent !important;
    box-shadow: none !important;
}

.qty_flx button {
    background: #EC7700;
    border-radius: 5px;
    display: block;
    transition: all 0.3s ease-in;
    width: 100%;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    /* or 373% */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    margin-top: 20px;
}

.qty_flx button:hover {
    transition: all 0.3s ease-in;
    background: #F2F2F2;
    color: #EC7700;
}

.spec_dt {

    display: flex;
    justify-content: space-between;

    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 10px;

}

.spec_dt a {
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    /* identical to box height, or 373% */


    text-decoration-line: underline;

    /* Drillcut Purple */

    color: #592C82;

}

.mb_pd_slider {
    margin-bottom: 70px;
}

.related_blck_slider {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    /* identical to box height, or 100% */

    text-align: center;
    letter-spacing: 0.18px;

    /* Black 90 (Text) */

    color: #1A1A1A;
    padding-bottom: 5px;
}

.related_blck_slider_p {

    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */

    text-align: center;
    letter-spacing: 0.1px;
    text-transform: uppercase;

    /* Black 90 (Text) */

    color: #1A1A1A;
}

.flxe_accrdion {
    display: flex;
    justify-content: flex-start;
}

.first_bx_accrdion {
    max-width: 210px;
    width: 33%;
}

.first_bx_accrdion span {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    color: #000000;
    opacity: 0.5;
    display: block;
    margin: 2px 0 10px;
}

.first_bx_accrdion h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    padding: 0px;
    color: #000000;
    margin-bottom: 26px;
    margin-top: 15px;

}

.first_bx_accrdion p,
.first_bx_accrdion h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    padding: 0px;
    color: #000000;
    padding-bottom: 10px;

}

.second_bx_accrdion span {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    display: block;
    color: #000000;
    opacity: 0.5;
    padding-bottom: 5px;;
}

.second_bx_accrdion h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    padding: 0px;
    color: #000000;
    margin-top: 15px;

}

.sixTmm {
    margin-top: 0px !important;
}

.accrdion_box {
    border: 1px solid #C4C4C4;
}

.accrdion_box .button {
    border: 1px solid #C4C4C4;
}

.accrdion_box {
    display: block;
    width: 50%;
}

.pd_bm_main_blck {
    margin-bottom: 50px;
}

.model_pd {
    max-width: 570px !important;
    background-color: transparent !important;
    box-shadow: none !important;
}

.model_pd .ct_acc {
    font-weight: 700;
    font-size: 15px;
    align-items: center;
    display: block;
    text-align: center !important;
    color: #EC7700;
    transition: all 0.3s ease-in;
}

.list_detail {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    padding-bottom: 27px;
}

.list_detail li {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #000000;
    text-align: left;
}

.list_detail span {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #000000;
    text-align: left;
}

.bundle_tb td {
    height: 100px !important;
}

.cstm_arrow_lt .slick_arrows_custom_logo {

    top: 43% !important;
}

.bundle_scond_tbl {
    margin-top: 26px;
}

.bundle_scond_tbl td {
    padding-top: 15px !important;
    padding-bottom: 11px !important;

}

.bundle_scond_tbl button {
    background: #EC7700;
    border-radius: 5px;
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    line-height: 56px;
    /* display: flex; */
    max-width: 152px;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    width: 100%;
}

.bundle_scond_tbl button:hover {
    color: #000;
}

.bundle_scond_tbl button:focus,
.bundle_scond_tbl button[data-focus] {
    box-shadow: none !important;
    border-color: #C4C4C4 !important;
}

.bundle_tbl_bx {
    margin: 40px 180px 66px;

}

.last_bundleTbl-1 {
    border-bottom: 1px solid #C4C4C4;
    margin: 0px 100px 0px;
}

.table_grid_mob {
    display: flex;
    justify-content: space-around;
    border: 1px solid #C4C4C4;

}

.hd_mb_bndle {
    display: none;
}

.left_arrow_pd_cp {
    /*left: 225px !important;*/
    top: 50% !important;
    background-color: transparent !important;
    box-shadow: none !important;
}

.table_grid_mob ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;

}

.table_grid_mob_2 {
    max-width: 33%;
    width: 100%;
}

.table_grid_mob_1 {
    max-width: 33%;
    width: 100%;
}

.table_grid_mob_1 span {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */

    letter-spacing: 0.1px;
    position: relative;
    bottom: 2px;

    color: #000000;

}

.table_grid_mob_2 li {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */
    height: 70px;
    letter-spacing: 0.1px;
    border-bottom: 1px solid #C4C4C4;
    color: #000000;
    padding: 10px;
}

.table_grid_mob_1 li {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */
    height: 70px;
    border-bottom: 1px solid #C4C4C4;
    letter-spacing: 0.1px;
    text-align: left;
    color: #000000;
    padding: 10px;
}

.table_grid_mob_2 button {
    font-weight: 700;
    font-size: 12px;
    line-height: 56px;
    /* display: flex; */
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background-color: #ec7700;
    margin-top: 6px;
}

.cart_container {
    max-width: 1100px !important;
    width: 100% !important;
    margin: 0px auto;
    display: block;
}

.prduct_image {
    /*background-color: #f2f2f2;*/
    display: inline-block;
    height: auto;
    max-width: 85px;
    width: 100%;
    position: relative;
    /* border: 2px solid #000; */
    top: -5px;
}

.number_bmt {
    font-weight: 700;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */


    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;

}

.pd_name_bmt {

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */

    letter-spacing: 0.1px;

    color: #000000;

}

.cart_container td {
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */

    border-bottom: 1px solid #C4C4C4;
    letter-spacing: 0.1px;

    color: #000000;
}

.prduct_image img {
    max-width: 86px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    border: 3px solid #f2f2f2;
}


.min-add-button {
    max-width: 80px;
    margin: 20px auto;
}

.min-add-button a {
    background: #aaa;
    color: #fff;
    border: 0px;
    padding: 11.1px 10px;
    transition: all 0.3s ease;
    background: #F2F2F2;


}

.minusbtn {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    height: 40px;
}

.min-add-button input {
    background: #F2F2F2;
    border: none;

}

.plusbtn {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    height: 40px;
}

.minusbtn svg {
    color: #000;
}

.plusbtn svg {
    color: #000;
}

.min-add-button a:hover {
    background: #f3f3f3;
}

.min-add-button input {
    height: 37px;
    text-align: center;
    font-weight: 700;
    padding: 18.8px 20px 17.6px;
    color: #000;
    border-left: 1px solid #C4C4C4;
    border-right: 1px solid #C4C4C4;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.18px
}

.cart_container th {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */
    border-bottom: 1px solid #C4C4C4;
    height: 50px;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;

}


.min-add-button input:focus,
.min-add-button input[data-focus] {
    box-shadow: none !important;
    border-color: #C4C4C4 !important;
}

.cart_container table {
    border: 1px solid #C4C4C4;
}

.cart_container h2 {
    font-weight: 700;
    font-size: 54px;
    line-height: 54px;
    /* display: flex; */
    align-items: center;
    letter-spacing: -0.5px;
    color: #000000;
    padding: 62px 0px;
}

img.image-360 {
    padding: 3px 0px;
    height: 63px;
    object-fit: cover;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 170px;
    max-height: 63px;
}

.chakra-select .option[value*="hvac"] {
    text-transform: uppercase;
}

.cart_dt_pp {
    justify-content: end;
}

.price_dt_bill {
    margin-top: 30px;
    float: none;
}

.price_dt_bill li:last-child {

    margin-bottom: 36px;
}

.checkOut_bt_cart {
    background: #EC7700 !important;
    border-radius: 5px !important;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;

    color: #FFFFFF !important;
    width: 100% !important;
    height: 64px !important;
}

.billing_details {
    max-width: 440px;
    width: 100%;

}

.flx_spc_betwen {
    justify-content: space-between;
}

.checkOut_bt_cart:hover {
    background: #F2F2F2 !important;
    color: #000 !important;;
}

.checkOut_bt_cart:focus,
.checkOut_bt_cart[data-focus] {
    box-shadow: none !important;
    border-color: none !important;
}

.checkOut_bt_cart_shoppig:focus,
.checkOut_bt_cart_shoppig[data-focus] {
    box-shadow: none !important;
    border-color: none !important;
}

.checkOut_bt_cart_shoppig:hover {
    background: #EC7700 !important;
    color: #fff !important;;
}

.chakra-modal__footer .css-2kyq28 {
    background: #ec7700 !important;
    color: #fff;
}

.checkOut_bt_cart_shoppig {
    background: #F2F2F2 !important;
    border-radius: 5px !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    line-height: 56px !important;
    /* or 373% */
    margin-top: 10px;

    margin-bottom: 134px;

    color: #000000;
    height: 32px !important;;
    width: 100% !important;
}

.flx_bx_mob_ct {
    display: flex;

}

.btnmob_pls_minus {
    justify-content: space-between;
    margin-bottom: 10px;
    border-bottom: 1px solid #C4C4C4;
    margin-bottom: 20px;
    padding-bottom: 23px;
}

.mob_img_bx {
    background-color: #f2f2f2;

    height: 70px;
    max-width: 85px;
    width: 100%;
    position: relative;
}

.mob_img_bx img {
    max-width: 44px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
}

.mob_pd_nm {
    text-align: left;
    padding-left: 20px;
    padding-top: 15px;
}

.mob_pd_nm .pd_name_bmt {
    display: block;
}

.hd_cart_mb_hd_btn {
    display: block;
}


.btnmob_pls_minus .number_bmt {
    font-weight: 700;
    font-size: 18px;
    text-align: right;
    letter-spacing: 0.1px;
    color: #000000;
    display: block;

}

.number_unit_price {
    font-weight: 400;
    font-size: 10px;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #4D4D4D;
    display: block;
    padding: 0px;
}

.btnmob_pls_minus .min-add-button {
    margin: 0px;
    margin-top: 15px;
}

.btnmob_pls_minus .min-add-button input {

    padding: 21.1px 20px 19.2px;
}

.price_md_test {
    text-align: right;

    margin-top: 22px;

    padding-left: 30px;
}

.dlt_mb_crown img {
    padding-top: 22px;
}

.hd_desktop_btn {
    display: none !important;
}

.hd_md_dtps {
    display: none;
}

.new_roles ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    display: flex;
}

.new_roles li {
    margin-right: 20px;
}

.new_roles {
    margin: 0px 34px;
}

.rl_dets {
    margin: 0px 35px 35px;
    padding-bottom: 25px;
    border-bottom: 1px solid #C4C4C4;
}

.edit_roles {
    margin: 0px 34px;
}

.rl_dets h2 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 120% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;

    color: #000000;

    padding-top: 16px;
    padding-bottom: 18px;
}

.rl_dets input {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
    height: 40px;
    max-width: 286px;
    width: 100%;
    display: block;
}

.rl_dets label {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    /* identical to box height, or 133% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;

}

.edit_roles h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
    padding-bottom: 26px;
}

.edit_roles ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    display: flex;
}

.edit_roles li {
    font-weight: 700;
    font-size: 14px;
    line-height: 13px;
    /* or 93% */

    padding-right: 45px;
    letter-spacing: 0.25px;

    /* Orange */

    color: #EC7700;
}

.manage_roles1 {

    /* Orange */

    color: #EC7700;
}

.manage_roles2 {


    color: #C4C4C4 !important;

}

.edit_roles tr:nth-child(even) {
    background-color: #f2f2f2;
}

.manage_role3 {
    opacity: 0.5 !important;
    color: #C4C4C4 !important;
}

.bg_strip_btn_save {
    background: #f2f2f2;
    /* margin-top: 250px; */
    margin: 250px 34px 53px;
    background: #f2f2f2;
    /* margin-top: 250px; */
    padding: 14px 20px;

    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;

}

.bg_color_acrhove a,
.bg_strip_btn_save a {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */
    padding: 3px 0px;
    display: flex;
    margin-right: 37px;
    align-items: center;
    letter-spacing: 1.25px;
    text-transform: uppercase;

    /* Orange */

    color: #EC7700;

}

.bg_strip_btn_save button {
    background: #EC7700;
    border-radius: 5px;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    /* or 373% */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
}

button.bg_strip_btn_long_text {
    white-space: pre-line;
    overflow: hidden;
    text-overflow: ellipsis;
}

.bg_strip_btn_long_text_span {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.bg_strip_btn_save button:hover {
    background-color: #592C82 !important;
}

.box_wd6hdpx {
    max-width: 600px;
    width: 100%;
}

.box_form_blck {
    margin: 0px 34px;
    border-bottom: 1px solid #C4C4C4;
}

.box_form_blck .form_controll {
    padding: 0px;
    padding-bottom: 20px;

}

.box_form_blck h2 {

    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
    padding: 15px 0px 20px;

}

.box_form_blck label {
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    padding-top: 1px;
}

.box_form_blck .chakra-input {
    background: #FFFFFF;
    /*border: 1px solid #C4C4C4;*/
    border-radius: 5px;
}

.box_form_blck input:focus,
.box_form_blck input[data-focus] {
    /*border: 1px solid #C4C4C4;*/
    box-shadow: none;
}

.pd-tp35 h2 {
    padding-top: 35px;
}

.box_form_blck button:focus,
.box_form_blck button[data-focus] {
    border: none;
    box-shadow: none;
}

.home_page_main_slider_mt .slick-dots,
.slick_slider_custom_arrows {
    padding-left: 0px;
    top:unset;
    bottom: 20px !important;
    /* width: 100%; */
    /* left: 50%; */
    /* top: 50%; */
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.slick_slider_custom_arrow {
    position: inherit !important;
}

.slick_left_arrow {
    left: 0;
    right: 0;
}

.slick_slider_custom_arrows {
    max-width: 0px;
    /* z-index: 99999; */
}

.slick_right_arrow {
    left: 0;
}

.slick_right_arrow {
    /* left: 28%; */
    right: 0;
}

.box_form_blck button {
    background: #EC7700;
    border-radius: 5px;
    font-weight: 700;
    font-size: 12px;
    line-height: 56px;
    /* identical to box height, or 467% */
    transition: all 0.3s ease-in;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    height: 24px;
    margin-top: 12px;
}

.box_form_blck button:hover {
    background: #f2f2f2;
    color: #EC7700;
    transition: all 0.3s ease-in;
}

.box_form_blck p {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    text-align: left;
    align-items: center;
    letter-spacing: 0.4px;
    color: #000000;
    display: block;
    position: relative;
    top: -10px;
}

.rm_bd_ud {
    border-bottom: none;
    /* padding-bottom:10px; */
}

.pd_tp_bm_tc {
    margin: 30px 34px 53px !important;
}

.blck-srtdt img {
    float: left;
    margin-right: 14px;
    position: relative;
    top: 3px;
}

.css-zipzvv .option_table .css-womqfz {
    /*max-width: 300px;*/
    /*right: 30px;*/
    /*left: 30px;*/
    /*width: 100%;*/
    /*left: 50%;*/
    /*right: 0;*/
    /*top: auto;*/


    /*transform: translate(-50%, -0%);*/
}

.blck-srtdt {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */


    align-items: center;
    letter-spacing: 0.25px;

    color: #000000;
}

.srch_filter {
    display: flex;
    justify-content: space-between;
    margin: 0px 20px;
    border-top: 1px solid #C4C4C4;
    padding-top: 18px;
    align-items: center;
}

.srch_filter input {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */

    display: flex;
    align-items: center;
    letter-spacing: 0.1px;

    color: #000000;

}

.srch_filter select {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */

    display: flex;
    align-items: center;
    letter-spacing: 0.1px;

    color: #000000;

}

.srch_filter input:focus,
.srch_filter input[data-focus] {
    border: 1px solid #C4C4C4;
    box-shadow: none;
}

.css-zipzvv .chakra-table .css-xumdn4:first-child {
    padding: 10px 10px 10px 25px;
    /* width: 300px;*/
}

.srch_filter button {
    background: #EC7700;
    border-radius: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    /* or 373% */
    transition: all 0.3s ease-in;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    margin-top: 9px;
    padding: 1px 33px;


}

.srch_filter button:hover {
    transition: all 0.3s ease-in;
    background: #f2f2f2;
    color: #EC7700;
}

.srch_filter button:focus,
.srch_filter button[data-focus] {
    border: none;
    box-shadow: none;
}

.srch_filter .form_controll {
    padding: 0px;
}

.srch_filter label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;
}

.fgt_pw_btn {
    margin: 0px 0px 17px !important;
}

.fg_pw_blck {
    height: 635px !important;
}

.pn_btn {
    background-color: #EC7700 !important;
    border-radius: 5px !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    line-height: 56px !important;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    margin-top: 5px;
    transition: all 0.3s ease-in;
}

.btPd_voic {
    margin: 20px 35px 10px !important;
}

.pn_btn:focus,
.pn_btn[data-focus] {
    border: none;
    box-shadow: none;
}

.pn_btn:hover {
    background: #fff !important;
    color: #EC7700;
    transition: all 0.3s ease-in;
}

.cstm_invoices {
    margin: 0px 35px;
}

.fx_bx_vic {
    max-width: 230px;
    width: 100%;
}

.fx_bx_vic li {
    display: flex;
    justify-content: space-between;
}

.ct_comp {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    letter-spacing: 0.25px;

    color: #000000;

}

.ct_comp1 {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    text-align: right;
    letter-spacing: 0.25px;

    color: #000000;

}

.ct_invoice {
    height: 85px !important;
    background: #F7F7F7;
    display: flex;
    justify-content: space-between;
}

.ct_outstading {
    font-weight: 700 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: 0.25px !important;
    padding: 0px !important;
    text-align: right !important;
    display: block !important;
    padding-bottom: 5px !important;
    color: #000000 !important;
}

.ct_outstading_1 {
    font-weight: 700 !important;
    font-size: 40px !important;
    line-height: 20px !important;
    /* identical to box height, or 50% */


    letter-spacing: 0.25px !important;

    color: #000000 !important;
}

.invoice_tble_cm {
    font-weight: 400 !important;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */


    letter-spacing: 0.1px;

    color: #000000;
}

.invoice_tble_cm_mn td {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    /* display: flex;
    align-items: center;
    text-align: center; */
    letter-spacing: 0.18px;

    /* Black 90 (Text) */

    color: #1A1A1A;
}

.invoice_tble_cm_mn {
    margin: 0px 35px;
}

.invoice_tble_cm_mn .option_table {
    margin-top: 12px;
    border-bottom: 1px solid #C4C4C4;
}

.invoice_dtTotal {
    margin-top: 32px;
}

.checkout_page_container {
    max-width: 900px !important;
    margin: 0px auto !important;
    width: 100% !important;
}

.check_heading {
    font-weight: 700;
    font-size: 54px;
    line-height: 54px;
    /* display: flex; */
    align-items: center;
    letter-spacing: -0.5px;
    color: #000000;
    text-align: left;
    padding: 61px 0px 56px;
}

.billing_details {
    /* display:flex;
    justify-content: space-between; */
}

.billing_details_1 {
    background: #E9EAEB;
    height: 40px;
    padding: 15px;
    width: 100%;
    display: block;
    margin: 0px auto;
    display: flex;
    position: relative;
    max-width: 440px;
    width: 100%;
    justify-content: space-between;
}

.flx_spc_betwen .css-0 {
    max-width: 425px;
    width: 100%;
}

.billing_details_1 h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #1A1A1A;
}

.billing_details_1 a {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* display: flex; */
    align-items: center;
    letter-spacing: 0.25px;
    text-decoration-line: underline;
    color: #F58220;
    display: block;
    margin-top: -5px;
}

.order_details_prduct {
    border: 1px solid #C4C4C4;
    background: #F6F6F6;
    padding: 0px 0px 0px;
}

.billing_details_1 .chakra-avatar {
    background-color: transparent !important;
    max-width: 16px;
    margin-top: -15px;
    padding-right: 0px;
    margin-left: 10px;
}

.billing_details ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    background: #F7F7F7;
    padding: 13px;
    text-align: left;
}

.billing_details li:first-of-type {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    letter-spacing: 0.25px;

    color: #000000;
}

.prduct_total ul {
    background-color: #fff !important;
    border: 1px solid #C4C4C4 !important;
    margin: 15px;
    padding: 0px;
}

.order_details_dt_ord_dt li {
    display: flex;
    justify-content: space-between;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 16px !important;
    /* identical to box height, or 114% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px !important;
    text-transform: uppercase;

    color: #000000;
}

.order_details_prduct {
    background: #F7F7F7 !important;
}

.order_details_dt_ord_dt li {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    padding: 15px 10px 15px;
    /* or 143% */
    text-align: left;
    border-bottom: 1px solid #C4C4C4;
    margin-bottom: 10px;

    letter-spacing: 0.25px;

    color: #000000;
    text-align: left;
    border-bottom: 1px solid #C4C4C4;
}

.order_details_dt_ord_dt img {
    max-width: 64px !important;
    width: 100%;
}

.mb_rm_tst {
    margin-bottom: 0px !important;
    padding: 5px 10px 13px !important;
    position: relative;
}

.mb_rm_tst .in_voice {
    position: absolute;
    left: 80px;
}

.flx_sp_bt span {
    text-transform: capitalize !important;
}

.sb_frm {
    padding: 0px 15px;
}

.sb_frm label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    padding-top: 30px;
}

.sb_frm input {
    width: 100%;
    display: block;
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
    position: relative;
    z-index: 1;
}

.sb_frm button {
    position: absolute;
    background: #EC7700;
    border-radius: 0px 5px 5px 0px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    /* or 373% */
    z-index: 2;
    right: 0px;
    bottom: 0px;
    padding: 0px 28px;
    color: #FFFFFF;
    transition: all .5s ease;
}

.sb_frm button:hover {
    background-color: #592C82 !important;
}

.sb_frm button:focus,
.sb_frm button[data-focus] {
    z-index: 1;

    box-shadow: none;;
}

.pm_tnw {
    padding: 0px 15px;
}

.pm_tnw p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    padding-top: 30px;
    padding-bottom: 11px;
}

.sb_frm input:focus,
.sb_frm input[data-focus] {
    z-index: 1;
    border: 1px solid #C4C4C4;
    box-shadow: none;;
}

.pm_tnw .chakra-radio__control:focus,
.pm_tnw .chakra-radio__control[data-focus] {
    box-shadow: none;
}

.pm_tnw .chakra-radio__control {

    height: 24px;
    background-color: #fff;
    width: 24px;
}

.pm_tnw .chakra-radio:last-child {
    margin-top: 20px;
}

.check_bx_blck {
    padding: 60px 15px 0px;

}

.det_checkt {
    margin-left: 120px;
}

.check_bx_blck .chakra-checkbox__control:focus,
.check_bx_blck .chakra-checkbox__control[data-focus] {
    box-shadow: none;
}

.pd_bm_bill_dt_pg {
    margin-bottom: 90px;
}

.check_bx_blck .chakra-checkbox__label {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;

    color: #000000;
}

.check_bx_blck .chakra-checkbox__control {
    width: 24px;
    height: 24px;
    background: #fff;
}

.check_bx_blck .chakra-checkbox:last-child {
    margin-top: 20px;
}

.check_bx_blck button {
    margin-top: 47px;
    background-color: #888;
    width: 100%;
    background: #EC7700;
    border-radius: 5px;
    color: #fff;
    height: 64px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    transition: all .5s ease;
}

.check_bx_blck button:hover {
    background-color: #592C82 !important;
    transition: all .5s ease;
}

.check_bx_blck img {
    width: 20px !important;
    height: 20px;
    object-fit: contain;
    margin-right: 10px;
}

.check_bx_blck p {
    display: flex;
    justify-content: center;

    padding: 30px 0px 60px;
    font-weight: 700;
    font-size: 14px;
    /* line-height: 56px; */
    /* identical to box height, or 400% */


    align-items: self-start;


    color: #000000;

}

.bg_color_acrhove {
    display: flex;
    align-self: center;
}

.searchDrillcutfilters {
    display: flex !important;
    justify-content: space-between;
}

.pm_tnw .chakra-radio__label {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;

    color: #000000;
}

.pd-btm-notes {
    margin-top: 22px;
}

.pd-btm-notes label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;
}

.form_dt_notes {
    padding: 0px 15px 15px 15px;
    background: #F7F7F7;
}

.form_dt_notes label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    padding: 14px 0px 5px;
    margin: 0px;

}

.form_dt_notes input {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
}

.form_dt_notes textarea {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
}

.form_dt_notes input:focus,
.form_dt_notes input[data-focus] {
    box-shadow: none !important;
    border-color: #C4C4C4 !important;
}

.form_dt_notes textarea:focus,
.form_dt_notes textarea[data-focus] {
    box-shadow: none !important;
    border-color: #C4C4C4 !important;
}

/* account information page css start  */
.acc_ctent_block {

    padding: 28px 35px 33px 35px;
}

.acc_ctent_block h2 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #1A1A1A;
    padding-bottom: 16px;
}

.account_info li span {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */
    float: left !important;

    letter-spacing: 0.25px;
    height: 70px;
    color: #000000;
}

.account_info li {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    letter-spacing: 0.25px;
    height: 70px;
    color: #000000;
}

.account_info li:last-child {
    height: 0px;
    padding-bottom: 30px;
}

.acc_ctent_block p {
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */

    text-align: left;
    letter-spacing: 0.5px;

    color: #000000;

}

.account_info a {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    letter-spacing: 0.25px;
    text-decoration-line: underline;

    /* Orange */

    color: #EC7700;

}

.account_info {
    height: auto;
    margin-bottom: 27px;
}

.address_info li {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    letter-spacing: 0.25px;

    color: #000000;
}

.address_info li span {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    letter-spacing: 0.25px;

    color: #000000;
}

.address_info {
    height: auto;
    padding-bottom: 17px;
}

.def_projct li {
    height: 50px;
}

.account_statment label {

    padding: 0px;
    margin: 0px;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
    padding-bottom: 10px;
}

.account_statment select {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    /* display: flex; */
    /* align-items: center; */
    letter-spacing: 0.1px;
    color: #000000;
    background-color: #fff;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
}

.acc_blnc_act {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    letter-spacing: 0.25px;

    color: #000000;

}

.bill_total {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #C4C4C4;
    padding-bottom: 8px;
}

.acc_blnc_total p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    letter-spacing: 0.25px;
    text-transform: uppercase;
    padding: 0px;
    color: #000000;
}

.acc_blnc_total p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    letter-spacing: 0.25px;
    text-transform: uppercase;

    color: #000000;

}

.acc_blnc_total_bll p {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    text-align: right;
    letter-spacing: 0.25px;

    color: #000000;
    padding: 0px;
}

.def_projct li:last-child {
    height: 0px;
    padding-bottom: 45px;
}

.acc_blnc_total_details {
    display: flex;
    justify-content: flex-end;
}

.acc_blnc_act {

    font-weight: 700 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: 0.25px !important;
    color: #000000 !important;
}

.acc_blnc_total_details ul {
    padding: 0px;
    list-style-type: none;
    margin: 0px;
    text-align: inherit;
    padding-top: 14px;
    padding-bottom: 15px;
}

.account_statment {
    height: auto;
    margin-bottom: 27px;
}

.acc_blnc_total_details li {
    display: flex;
    justify-content: space-between;
}

.dt_ttl_sm {
    display: block;
    padding: 0px;
    margin: 0px;
    padding-right: 17px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    letter-spacing: 0.25px;
    text-transform: uppercase;

    color: #000000;
}

.drill_table tr:nth-child(4) {
    background: rgb(242 242 242 / 50%);
}

.dt_ttl_sm_1 {

    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    text-align: right;
    letter-spacing: 0.25px;

    color: #000000;

    padding: 0px;
    display: block;
}

/* account information page css end  */
/* drill club page css start */
.drill_clb_bg {
    background: #F2F2F2;
    margin: 35px 35px 0px;
    padding: 28px 20px 20px;
}

.drill_block_1 h2 {
    font-size: 28px;
    color: #1A1A1A;
    text-align: left;
}

.drill_block_1 h2 span {
    font-weight: bolder;
}

.drill_block_1 h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */

    text-align: left;
    letter-spacing: 0.1px;
    text-transform: uppercase;

    /* Drillcut Purple */

    color: #592C82;
    padding-top: 10px;
}

.drill_block_1 h3 span {
    font-weight: 700;
    font-size: 40px;
    line-height: 24px;
    text-align: left;
    padding-right: 5px;

    letter-spacing: 0.15px;

    /* Drillcut Purple */

    color: #592C82;

}

.drill_block_1 p {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: #4D4D4D;
    padding-bottom: 16px;
    text-align: left;
    display: block;
    padding-top: 9px;
}

.drill_block_1 button {
    background: #EC7700;
    border-radius: 5px;
    color: #fff;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 40px;
    display: block;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    display: block;
    padding: 0px 28px;
    height: 48px;
    transition: all 0.3s ease-in;
}

.drill_block_1 button:hover {
    transition: all 0.3s ease-in;
    background: #592C82;

    color: #fff;
}

.drill_block_1 button:focus,
.drill_block_1 button[data-focus] {

    box-shadow: none !important;
}

.drill_block_1 a {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* display: flex; */
    align-items: center;
    letter-spacing: 0.25px;
    color: #F58220;
    /* padding-top: 28px; */
    display: block;
    padding-top: 18px;
}

.drill_block_1 {
    position: relative;
}

.drill_block_1:after {
    position: absolute;
    content: '';
    width: 1px;
    border-right: 1px solid #fff;
    height: 100%;
    right: -25px;
    top: 0px;
}

.drill_block_2 {
    padding-left: 60px;
}

.drill_block_2 {
    padding-left: 60px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.drill_block_3 p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */
    text-align: left;
    letter-spacing: 0.4px;

    color: #000000;

}

.drill_block_3 h2 {
    font-weight: 700;
    font-size: 34px;
    line-height: 36px;
    text-align: left;
    color: #000000;
    padding: 7px 0px 19px;
}

.project_br .md_lftd .chakra-accordion {
    display: none;
}

.drill_block_3 h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #000000;
    text-align: left;
}

.drill_block_3 h3 span {
    font-weight: bolder;

}

.drill_block_3 a {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    color: #F58220;
    margin-top: 47px;
}

.drill_block_4 ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    display: flex;
    justify-content: flex-end;
}

.drill_block_4 li {
    margin-left: 45px;

}

.drill_block_4 li img {
    margin: 0px auto;
}

.drill_block_4 li p {
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    padding-top: 8px;
    line-height: 12px;
    /* identical to box height, or 120% */

    display: flex;
    align-items: center;
    letter-spacing: 1.5px;
    transition: all 0.3s ease-in;
    color: #000000;
    margin-bottom: 50px;
}

.drill_block_4 li p:hover {
    transition: all 0.3s ease-in;
    font-weight: 700;

}

.drill_block_3 {
    max-width: 30%;
    width: 100%;
}

.drill_block_4 {
    max-width: 70%;
    width: 100%;
}

.pg_bar .css-150tos1 {
    background-color: #fff;
    max-width: 82%;
}

.pg_bar {
    position: relative;
}

.pg_bar span {
    position: absolute;
    right: 0px;
    top: 0px;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */

    display: flex;
    align-items: center;
    letter-spacing: 0.1px;
    text-transform: uppercase;

    color: #000000;

}

.drill_select_bx {
    background-color: transparent !important;
    border: none !important;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    display: flex;
    align-items: center;
    letter-spacing: 0.25px;

    color: #F58220;

}

.drill_select_bx {
    margin-top: 51px;
}

.drill_block_4 .chakra-select__wrapper {
    border: none;
    max-width: 170px;
    width: 100%;
    border: none;
}

.drill_block_4 .chakra-select__icon-wrapper {
    color: #F58220;
}

.drill_select_bx:focus,
.drill_select_bx[data-focus] {
    box-shadow: none !important;
}

.drill_table {
    /* padding:0px 35px; */
    width: 100%;
}

.drill_table tr:nth-child(2n) {
    background: rgb(242 242 242 / 50%);
}

.drill_table td {

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 7px;
    /* or 150% */

    letter-spacing: 0.25px;

    color: #000000;

}

.md_lftd {
    margin: 0px 35px;
}

.pr_drill {
    font-weight: 700 !important;
    font-size: 14px;
    line-height: 21px;
    /* or 150% */

    letter-spacing: 0.25px;

    color: #000000;
}

.modal_dataDrill_cbt {
    height: auto;
    margin: 0px auto;
    display: block;
    position: absolute;
    /* text-align: center; */
    left: 50%;
    right: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 1010px;


    background: #FFFFFF;
}

.modal_dataDrill_cbt h3 {
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    /* display: flex; */
    /* align-items: center; */
    letter-spacing: 0.18px;
    color: #1A1A1A;
    text-align: center;
    padding: 65px 0px 25px;
}

.modal_dataDrill_cbt .chakra-accordion__button {
    background: #F2F2F2;
    /* Keyline */
    display: flex;
    align-items: center;
    height: 64px;
    border-top: 1px solid #C4C4C4;
    border-left: 1px solid #C4C4C4;
    border-right: 1px solid #C4C4C4;
}

.whle_modal .chakra-modal__close-btn {
    right: -344px;
    position: absolute;
    z-index: 9;
}

/* drill club page css end */
/* drill club statment page css start */
.flx_bx_drill_statment {
    display: flex;
    justify-content: space-between;
    margin: 35px 35px 0px;
}

.drill_stment_brder:after {
    top: -13px !important;

}

.flx_bx_option_statment select {

    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
    letter-spacing: 0.25px;
    max-width: 100%;
    width: 182px;
    height: 40px;
    color: #000000;
}

.flx_bx_option_statment select:focus,
.flx_bx_option_statment select[data-focus] {
    box-shadow: none;
    border: 1px solid #C4C4C4;
}

.acct_statment h2 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 120% */

    padding-top: 10px;
    letter-spacing: 0.15px;

    color: #000000;
}

.price_tl_pr_1 {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    /* identical to box height, or 167% */

    display: flex;
    align-items: center;
    text-transform: uppercase;

    color: #000000;
}

.price_tl_pr_2 {

    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    text-align: right;
    text-align: right;
    letter-spacing: 0.15px;
    display: inline-block;
    width: 150px;
    color: #000000;
}

.pd_lf_stment {
    float: none;
}

.pd_lf_stment li:last-child {
    margin-top: 10px;
    padding-top: 7px;
    border-top: 1px solid #C4C4C4;
    margin-bottom: 0px;
}

.poingt_spnt {
    font-weight: 700;
    font-size: 18px;
}

.acct_statment .price_dt_summry {
    margin-top: 31px !important;
    margin-inline-start: 0em !important;
}

/* drill club statment page css start */
/* drill club web page css started */
.drill_club_web_ct {
    margin: 0px;
    padding: 0px;
    padding-inline-start: 0rem !important;
    padding-inline-end: 0rem !important;
}

.dril_club_wb {
    background: linear-gradient(105.17deg, #0094B8 0.56%, #5C2870 97.85%);
    background: linear-gradient(105.17deg, #0094B8 0.56%, #5C2870 97.85%);
    width: 35.2%;
    padding: 175px 0px;
}

.bg_banner_web {
    display: flex;
    justify-content: space-between;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
    background-position: right;
    background-repeat: no-repeat;
    background-size: cover;
}

.dril_club_wb p {
    font-weight: 700;
    font-size: 53px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #FFFFFF;
    text-align: center;
}

.dril_club_wb img {
    display: block;
    margin-bottom: 21px;
}

.blck_web_1 h2 {
    font-weight: 700;
    font-size: 34px;
    line-height: 36px;
    /* display: flex; */
    align-items: center;
    text-align: center;
    color: #592C82;
    text-align: center;
    display: block;
    padding: 60px 0px 30px;
}

.blck_web_1 p {
    max-width: 900px;
    width: 100%;
    text-align: center;
    margin: 0px auto;
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.5px;
    color: #000000;
}

.blck_web_2 {
    display: flex;
    justify-content: center;
    text-align: center;
    width: 100%;
    max-width: 800px;
    margin: 0px auto;
}

.blck_web_2_1 {

    width: 100%;
    padding: 0px 25px;
    margin-top: 45px;
}

.blck_web_2_1 img {
    margin: 0px auto;
    display: block;
    text-align: center;
    margin-bottom: 18px;
}

.blck_web_2_1 p {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.1px;

    /* Black 90 (Text) */

    color: #1A1A1A;
    padding-bottom: 88px;
}

.blck_web_jon_dril_clb {
    background: linear-gradient(105.17deg, #0094B8 0.56%, #5C2870 97.85%);
    padding: 65px 0px 60px;
    max-width: 1130px;
    margin: 0px auto;
    position: relative;
}

.blck_web_jon_dril_clb h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #FFFFFF;
}

.ct_img_rill {
    display: flex;
    justify-content: center;
    align-items: baseline;
}

.ct_img_rill img {
    margin-left: 10px;
}

.blck_web_jon_dril_clb button {
    background: #BDD635;
    border-radius: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 60px;
    text-align: center;
    color: #592C82;
    padding: 26px 80px;
    /* height: 26px; */
    text-transform: uppercase;
    transition: all .5s ease;
}

.blck_web_jon_dril_clb button:hover {
    background-color: #FFF;
    color: #1A1A1A;

}

.blck_web_jon_dril_clb button:focus,
.blck_web_jon_dril_clb button[data-focus] {
    box-shadow: none;
}

.blck_web_jon_dril_clb p {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.15px;
    color: #FFFFFF;
    padding: 30px 0px 20px;
}

.block_left_rill1 {
    max-width: 410px;
    width: 100%;
}

.block_left_rill1 h4 {
    font-weight: 700;
    font-size: 34px;
    line-height: 36px;
    /* display: flex; */
    /* align-items: center; */
    color: #592C82;
    text-align: left;

}

.block_left_rill2 {
    max-width: 450px;
    width: 100%;
}

.block_left_rill2 p {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #000000;
    text-align: left;

}

.cntnt_blck_wrk_grw {
    justify-content: space-between;
    max-width: 900px;
    margin: 0px auto;
    padding: 72px 0px 83px;
}

.explore-the-rewards {
    justify-content: space-between;
    max-width: 900px;
    margin: 0px auto;
}

.explore-the-rewards span {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */

    text-align: center;
    letter-spacing: 0.1px;
    text-transform: uppercase;

    /* Black 90 (Text) */

    color: #1A1A1A;
}

.explore-the-rewards h5 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    /* identical to box height, or 100% */

    text-align: center;
    letter-spacing: 0.18px;

    /* Black 90 (Text) */
    padding-top: 5px;
    color: #1A1A1A;
}

.explore-the-rewards p {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */

    text-align: center;
    letter-spacing: 0.5px;
    padding: 20px 0px;
    color: #000000;


}

.wd_block {
    max-width: 900px;
    width: 100%;
    margin: 0px auto;

    border: 1px solid #C4C4C4;
}

.wd_block button {
    background: #F2F2F2;
    border: none;

    border-bottom: 1px solid #C4C4C4;
    height: 64px;
}

.wd_block button:focus,
.wd_block button[data-focus] {
    box-shadow: none;
}

.points_block {
    max-width: 900px;
    width: 100%;
    margin: 0px auto;
}

.pt_blcks_jc {
    justify-content: space-between;
}

.points_block p {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */

    letter-spacing: 0.5px;

    color: #FFFFFF;
}

.content_block_drill1 {
    background: #0094B8;
    max-width: 440px;
    padding: 50px 30px;
    color: #fff;
    text-align: left;
}

.content_block_drill2 {
    background: #592C82;
    padding: 50px 30px;
    color: #fff;
    text-align: left;
    max-width: 440px;
}

.content_block_drill1 h6 {
    font-style: normal;
    font-weight: 700;
    font-size: 34px;
    line-height: 36px;
    /* or 106% */

    padding-bottom: 15px;
    color: #FFFFFF;
}

.content_block_drill2 h6 {
    font-style: normal;
    font-weight: 700;
    font-size: 34px;
    line-height: 36px;
    /* or 106% */

    padding-bottom: 15px;
    color: #FFFFFF;
}

.content_block_drill1 span {
    font-weight: 700;
}

.content_block_drill2 span {
    font-weight: 700;
}

.main_block_sp_offer {
    border: 20px solid #F2F2F2;
    max-width: 900px;
    margin: 0px auto;
    margin-top: 60px;
    margin-bottom: 20px;
    padding: 25px 35px;
    position: relative;
}

.main_block_sp_offer h6 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    position: relative;
    letter-spacing: 0.15px;
    color: #1477AF;
    text-align: left;
    padding-bottom: 40px;
}

.main_block_sp_offer h6:before {
    position: absolute;
    content: '';
    height: 1px;
    border-bottom: 1px solid #C4C4C4;
    width: 560px;
    bottom: 20px;
}

.main_block_sp_offer span {
    color: #EC7700;
}

.cls_ul_li_rill_clb ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
}

.cls_ul_li_rill_clb li {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    letter-spacing: 0.5px;
    color: #1477AF;
    padding-right: 113px;

}

.ribbon-content p {
    font-weight: 700;
    font-size: 33px;
    line-height: 39px;
    /* display: flex; */
    /* align-items: center; */
    text-align: center;
    letter-spacing: 0.15px;
    color: #FFFFFF;
    text-shadow: 2px 2px 0px rgb(0 0 0 / 25%);
    padding-top: 35px;
}

.overlay-ribbon {
    position: absolute;
    max-width: 223px;
    width: 100%;
    height: 232px;
    z-index: 9999;
    top: -20px;
    right: 2%;
    /* background: rgb(0 148 184 / 75%); */
    padding: 5px 0;
    background: linear-gradient(105.17deg, #0094B8 0.56%, #5C2870 97.85%);
    /* box-shadow: -5px 21px 28px -4px rgb(0 0 0 / 43%); */
    /* border-radius: 8px; */
    animation: slidein 3s ease-in-out forwards;
}

.overlay-ribbon:before {
    content: "";
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 223px;
    border-bottom: 100px solid #fff;
    border-top: 100px solid transparent;
    border-left: 112px solid transparent;
    border-right: 112px solid transparent;
    z-index: 997;
}

.overlay-ribbon:after {
    content: "";
    position: absolute;
    bottom: -7em;
    right: 0;
    width: 0;
    height: 0;
    border-top: 7em solid rgb(0 148 184 / 75%);
    border-left: 7em solid transparent;
    z-index: 998;
    display: none;
}

.points_block {
    margin-bottom: 50px;
}

.pd_bmrill {
    margin-bottom: 107px;
}

.cnter_block_rillclb {
    justify-content: center;
    border: 1px solid #C4C4C4;
}

.block_1_rill_clb {
    background: #F2F2F2;
    max-width: 180px;
    width: 100%;
    max-height: 359px;
}

.tiers h6 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.18px;
    color: #1A1A1A;
    padding: 70px 0px 23px;
}

.tiers {
    max-width: 900px;
    margin: 0px auto;
}

.block_1_rill_clb .members_dt {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    position: relative;
    padding-bottom: 35px;
}

.block_1_rill_clb ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    padding-left: 11px;
    padding-top: 56px;
    padding-bottom: 133px;
}

.block_1_rill_clb .members_dt:after {
    position: absolute;
    content: '';
    height: 1px;
    width: 150px;
    border-bottom: 1px solid #C4C4C4;
    bottom: 17px;
}

.range_txt {
    font-weight: 700;
    font-size: 25px;
    line-height: 34px;
    padding-top: 18px;
    text-align: left;
    text-transform: uppercase;
    letter-spacing: 0.15px;
    color: #F58220;
    padding-bottom: 20px;
}

.ct_suptd {
    font-weight: 700;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */
    text-align: left;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;
    padding-bottom: 10px;
    display: block;
    opacity: 0.5;
}

.cat_spt {
    font-style: normal;
    font-weight: 700;
    font-size: 25px;
    line-height: 16px;
    /* identical to box height, or 64% */


    letter-spacing: 0.15px;

    text-align: left;

    color: #1A1A1A;
}

.block_2_rill_clb .members_dt {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    position: relative;
    padding-bottom: 30px;

}

.block_2_rill_clb .members_dt:after {
    position: absolute;
    content: '';
    height: 1px;
    width: 150px;
    border-bottom: 1px solid #C4C4C4;
    bottom: 17px;
}

.block_2_rill_clb ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    padding-left: 11px;
    padding-top: 53px;
    padding-bottom: 133px;
}

.ct_spces {
    padding-top: 30px;
}

.earn_lirill {
    font-weight: 700;
    font-size: 10px;
    line-height: 16px;
    /* display: flex; */
    /* align-items: center; */
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    opacity: 0.5;
    display: block;
    text-align: left;
    padding-top: 39px;
    padding-bottom: 5px;
}

.lst_rill_clb {
    font-style: normal;
    font-weight: 700;
    font-size: 34px;
    line-height: 16px;
    /* identical to box height, or 47% */
    text-align: left;
    display: block;

    letter-spacing: 0.15px;

    color: #F58220;
}

.pts_rill {
    font-size: 16px;
}

.price_rill {
    font-weight: 700;
    font-size: 10px;
    line-height: 16px;
    display: block;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    opacity: 0.5;
    padding-top: 5px;
}

.block_2_rill_clb {
    max-width: 180px;
    width: 100%;
    max-height: 359px;
}

.bg_color_2_rill {
    background: #F2F2F2;
}

.flx_bx_grid_projct {
    display: flex !important;
}

.brder_rmved_prjct {
    border-top: none;
    margin: 0px 35px;

}

.flx_bx_grid_projct {
    width: 100%;
}

.wd_block .chakra-accordion__item:last-child {
    border-bottom: none !important;
}

.chakra-accordion__item .wd_block button:last-child {
    border-bottom: none !important;
}


/* drill club web page css started */
/* drill club claims page css start */
.cm_frm_claims {
    margin: 0px 35px;
}

.cm_frm_claims p {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.5px;
    color: #000000;
    padding: 33px 0px 17px;
}

.cm_frm_claims h1 {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
    padding-bottom: 20px;
}

.cm_frm_claims label {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;
}

.cm_frm_claims input {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
    max-width: 286px;
    width: 100%;
    display: block;
    margin-bottom: 20px;
}

.cm_frm_claims input:focus,
.cm_frm_claims input[data-focus] {
    z-index: 1;
    border: 1px solid #C4C4C4;
    box-shadow: none;
}

.claim_pg_dril_clb {
    margin: 0px 35px;
}

.claim_pg_dril_clb h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 120% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;

    color: #000000;
    padding: 42px 0px 22px;

}

.claim_pg_dril_clb .chakra-accordion {
    border: 1px solid #C4C4C4;
}

.claim_pg_dril_clb button {
    background: #F2F2F2;
    height: 64px;
    border-bottom: 1px solid #C4C4C4;
}

.claim_pg_dril_clb button:focus,
.claim_pg_dril_clb buttonx[data-focus] {
    box-shadow: none;
}

.claim_pg_dril_clb .chakra-accordion__item {
    border-top-width: 0px;

}

.claim_pg_dril_clb .chakra-accordion__item:last-child {
    border-bottom-width: 0px;

}

.claim_pg_dril_clb button:last-child {
    border-bottom: 1px solid #C4C4C4;
}

.headingaccdion {

    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.1px;
    text-transform: uppercase;

    color: #000000;
}

.claim_pg_dril_clb .chakra-checkbox__label {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;

    color: #000000;
}

.points_claims {
    font-weight: 700;
}

.claim_pg_dril_clb .chakra-stack {
    padding: 15px 0px 10px;
}

.claim_pg_dril_clb .chakra-checkbox__control:focus,
.claim_pg_dril_clb .chakra-checkbox__control[data-focus] {
    box-shadow: none;
}

.bg_color_btn_claims {
    background: #F2F2F2;
    margin: 32px 35px 43px;
    display: flex;
    justify-content: flex-end;
    padding: 14px 20px;
}

.bg_color_btn_claims button {
    background: #EC7700;
    border-radius: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    text-align: center;
    color: #FFFFFF;
    padding: 8px 45px 10px;
    margin: 0px;
    display: block;
    height: 32px;
    transition: all 0.3s ease-in;

}

.bg_color_btn_claims button:focus,
.bg_color_btn_claims button[data-focus] {
    box-shadow: none;
}

.bg_color_btn_claims button:hover {
    transition: all 0.3s ease-in;
    background-color: #592C82 !important;
}


/* drill club claims page css end */
/* submittal page css start  */
.sbMittal_frm .chakra-form__label {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 9px;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
}

.sbMittal_frm input {
    background: #FFFFFF;
    border-radius: 5px;
    z-index: 1;
}

.sbMittal_frm input:focus,
.sbMittal_frm input[data-focus] {
    z-index: 1;
    border-color: transparent;
    box-shadow: none;
}

.sbMittal_frm {
    padding: 10px 0;
}

.tab_dt {
    padding: 0px 35px !important;
}

.sbMittal_frm {
    display: flex;
}

.sbMittal_frm .chakra-form-control {
    margin-right: 20px;
}

.prct_crtjs {
    padding: 0px 15px !important;
}

/* submittal page css end  */
/* Project Order css started  */
.date_cd_orders {
    position: relative;
}

.date_cd_orders img {
    position: absolute;
    bottom: 8px;
    right: 7px;
    z-index: 2;
}

.sbMittal_frm select {
    background: #FFFFFF;
    border-radius: 5px;
}

/*.tble_dt tr:nth-child(4) {*/
/*    background: #F2F2F2;*/
/*}*/

/* Project Order css end  */
/* Manage project css start  */
.dsipl_blck_prkj img {
    max-width: 10px;
    cursor: pointer;
}

.tble_dt_101 {
    margin: 5px 35px;
}

/* Manage project css end  */
/* Project Product History Page css start */
.check_bx .chakra-checkbox__control {
    background-color: #fff;
    width: 24px;
    height: 24px;
}

.check_bx .chakra-checkbox__control:focus,
.check_bx .chakra-checkbox__control[data-focus] {
    box-shadow: none !important;
}

.check_bx {
    margin-top: 26px;
}

.img_tick_pph img {
    max-width: 23px !important;
    cursor: pointer;
    margin: 0px auto;
}

.pph_btn {

    background-color: #fcfcfc !important;
    color: #000;
    padding: 10px 60px !important;
    display: flex;
    align-items: flex-start;
    margin-top: 13px;

}

.pph_btn img {
    padding-right: 5px;
}

/* Project Product History Page css start */
/* my Order history page css start  */
.advance_search {
    text-align: right;
    padding-top: 25px;
    text-decoration: underline;
}

.brder_stsreq {
    margin-right: 18px;
}

.brder_stsreq .chakra-avatar {
    margin-right: 8px !important;

}

.pd_btdf_pt {
    padding-bottom: 17px !important;
}

/* my Order history page css end  */
/* Company Information page css start */
.pd_tp_20 {
    margin-top: 20px;
}

/* Company Information page css end */
.qucik_order {
    clear: both;
    justify-content: space-between;
}

.lst_rdqk_rder {
    display: flex !important;
    align-items: center !important;
}


.lst_rdqk_rder .dt_archive {
    padding-left: 5px;
    padding-top: 0px;
}

.flx_qk_order {
    display: flex;

}

.btn_drpdwn {
    margin-right: 10px !important;
}

.bg_strip_btn_save button:focus,
.bg_strip_btn_save button[data-focus] {
    box-shadow: none;
}

.men_item_qk_order {
    padding: 5px;
}

.men_item_qk_order button {
    line-height: 20px !important;
    margin-bottom: 10px !important;
}

.men_item_qk_order button:last-child {

    margin-bottom: 0px !important;
}

/* blog page css start  */
.btn_blog_grid {
    display: flex;
}

.btn_blog_grid a {
    padding: 10px 20px;
    border: 1px solid #592C82;
    color: #fff;
}

.btn_blog_grid .chakra-select__wrapper {
    max-width: 120px;
    width: 100%;
}

.btn_blog_grid .chakra-select {
    max-width: 300px;
    width: 100%;
    font-weight: 700;
    font-size: 15px;
    color: #1A1A1A;
    border: none !important;
}

.btn_blog_grid option {
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    /* or 373% */

    margin-bottom: 15px;

    /* Black 90 (Text) */

    color: #1A1A1A;
}

.btn_blog_grid .chakra-select:focus,
.btn_blog_grid .chakra-select [data-focus] {
    box-shadow: none;
}

.grid_aside_blog {
    justify-content: space-between;
    padding: 36px 0px 24px;
}

.grid_aside_blog p {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */


    letter-spacing: 0.1px;
    text-transform: uppercase;

    color: #000000;

}

.grid_aside_blog img {
    background-color: #4D4D4D;
    border-radius: 5px;
    height: 43px;
    width: 43px;
    margin: 20px 0px;
    display: flex;
    /* padding: 20px; */
    padding-bottom: 10px;
    padding-top: 10px;
}

.grid_aside_blog ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
    display: flex;
    padding: 0px 21px;
    align-items: center;
}

.grid_aside_blog li {
    margin-right: 20px;
}

.grid_aside_blog li:last-child {
    margin-right: 0px;
}

.grid_aside_blog a {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */


    letter-spacing: 0.1px;
    text-transform: uppercase;

    color: #000000;

}

.grid_aside_blog a:hover {
    text-decoration: none;
}

.flx_pagenation_blg_pg {
    display: flex;
    justify-content: space-between;
}

.bloc_blog {
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);

}

.bloc_blog_inner {
    padding: 25px 20px 50px;
}

.bloc_blog_inner h2 {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    /* identical to box height */

    text-align: left;
    letter-spacing: 0.1px;

    /* Drillcut Purple */

    color: #592C82;

}

.bloc_blog_inner h3 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height, or 120% */

    text-align: left;
    letter-spacing: 0.15px;

    /* Drillcut Purple */
    padding-top: 3px;

    color: #592C82;
}

.bloc_blog_inner p {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    text-align: left;
    letter-spacing: 0.25px;
    padding-top: 5px;
    /* Black 90 (Text) */

    color: #1A1A1A;

}

.bloc_blog img {
    width: 100%;
}

/* blog page css end  */

/* inner blog css start */
.feat_product_inner_blog {
    max-width: 1100px !important;
}

.feat_product_inner_blog h3 {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    color: #1A1A1A;
}

.feat_product_inner_blog h4 {
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.18px;
    color: #1A1A1A;
    padding-top: 5px;
    padding-bottom: 50px;
}

.about_us_content_mt_1 {
    max-width: 860px;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 50px;
    text-align: left;
}

.container_banner_img {
    max-width: 1230px !important;
    padding-right: 21px !important;
    padding-left: 20px !important;
}

.email_subcriber_banner_img {
    max-width: 526px;
    width: 100%;
}

.email_subcriber_banner_img input {
    background: #E9EAEB;
    border-radius: 8px;
    height: 48px;
    color: #000000;
    position: relative;
}

.email_subcriber_banner_img input:placeholder {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    letter-spacing: 0.5px;

    color: #000000;

    opacity: 0.5;
}

.email_subcriber_banner_img button {

    position: absolute;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
    border-radius: 0px 8px 8px 0px;
    color: #000;
    right: 0px;
    height: 48px;
}

.main_export_socialsect {
    max-width: 1200px;
    width: 100%;
    margin: 0px auto;
    display: flex;
    justify-content: space-between;
    /* padding-right: 49px; */
    padding: 0px 5px;

}

.main_export_social_tp_brder {
    border-top: 1px solid #C4C4C4;
    margin: 50px 0px 25px;
}

.main_export_socialsect button {
    background: #EC7700;
    border-radius: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;
    /* or 373% */

    color: #FFFFFF;
    text-transform: uppercase;
    padding: 0px 44px;
    height: 32px;
    transition: all .5s ease;
    color: #FFFFFF;

}

.main_export_socialsect button:hover {
    transition: all .5s ease;
    background: #592C82;
    transition: all .5s ease;
}

.main_export_socialsect ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    display: flex;
}

.main_export_socialsect li {
    margin-right: 28px;
}

.main_export_socialsect li:last-child {
    margin-right: 0px;
}

.abt_img_wd img {
    width: 100%;
}

.main_container_inner_blg {
    width: 100% !important;
    max-width: 100% !important;
    padding-inline-start: 0rem !important;
    padding-inline-end: 0rem !important;
}

.height_slider_iner_blg {
    max-height: 615px;
    background-color: transparent !important;
    height: 624px;
}

.height_slider_iner_blg img {
    width: 100% !important;
    height: 627px;
    object-fit: cover;
}

.lft_pd_blg {
    left: 720px !important
}

.rht_pd_blg {
    right: 720px !important
}

.cstm_arrow_lt1 .slick-slide {

    transition: all 300ms ease;
    position: relative;
}

.cstm_arrow_lt1 .slick-slide::after {
    content: '';
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    background: rgb(0 0 0 / 64%);
    left: 0;
}

.cstm_arrow_lt1 .slick-slide.slick-current::after {
    display: none;
}

.main_container_inner_blg .slick-active img {
    padding: 0px 21px;

}

.cstm_arrow_lt1 .slick-center {

    color: #e67e22;
    opacity: 1;

}

.slider-blog-arrowleft {
    /* position: absolute; */
    bottom: 0px;
    left: 550px;
}

.slider-blog-arrowright {
    /* position: absolute; */
    bottom: 0px;
    right: 550px;
}

.slider-blog-arrowleft svg {
    fill: #C4C4C4;
}

.slider-blog-arrowright svg {
    fill: #C4C4C4;
}

.main_container_inner_blg .slick-dots {
    bottom: -45px !important;
}

.arrow_box_cont {
    max-width: 300px;
    width: 100%;
    display: block;
    margin: 0px auto;
    position: relative;
    top: 25px;
    display: flex;
    justify-content: space-around;
}

.tp_bar_innerblog_bg_color {
    background: #592C82;
    width: 100%;
    text-align: left;
    color: #FFF;
}

.tp_bar_innerblog {
    padding: 70px 15px;
    max-width: 1100px;
    margin: auto;
}

.tp_bar_innerblog h2 {
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
}

.tp_bar_innerblog h3 {
    letter-spacing: -0.5px;
    font-weight: 700 !important;
    font-size: 54px !important;
    line-height: 54px !important;
    color: #FFF;
}

.tp_bar_innerblog button {
    background: #FFFFFF;
    text-transform: uppercase;
    border-radius: 5px;
    font-weight: 700;
    font-size: 15px;
    line-height: 56px;

    color: #EC7700;
    padding: 0px 48px;
    height: 30px;
    margin-top: 20px;
}

.tp_bar_innerblog button:focus,
.tp_bar_innerblog button[data-focus] {
    box-shadow: none;
}

.pd_tp_innerblog {
    padding-top: 70px;
}

.pd_tp_innerblog p {
    padding-top: 20px;
}

.inner_blg_h2Blginner {
    color: #1A1A1A;
}

.pd_tp_innerblog .blog_design_mt {
    margin: 0 8px 0px !important;
}

/* ruby page css start */
.ruby-drill ul {
    margin-bottom: 20px !important;
    justify-content: start !important;
}

.css-22pr2o {
    background-color: #c22e4f !important;
}

.ruby-drill li {
    margin-left: 0px !important;
    margin-right: 45px !important;
}

.ruby-drill li img {
    margin: 0px auto;
    max-width: 100px;
    width: 100%;
}

/* ruby page css end */

.smcx-embed {
    margin: auto !important;
    height: 500px !important;
}

.smcx-iframe-container {
    height: 463px !important;
}

.cart_view_mobile {
    display: none;
}

.data-block {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.mobile-cart {
    padding: 0px 14px;
    /*margin: 0 0 20 0;*/
}

.mobile-cart .data-block {
    background-color: #F8F8F8;
    padding: 15px 30px 30px 15px;
    margin: 30px 0px;

}

.mobile-cart .product {
    display: flex;
    gap: 25px;
    justify-content: space-between;
}

.mobile-cart .product .main-product-image img {
    max-width: 170px;
    width: 100%;
    height: 127px;
    object-fit: cover;

}


.mobile-cart .product .title {
    font-weight: 700;
    max-width: 36%;
    font-size: 12px !important;
}

.mobile-cart .product > input {
    width: 37%;
}

.mobile-cart .product p {
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    color: #000000;
    padding: 0px;
    width: 37%;
    text-align: left;
}

.mobile-cart .product span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #000000;
    max-width: 50%;
    width: 100%;

}

.cart_view_mobile .chakra-collapse {
    overflow: visible !important;
}

.mobile-cart .cart-content {
    justify-content: flex-start !important;
    gap: 30px !important;
    /*align-items: center;*/
}

.mobile-cart .product .content {
    width: 50% !important;
}

.mobile-cart .product .content .pd_name_bmt {
    white-space: pre-line;
    line-height: 1.1;
    word-break: break-word;
    display: table-cell;
}

img.del_icon {
    max-width: 18px !important;
    width: 100% !important;
    height: 20px !important;
    object-fit: cover;
    float: right;
    margin-right: 5px;
}

.cart-additional-info {
    width: 100%;
    flex-direction: column;
    align-items: end;
}

.cart-additional-info .price_dt_summry {
    max-width: 350px;
}

.cart-additional-info .cart-checkout {
    max-width: 360px;
}

.cart-additional-info .cart-checkout {
    width: 100%;
}

.cart-additional-info .select-project {
    width: 100%;
}

.bg_strip_no_margin {
    margin: 0px;
}

/* ruby page media css start */
@media (max-width: 560px) {
    .drill_block_4 li {
        margin-left: 0px;
        margin-right: 15px !important;
    }

    .about_us_page_sliderContent {
        font-size: 18px;
        line-height: 22px;
        padding: 0px 40px;
        letter-spacing: 0.5px;
    }

    .box_homepage_designs_button_box {
        bottom: 18px;
    }

    .chiled_header a {
        position: inherit !important;
        right: 0 !important;
        top: 7px !important;
    }

    .chiled_header {
        display: block !important;
    }

    .box_design {
        margin: 15px 0 0;
        background-size: 100%;
        height: auto !important;
        background-repeat: no-repeat;
    }
}

/* ruby page media css end */

@media (max-width: 1030px) {
    .cart-additional-info .price_dt_summry,
    .cart-additional-info .cart-checkout {
        width: 100%;
        max-width: 100%;
    }

    .cart-additional-info .price_dt_summry {
        margin-right: 0px;
        padding: 0 20px;
    }
}


/* inner blog css end */
@media (max-width: 1350px) {
    .left_arrow_pd_cp {
        left: 180px !important;
    }

    .right_arrow_pd_cp {
        right: 180px !important;
    }

}


@media (max-width: 1165px) {
    .right_arrow_pd_cp {
        display: none !important;
    }

    .project_order_pgs {
        display: block !important;
    }

    .date_cd_orders img {
        position: absolute;
        bottom: 23px;
        right: 7px;
    }

    .project_order_pgs input {
        width: 100% !important;
        margin-bottom: 15px;
    }

    .dril_club_wb p {
        font-weight: 700;
        font-size: 50px;
        line-height: 35px;
    }

    .spec_dt {

        margin: 0px 0px 0px 0px;
    }

    .spec_dt a {

        font-size: 13px;
    }

    .left_arrow_pd_cp {
        display: none !important;
    }

}

@media (min-width: 768px) and (max-width: 1220px) {
    .articleproducts_mt_content {
        padding: 15px;
        /* height: 100%; */
        display: block;
        min-height: 200px;
    }
}

@media (max-width: 1200px) {
    .main_export_socialsect {
        padding: 0px 23px;
    }

    .dropdown__table td:first-child {
        min-width: 148px;
        width: 148px;
    }

    .dropdown__table td:nth-child(2) {
        min-width: 148px;
        width: 148px;
    }

    .dropdown__table td:nth-child(3) {
        width: calc(100% - 296px);
    }

    .dropdown__table .product-cod-st1 {
        max-width: 250px;
    }

    .dropdown__table td:nth-child(4) {
        display: none;
    }

    .dropdown__table td:nth-child(5) {
        display: none;
    }

    .dropdown__table td:nth-child(6) {
        display: none;
    }
}

@media (max-width: 991px) {
    .modal_dataDrill_cbt {
        width: 100%;
    }
    .whle_modal .chakra-modal__close-btn {
        right: 5px;
    }
    .project_page {
        display: block !important;
    }

    .feat_product_inner_blog h4 {
        padding-bottom: 20px;
    }

    .cstm_arrow_lt1 .slick-slide::after {
        position: inherit;
    }

    .feat_product_inner_blog {
        padding-top: 20px;
    }

    .about_us_content_mt_1 {
        padding: 0px !important;
    }

    .mb_pd_iner_blg {
        padding: 0px !important;
    }

    .mini_container_mt {
        padding-inline-start: 0rem !important;
        padding-inline-end: 0rem !important;
    }

    .tp_bar_innerblog h3 {
        font-size: 24px !important;
        line-height: 30px !important;
    }

    .height_slider_iner_blg {
        height: 300px !important;
        margin-top: 20px;
    }

    .height_slider_iner_blg img {
        height: 300px !important;
    }

    .abt_img_wd {
        margin-top: 20px;
    }

    .email_subcriber_banner_img {
        max-width: 270px;
    }

    .grid_aside_blog {
        display: block !important;
    }

    .btn_blog_grid a {

        margin-bottom: 10px;
        margin-top: 10px;
        max-width: 100%;
        padding: 9px 15px;
        width: 48%;

        display: block;
        margin: 0px auto;
        margin-bottom: 10px;
    }

    .grid_aside_blog p {
        text-align: center;
    }

    .flx_pagenation_blg_pg {
        display: flex;
        justify-content: center;
    }

    .btn_blog_grid .chakra-select__wrapper {
        max-width: 48%;
        width: 100%;
    }

    .btn_blog_grid {
        flex-wrap: wrap;
        padding-left: 28px;
    }

    .advance_search {
        text-align: left;
    }


    .pph_btn {
        width: 100% !important;;
    }

    .project_orders_tbl {
        margin-bottom: 90px;
    }

    .project_order_pgs {
        display: block !important;
    }

    .check_bx {
        margin-top: 0px;
    }

    .project_order_pgs input {
        width: 100% !important;
        margin-bottom: 15px;
    }

    /*.container_padding_remove h2 {*/
    /*    font-size: 12px !important;*/
    /*}*/
    .pd_add_mb_lr {
        padding: 0px 15px !important;
    }

    .flx_spc_betwen {
        display: block !important;
    }

    .check_heading {
        font-size: 1.875rem !important;
    }

    .flx_spc_betwen .css-0 {
        max-width: 100%;
        width: 100%;
    }

    .drill_block_3 h3 span {

        display: inline-block;
        padding-left: 5px;
    }

    .drill_block_3 br {
        display: none;
    }

    .cm_frm_claims input {
        max-width: 100%;
    }

    .drill_block_1 a {

        /* position: absolute; */

        bottom: 11px;
        left: 225px;
    }

    .drill_block_1 button {

        margin-bottom: 25px;
    }

    .drill_block_4 {
        max-width: 100%;
    }

    .drill_block_4 ul {

        justify-content: start;
    }

    .rill_flx_blxkCbt {
        display: block !important;
    }

    .drill_block_2 {
        padding-left: 0px;
    }

    .projct_dt {
        margin: 5px 0px;
    }

    .brder_rmved_prjct {

        margin: 0px 15px;
    }

    .flx_bx_grid_projct {
        display: block !important;
    }

    .main_block_sp_offer_flx {
        display: block !important;
    }

    .overlay-ribbon {
        display: none;
    }

    .cls_ul_li_rill_clb li {
        padding-right: 0px;
    }

    .rillRby_member {
        display: block !important;
    }

    .main_block_sp_offer h6:before {

        width: 100%;

    }

    .dril_club_wb img {
        max-width: 250px;
        display: block;
        margin: inherit;
        padding-left: 20px;
        padding-bottom: 12px;
    }

    .dril_club_wb {

        padding: 29px 0px;
    }

    .dril_club_wb p {

        font-size: 32px;
        padding-left: 20px;
        text-align: left;
    }

    .mb_hd_rill {
        display: block !important;
    }

    .pt_blcks_jc {
        display: block !important;
    }

    .content_block_drill2 {

        max-width: 100%;
        margin-top: 25px;
    }

    .content_block_drill1 {

        max-width: 100%;

    }

    .block_left_rill1 {
        max-width: 100%;
        width: 100%;
    }

    .block_left_rill2 {
        max-width: 100%;
        width: 100%;
    }

    .bg_banner_web {
        padding: 175px 0px;
    }

    .dril_club_wb {
        display: none;
    }

    .cnter_block_rillclb {
        display: block !important;
    }

    .block_1_rill_clb {
        max-width: 100%;
    }

    .block_2_rill_clb {
        max-width: 100%;
    }

    .block_1_rill_clb ul {

        padding-right: 11px;

    }

    .block_2_rill_clb ul {

        padding-right: 11px;

    }

    .flx_mb_rill {
        display: flex;
        justify-content: space-between;
    }

    .block_1_rill_clb .members_dt:after {
        width: 100%;
    }

    .price_rill {

        display: inline-block;
    }

    .block_2_rill_clb ul {
        padding-bottom: 20px;
        padding-top: 20px;
    }

    .block_1_rill_clb ul {
        padding-bottom: 20px;
        padding-top: 20px;
    }

    .main_block_sp_offer {
        padding: 25px 20px;
    }

    .block_2_rill_clb .members_dt:after {
        width: 100%;
    }

    .ct_img_rill {
        display: block;
    }

    .ct_img_rill img {

        display: block;
        margin: 0px auto;
        margin-top: 20px;
    }

    .blck_web_2_1 {
        width: 50%;
    }

    .cntnt_blck_wrk_grw {
        display: block !important;
    }

    .cntnt_blck_wrk_grw {

        padding: 54px 0px 83px;
    }

    .block_left_rill1 h4 {
        padding-bottom: 22px;
    }

    .explore-the-rewards span {

        padding-top: 40px;
        display: block;
    }

    .explore-the-rewards p {

        padding-bottom: 156px;
    }

    .explore-the-rewards br {
        display: none;
    }

    .tiers h6 {

        padding: 50px 0px 35px;
    }

    .blck_web_2 {
        display: flex;

        flex-wrap: wrap;
    }

    .acct_statment h2 {
        text-align: left;
    }

    .acct_statment .price_dt_summry {
        margin-top: 20px !important;
    }

    .flx_bx_drill_statment {
        display: block;
        margin: 25px 15px 0px;
    }

    .flx_bx_option_statment select {
        width: 100%;
        margin-top: 10px;
    }

    .stment_clb_drill {
        margin-bottom: 35px !important;
    }

    .spacer_75pstmt {
        height: 55px !important;
    }

    .acc_ctent_block {
        padding: 28px 15px 20px 15px;
    }

    .account_info {
        margin-bottom: 83px !important;
    }

    .invoice_tble_cm_mn {
        margin: 0px 15px;
    }

    .btPd_voic {
        margin: 20px 15px 10px !important;
        display: block;
        padding-bottom: 20px;
    }

    .cstm_invoices {
        margin: 0px 5px;
    }


    .fg_pw_blck {
        height: 560px !important;
    }

    .srch_filter input {
        margin-bottom: 0px;
    }

    .srch_filter {
        display: block !important
    }

    .srch_filter button {

        width: 100%;
        margin-bottom: 30px;
    }

    .pd_tp_bm_tc {
        margin: 30px 14px 53px !important;
    }

    .box_form_blck {
        margin: 0px 14px;
    }

    .mb_st_hd h2 {
        border-bottom: 1px solid #C4C4C4;
        margin-bottom: 20px;
    }

    .hd_cart_mb_hd {
        display: none;
    }

    .hd_md_dtps {
        display: block;
    }

    .pd_rmReorders {
        margin-bottom: 20px !important;
    }

    .bg_strip_btn_save {
        background: #f2f2f2;
        /* margin-top: 250px; */
        margin: 50px 14px 50px;
    }

    .hd_desktop_btn {
        display: none !important;
    }


    .checkOut_bt_cart_shoppig {
        line-height: 36px !important;
        margin-bottom: 65px;
    }

    .qucik_order {
        display: block !important;
    }

    .qucik_order {
        margin: 30px 0px 52px !important;
    }

    .lst_rdqk_rder {

        margin-bottom: 10px !important;
    }

    .mb_pd_tp_qkahuser {
        /* padding-top: 13px !important; */
    }

    .checkOut_bt_cart {
        margin-top: 30px;
    }

    .hd_cart_mb_hd_btn {
        /* display: none !important; */
    }

    .cart_container h2 {
        font-weight: 700;
        font-size: 24px;
        line-height: 24px;
        /* identical to box height, or 100% */

        text-align: center;
        letter-spacing: 0.18px;

        color: #000000;
        padding: 30px 0px;
    }

    .hd_mb_bndle {
        display: block;
    }

    .table_grid_mob {
        margin-top: 23px;
    }

    .pd_tp_mm li {
        padding-top: 37px !important;
    }

    .table_grid_mob_1 li {
        padding-top: 19px;
    }

    .bundle_tbl_bx {
        margin: 40px 0px 33px;
    }

    .cstm_arrow_lt .slick_arrows_custom_logo {

        top: 55% !important;
    }

    .last_bundleTbl-1 {

        margin: 0px 22px 35px;
    }

    .mb_pd_slider {

        margin-top: 20px;
    }

    .model_pd .form-login h2 {
        padding-top: 70px;
    }

    .spec_table {
        display: none;
    }

    .accrdion_box {
        display: block;
        width: 100%;
    }


    .spec_card {
        margin: 0px 22px 33px;
    }

    .spec_dt {

        margin: 0px 25px 0px 25px;
    }

    .block_feat {
        margin: 40px 22px 33px;
    }

    .capliry_h2 {
        padding: 5px 0px;
    }

    .flx_bfeatInner {
        display: block !important;
    }

    .btn_1dwnlod {
        width: 100% !important;
    }

    .video_block {

        margin: 40px 22px 33px;
    }

    .right_arrow_pd_cp {
        display: none !important;
    }

    .stock_data {
        max-width: 100%;
    }

    .main_slider_block_prduct {
        height: 375px;
    }

    .Img_block_pd_slide_prduct img {
        top: 37%;
    }

    .left_arrow_pd_cp {
        display: none !important;
    }


    .main_block_slider {
        box-shadow: none !important;
        display: block;
        margin: 0px;
    }

    .wd_60_pd_slider {
        max-width: 95%;
        /* margin: 10px 30px; */
        margin: 20px auto;
    }

    .wd_40_pd_details {
        max-width: 100%;
        padding: 20px 20px 30px;
    }

    .product_detail_page {
        padding: 0px !important;
    }

    .rm_bgntes {
        margin: 0px 0px 0px 0px !important;
    }

    .price_dt_summry {
        float: none;
        margin-inline-start: 0em !important;
    }

    .option_form {
        margin: 20px 15px 0px 15px;
    }

    .lt_brder {
        display: block !important;
        position: inherit;
        margin-left: 0px;
    }

    .flx_bx_stp .lt_pr {
        margin-left: 0px;
    }

    .lt_brder:after {
        position: inherit;
        content: '';
        border: none;
    }

    .search_filter input {
        width: 100%;
    }

    .block_tb_dt {
        display: block !important;
    }

    .tble_dt {
        display: none !important;
    }

    .dsipl_blck_prkj {
        display: block !important;
        margin: 5px 0px !important;
    }

    .qt_mb_pg {
        /* display: none; */
    }

    .bd_crum h1 {

        font-size: 24px;
        /* padding-left: 32px; */

    }

    .tab_bar {

        margin: 20px 15px;
    }

    .new_roles {
        display: block !important;
        margin: 0px 15px;
    }

    .edit_roles {
        display: block !important;
        margin: 0px 15px;
    }

    .new_roles img {
        max-width: 20px;
    }

    .bx_flx_filt {
        display: block;
    }

    .rl_dets {
        margin: 0px 15px 35px;
    }

    .tab_dt a {
        display: block;
        text-align: center;
    }

    .user_dt {
        display: block !important;
    }

    .user_dt .hd_mdl {
        display: none !important;
    }

    .tble_dt_101 {
        margin: 5px 15px !important;
    }

    .hd_menu {
        display: block;
        padding-inline-start: 0rem !important;
        padding-inline-end: 0rem !important;
    }

    .options_txt {
        display: block;
    }

    .wrap_bx {
        width: 50%;
    }

    .bgFlx {
        flex-flow: wrap;
    }

    .options_txt {

        margin: 20px 15px;
        display: none;
    }

    .bg_color_acrhove {
        margin: 20px 15px;

    }

    .button_list_dt li:hover {
        transform: none;
    }

    .bgFlx {
        margin: 0px 15px 20px 15px;
    }

    .wd_50_prview {
        max-width: 100%;
    }

    .space_sd1 {
        margin: 0px;
    }

    .space_sd {
        margin: 0px;
    }

    .bg_pj {
        margin: 0px 15px 0px 15px;
    }

    .dt_frman {
        margin: 0px 15px 20px 15px;
        height: auto;

    }

    .button_list_dt img {
        max-width: 24px;
        object-fit: contain;
    }

    .button_list_dt li {
        width: 100%;
        height: auto;
    }

    .button_list_dt li {
        text-align: left;
        padding: 5px 23px 5px 23px;
        margin-bottom: 14px;
    }

    .button_list_dt_spn {
        position: absolute;
        top: 19px;

    }

    .button_list_dt .chakra-avatar {
        display: inline-block;
        padding: 0px;
        margin: 0px;
    }

    .button_list_dt {
        display: block;
        margin-inline-start: 0em !important;
        margin-bottom: 55px;
        padding: 12px 15px 10px;
    }

    .flx_bx_wd {
        display: block !important;;
    }

    .color_strip {

        margin: 0px 15px 0px 15px;
    }

    .side-menuct {
        display: none;
    }

    .image-360 {
        width: 50%;
    }


    .pages_project_bar_sub_heading {
        display: none;
    }

    .List_db1 {
        padding-bottom: 0px;
    }

    .side-menuct {
        position: absolute;
        z-index: 999;
        background-color: #fff;
    }

    .hd_dtp {
        display: block;
    }

    .box_width_30 {
        width: 100%;
        max-width: 100%;
    }

    .box_width_70 {
        width: 100%;
    }

    .bd_crum .chakra-avatar {
        margin-left: 10px;
    }

    .bd_crum {

        padding: 20px 14px;
    }

    .qoute_pg {
        display: block !important;
    }

}

@media (max-width: 930px) {
    .brand_logo_aboutuspage .css-1wkijx5 {
        grid-template-columns: repeat(1, 1fr) !important;
    }

    .brand__page p {
        padding-top: 20px !important;
        font-size: 15px !important;
        line-height: 23px !important;
    }

    .brand__page .brands_image .css-0 {
        max-width: 100% !important;
    }

    .brand_logo_aboutuspage .css-70qvj9 .css-0 a {
        position: inherit;
        bottom: 10px;
    }

    .brands_image .css-70qvj9 {
        display: block;
    }

    .css-1wkijx5 .brands_image img, .bg_image img {
        width: 100%;
        object-fit: contain;
        background: #f1f1f1;
        max-width: 100% !important;
    }

    .brand__page .css-1nravos {

        width: 100%;
        margin: 0px auto;
    }
}

@media (max-width: 580px) {
    .table_grid_mob_1 li {
        padding-top: 10px;
    }

    .main_export_socialsect {
        display: block;
    }

    .main_export_socialsect ul {
        justify-content: center;
        margin-top: 20px;
    }

    .drill_block_2 {
        display: block;
    }

    .drill_block_3 {
        max-width: 100%;
    }

    .table_grid_mob_2 li {
        padding-top: 10px;
    }

    .table_grid_mob_2 button {
        margin-top: 5px;
    }

    .drill_block_4 .drill_select_bx {
        padding-inline-start: 0px;
    }

    .drill_select_bx {
        margin-top: 20px;
    }

    .claim_pg_dril_clb {
        margin: 0px 15px;
    }

    .cm_frm_claims {
        margin: 0px 15px;
    }

    .drill_clb_bg {
        margin: 35px 15px 0px;
    }

    .cm_frm_claims p {
        display: block;
        text-align: left;
    }

    .bg_color_btn_claims {
        margin: 32px 15px 43px;
    }

    .sbt_dt {
        margin-bottom: 90px;
    }

    .price_dt a {
        margin: 30px 0px 9px;
    }

    .option_table img {
        max-width: 100%;

    }
}

@media (max-width: 560px) {
    .model_dt {
        width: 90% !important;
    }

    .det_checkt {
        margin-left: 80px;
    }

    .flx_sp_bt .price_tl_pr {
        font-weight: 700;
        font-size: 16px;
    }

    .pd_bm_bill_dt_pg {
        margin-bottom: 50px;
        margin-top: 20px;
    }

    .check_bx_blck .chakra-checkbox__label {

        font-size: 14px;
    }

    .check_bx_blck {
        padding: 40px 15px 0px;
    }

    .flx_sp_bt .price_tl_pr1 {
        font-weight: 700;
        font-size: 16px;
    }

    .drill_block_4 li p {

        margin-bottom: 20px;
    }

    .drill_block_4 li {
        margin-left: 0px;
        margin-right: 15px;
    }

    .drill_block_3 a {

        margin-top: 20px;
        margin-bottom: 20px;
    }


    .model_dt button {
        font-size: 12.5px;
    }

    .table_grid_mob_1 {
        max-width: 36%;
        width: 100%;
    }

    .table_grid_mob_2 {
        max-width: 34%;
        width: 100%;
    }

    .table_grid_mob_1 li {

        font-size: 13px;
    }

    .table_grid_mob_2 li {

        font-size: 13px;
    }

    .ct_invoice {
        display: block;
        height: auto !important;
    }

    .ct_outstading {
        text-align: left !important;
        margin-top: 10px;
    }

    .pg_bar .css-150tos1 {

        max-width: 70%;
    }

    .btn_blog_grid a {
        width: 100%;

    }

    .btn_blog_grid .chakra-select {
        max-width: 100%;
    }

    .btn_blog_grid .chakra-select__wrapper {
        max-width: 100%;
        width: 100%;
    }
}

@media (max-width: 370px) {
    .first_bx_accrdion {

        max-width: 100px;
    }

    .container_padding_remove h2 {
        font-size: 20px !important;
    }

    .check_heading {
        font-size: 1.875rem !important;
    }
}

@media (max-width: 390px) {

    .container_padding_remove h2 {
        font-size: 15px !important;
    }

    .check_heading {
        font-size: 1.875rem !important;
    }
}

@media (min-width: 560px) and (max-width: 767px) {
    .mobile_logo img {
        max-width: 140px;
        width: auto;
    }

    .searchBox_searchPage form.ais-SearchBox-form {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 38%;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        position: absolute;
        top: -42px;
    }
}

/*vijay css start*/
/* css 13-7-2022 */
.box-cr {
    background: #F2F2F2 !important;
    border: none !important;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
}

.promo_img_banner {
    display: flex;
    justify-content: space-between;
    background-position: right;
    background-repeat: no-repeat;
    background-size: cover;

}

.bg_color_promo_img_nner {
    padding-right: 60px;
}

.bg_color_promo_img_nner img {
    max-width: 590.74px;
    height: 433.01px;
    width: 100%;
}

.bg_color_promo_pg {
    background: #F2F2F2;
    width: 100%;
    padding-right: 42px;
    margin-right: 50px;
    margin-left: 20px;
}

.input-invoice-margin {
    display: flex;
}

.input-invoice-mi {
    margin-top: -5px;
    margin-left: 10px;

}

.radio-btn-sp .chakra-radio__control:focus,
.radio-btn-sp .chakra-radio__control[data-focus] {
    outline: none !important;
    box-shadow: none !important;
}

.table-or {
    margin-top: 30px;
}

.listed-or {
    margin-top: 30px;
}

/*
.table-list-mr {} */

.table-or-border {

    margin-bottom: 20px;
    margin-top: 20px;
}

.table-or {
    margin-top: 10px;
}

.listed-or {
    margin-top: 30px;
}

.table-list-mr {
    margin: 0px 15px !important;

}

.new-user-mr {
    margin-top: 30px;
}

.new-user-hr {


    margin: 0 35px;
}

.new-user-br-none {
    border: none;
}

.new-user-br-none1 {
    border: none;
    padding-top: 20px;
}

.user-checkbox-mr {
    display: table !important;
    padding-bottom: 10px;
}

.new-content-mr {
    padding-top: 0px !important;
}

.new-content-mr1 {
    padding-bottom: 0px !important;

}

.new-content-input-mr {
    width: 50% !important;
    display: block !important;
}

.my-price-hr {
    /* / border-bottom: 1px solid #ccc; / */
    margin-top: 20px;

    margin-bottom: 20px;
}

.my-price-text {
    margin-top: 20px;

}

.my-price-text p {
    font-size: 14px;
    line-height: 30px;

}

.price-checkbox-mr {
    display: table !important;
    padding-bottom: 10px;
    font-size: 12px !important;
    text-transform: capitalize !important;
}

.price-checkbox-main {
    margin: 20px 0;
}

.price-btn-mr {
    padding: 20px 20px !important;
    font-size: 14px !important;
}

.heading-rr {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}

.text-nn {
    padding-top: 15px !important;
    padding-bottom: 0px !important;
}

.price-radio-btn {
    margin-top: 40px;
}

.radio-btn-sp {
    margin-right: 40px;
}

.image-rr {
    display: inline;
    top: -2px;
    position: absolute;
    left: 100px;
}

.box-cr-rw {
    background: #F2F2F2 !important;
    padding: 15px 0 !important;
}

.box-cr::placeholder {
    color: #000000;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
}

.box-cr .css-12y4u6o {
    border-color: none !important;
}

.box-cr input:focus {

    border-color: none !important;
}

.test tr:nth-of-type(even) {
    background: #f8f8f8 !important;

}

.test tr:nth-of-type(odd) td {
    background: none !important;
}

.test td img {
    max-width: 200px;
}

.add-border-text {
    border-bottom: 1px solid;
}

.add-border-text p {
    font-size: 14px;
    text-align: left;
    color: #F58220;
    padding: 10px 0;
    margin-top: 20px;;
}

.wd-94 {
    margin: 0 35px;
}

.bg-add-to {
    background: #f2f2f2;
    padding: 14px 0px;
}

.add-to-btn-pd {
    padding: 0px;
    margin: 0px;
}

.add-to-btn {
    border-radius: 10px;
    color: #fff;
    padding: 7px 12px 5px 14px;
    font-size: 15px;
    margin-left: auto;

}

.btn-clr-bl {
    background: #4D4D4D !important;
    margin-right: 10px;
}

.btn-clr-invoice-bl {
    background: #EC7700 !important;
    padding: 5px 60px !important;
}

.btn-clr {
    background: #EC7700 !important;
}

.bg-invoice-to {
    background: #f2f2f2;
    padding: 14px 13px;
    margin: 0 35px;
    margin-top: 20px;
}

.modal-form-group-main {
    margin: 0 35px;
}

.modal-form-group-lv {
    margin-top: 15px;
    margin-bottom: 25px;
    position: relative;
    margin-right: 10px;
}

.modal-form-group-lv .input-icon-lv img {
    opacity: 1;
    position: absolute;
    z-index: 1;
    left: 8px;
    top: 10px;
    color: #979faf;
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.modal-form-group-lv .modal-form-input-lv {
    display: block !important;
    padding: 0px 8px 0px 34px !important;
    width: 150px;
    height: 40px;
    font-size: 12px;
    line-height: 16px;
}

.modal-form-group-lv .modal-form-input-btn {
    display: block !important;
    width: 100%;
    height: 40px;
    font-size: 12px;
    line-height: 16px;
    background: #EC7700;
    color: #fff;
    border-radius: 5px;
}

.btn-clr-invoice-tb {
    background: #EC7700 !important;
    padding: 5px 40px !important;
    color: #fff;
    font-size: 12px;
}

.checkbox-st {
    background: #fff;

    border: 1px solid #E2E2E2;
    border-radius: 4px;

}

.tble_fd tr:nth-child(even) {
    background: #F2F2F2 !important;
}


.hr-brder {
    border: 0.1px solid #C4C4C4;
    margin: 15px 0;
}

.dt_frman-cr {
    height: 200px !important;
}

.model-block-none {
    display: block;
}

.open-drawer-none {
    display: none;
}

.wd_50_prview-wd {
    width: 50%;
    margin: 0 35px;
}

.wd_50_prview-wd-1 {
    margin: 0 35px;
    margin-top: 15px;
}

.wd_50_hr-1 {
    border-bottom: 1px solid #444;
    margin-top: 30px;
}

.lt_pr-1 {
    margin-left: 40px;
}

.mr-t {
    margin-top: 20px;
}

.restore-mr-1 {
    display: flex;
}

.icon-mr {
    margin-top: 15px;
    margin-right: 15px;
}

.mr-rr1 {
    position: relative;
}

.mr-rr1::after {
    position: absolute;
    border-right: none !important;
}

.increse-colr {
    width: 130px;
}

.product-cod-st1 {
    width: 300px;
    background-color: #fff !important;
    border: 1px solid #444 !important;
    border-radius: none !important;
}

.product-cod-st1:focus {
    border: 1px solid #444 !important;
}

/* product web gallery */
.web_gallery {
    display: inline-block;
}

/* product web gallery */
.price_dt2 {
    border-bottom: none !important;
}

.lt_pr-4 {
    /* margin-right: 20px; */
}

.restore-mr-5 {
    gap: 20px;
}

.lt_pr_4sbmt_det {
    /* margin-right: 12px; */
}

/*.option_table tr:nth-child(4) {*/
/*    background: rgb(242 242 242 / 50%);*/
/*}*/

.promo-bg-1 {
    background: #2FA8DF !important;
    padding: 175px 90px;
    width: 657px;

}

.promo-bg-1 img {
    margin: 0 0;
    margin-bottom: 15px;
}

.promo-bg-2 {
    font-weight: 300 !important;
    font-size: 24px !important;
    line-height: 28px !important;
    letter-spacing: 0.15px;
    color: #FFFFFF;
    text-align: left !important;
}

.title-c {
    text-align: center !important;
    padding: 70px 15px;
    max-width: 1200px;
    letter-spacing: -0.5px;
    font-weight: 700 !important;
    font-size: 54px !important;
    line-height: 54px !important;
    margin: auto;
}

.title-c-bg {
    background: #592C82;
    width: 100%;
    text-align: center;
    color: #FFF;
}

.img-re {
    object-fit: cover;
    width: 100%;
}

.box-c-content {
    width: 100%;
}

.parple-bg-d {
    width: 100%;
    height: auto;
    background: ;
}

.parple-text-it {
    font-size: 24px;
    font-weight: 600;
}

.parple-text-its {
    font-size: 14px;
    font-weight: 600;
}

.parple-text-it-1 {
    margin: 20px 0 43px 0;
}

.product-bg-t-img {
    width: 100% !important;
    height: 433px !important;
}

.product-bg-t-img img {
    width: 100% !important;
    height: 390px !important;
}

.product-bg-t-paddinng {
    padding: 0 300px 0 0px;
    width: 800px;
    box-sizing: border-box;
}

.product-bg-t-p-text {
    font-size: 24px;
    font-weight: 700 !important;
    line-height: 24px;
    color: #1A1A1A;
    opacity: 0.5;
}

.product-bg-t-p-sub {
    background: #EC7700;
    /*height: 50px;*/
    font-size: 15px;
    color: #fff !important;
    line-height: 45px !important;
    width: 208px;

}

.product-bg-t-p-sub:hover {
    background: #EC7700 !important;
    text-decoration: none !important;
    border: 1px solid #EC7700 !important;


}

.product-bg-t-p-sub-1 {
    color: #fff !important;
}

.product-bg-t-p-img {
    padding: 20px 0px !important;
    width: 200px;
}

.product-bg-t {
    background: #F2F2F2;
}

.product-bg-t-or {
    display: flex !important;
}

/* css 13-07-2022 */
.box-cr {
    background: #F2F2F2 !important;
    border: none !important;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
}

.input-invoice-margin {
    display: flex;
}

.input-invoice-mi {
    margin-top: -5px;
    margin-left: 10px;

}

.radio-btn-sp .chakra-radio__control:focus,
.radio-btn-sp .chakra-radio__control[data-focus] {
    outline: none !important;
    box-shadow: none !important;
}

.table-or {
    margin-top: 30px;
}

.listed-or {
    margin-top: 30px;
}

/*
.table-list-mr {} */

.table-or-border {
    /* border-bottom: 1px solid #444; */
    margin-bottom: 20px;
    margin-top: 20px;
}


.table-or {
    margin-top: 10px;
}

.listed-or {
    margin-top: 30px;
}

.table-list-mr {
    margin: 0px 15px !important;

}

.new-user-mr {
    margin-top: 30px;
}

.new-user-hr {
    /* border-bottom: 1px solid #ccc; */

    margin: 0 35px;
}

.new-user-br-none {
    border: none;
}

.new-user-br-none1 {
    border: none;
    padding-top: 20px;
}

.user-checkbox-mr {
    display: table !important;
    padding-bottom: 10px;
}

.new-content-mr {
    padding-top: 0px !important;
}

.new-content-mr1 {
    padding-bottom: 0px !important;

}

.new-content-input-mr {
    width: 50% !important;
    display: block !important;
}

.my-price-hr {
    /* border-bottom: 1px solid #ccc; */
    margin-top: 20px;

    margin-bottom: 20px;
}

.my-price-text {
    margin-top: 20px;

}

.my-price-text p {
    font-size: 14px;
    line-height: 30px;

}

.price-checkbox-mr {
    display: table !important;
    padding-bottom: 10px;
    font-size: 12px !important;
    text-transform: capitalize !important;
}

.price-checkbox-main {
    margin: 20px 0;
}

.price-btn-mr {
    padding: 20px 20px !important;
    font-size: 14px !important;
}

.heading-rr {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}

.text-nn {
    padding-top: 15px !important;
    padding-bottom: 0px !important;
}

.price-radio-btn {
    margin-top: 40px;
}

.radio-btn-sp {
    margin-right: 40px;
}

.image-rr {
    display: inline;
    top: -2px;
    position: absolute;
    left: 100px;
}

.box-cr-rw {
    background: #F2F2F2 !important;
    padding: 15px 0 !important;
}

.box-cr::placeholder {
    color: #000000;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
}

.box-cr .css-12y4u6o {
    border-color: none !important;
}

.box-cr input:focus {

    border-color: none !important;
}

.test tr:nth-of-type(even) {
    background: #f8f8f8 !important;

}

.test tr:nth-of-type(odd) td {
    background: none !important;
}

.test td img {
    max-width: 200px;
}

.add-border-text {
    border-bottom: 1px solid;
}

.add-border-text p {
    font-size: 14px;
    text-align: left;
    color: #F58220;
    padding: 10px 0;
    margin-top: 20px;;
}

.wd-94 {
    margin: 0 35px;
}

.bg-add-to {
    background: #f2f2f2;
    padding: 14px 0px;
}

.add-to-btn-pd {
    padding: 0px;
    margin: 0px;
}

.btn-clr-bl {
    background: #4D4D4D !important;
    margin-right: 10px;
}

.btn-clr-invoice-bl {
    background: #EC7700 !important;
    padding: 5px 60px !important;
}

.btn-clr {
    background: #EC7700 !important;
}

.bg-invoice-to {
    background: #f2f2f2;
    padding: 14px 13px;
    margin: 0 35px;
    margin-top: 20px;
}

.modal-form-group-main {
    margin: 0 35px;
}

.modal-form-group-lv {
    margin-top: 15px;
    margin-bottom: 25px;
    position: relative;
    margin-right: 10px;
}

.modal-form-group-lv .input-icon-lv img {
    opacity: 1;
    position: absolute;
    z-index: 1;
    left: 8px;
    top: 10px;
    color: #979faf;
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.modal-form-group-lv .modal-form-input-lv {
    display: block !important;
    padding: 0px 8px 0px 34px !important;
    width: 150px;
    height: 40px;
    font-size: 12px;
    line-height: 16px;
}

.modal-form-group-lv .modal-form-input-btn {
    display: block !important;
    width: 100%;
    height: 40px;
    font-size: 12px;
    line-height: 16px;
    background: #EC7700;
    color: #fff;
    border-radius: 5px;
}

.btn-clr-invoice-tb {
    background: #EC7700 !important;
    padding: 5px 40px !important;
    color: #fff;
    font-size: 12px;
}

.checkbox-st {
    background: #fff;

    border: 1px solid #E2E2E2;
    border-radius: 4px;

}

.tble_fd tr:nth-child(even) {
    background: #F2F2F2 !important;
}

.hr-brder {
    border: 0.1px solid #C4C4C4;
    margin: 15px 0;
}

.dt_frman-cr {
    height: 140px !important;
}

.dt_frman-cr2 {
    height: 200px !important;
}

.model-block-none {
    display: block;
}

.open-drawer-none {
    display: none;
}

.wd_50_prview-wd {
    width: 50%;
    margin: 0 35px;
}

.wd_50_prview-wd-1 {
    margin: 0 35px;
    margin-top: 15px;
}

.wd_50_hr-1 {
    border-bottom: 1px solid #444;
    margin-top: 30px;
}

.lt_pr-1 {
    margin-left: 40px;
}

.mr-t {
    margin-top: 20px;
}

.restore-mr-1 {
    display: flex;
}

.icon-mr {
    margin-top: 15px;
    margin-right: 15px;
}

.mr-rr1 {
    position: relative;
}

.mr-rr1::after {
    position: absolute;
    border-right: none !important;
}

.increse-colr {
    width: 130px;
}

.product-cod-st {
    width: 150px;
    background-color: #fff !important;
    border: 1px solid #444 !important;
    border-radius: none !important;
}

.product-cod-st1 {
    background-color: #fff !important;
    border: 1px solid #444 !important;
    border-radius: none !important;
}

.product-cod-st1:focus {
    border: 1px solid #444 !important;
}

.price_dt2 {
    border-bottom: none !important;
}

.lt_pr-4 {
    /* margin-right: 20px; */
}

.lt_pr_4sbmt_det {
    /* margin-right: 12px; */
}

/*.option_table tr:nth-child(4) {*/
/*    background: rgb(242 242 242 / 50%);*/
/*}*/

@media (max-width: 991px) {
    .desktop_cart {
        display: none;
    }

    .bg-add-to {
        display: block !important;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .fmb_wd_blog {
        grid-template-columns: auto !important;
    }

    .rm_padding_quicks li:last-child {

        margin-bottom: 15px;
    }

    .pd_add_bm_quicks {
        margin-bottom: 90px;
    }

    .mb_pd_qucik_rm {
        margin: 0 15px !important;
    }

    .new-user-hr {
        border-bottom: 1px solid #ccc;

        margin: 0 15px;
    }

    .add-to-btn-pd {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dt_archive {
        padding-top: 0px;
    }

    .archive-rr {
        padding-top: 15px;
    }

    .bg_color_acrhove .chakra-avatar {
        margin-right: 0px;
    }

    .model-block-none {
        display: none;
    }

    .open-drawer-none {
        display: block;
    }

    .modal-form-group-lv .modal-form-input-lv {
        width: 100%;
    }

    .modal-form-group-lv {
        margin-right: 0px;
    }

    .drawer-btn-color {
        color: #EC7700 !important;
        background: none !important;
        box-shadow: none !important;
        margin-bottom: 20px;

    }

    .open-dig {
        width: 90%;
        margin: auto;
    }

    .bg-invoice-to {
        margin: 0px 0px;
    }

    .modal-form-group-main {
        margin: 0 15px;
    }

    .modal-form-group-main1 {
        padding: 15px;
        margin: auto;
        width: 95% !important;
        margin-top: 15px;
    }

    .wd_50_prview-wd {
        width: 100%;
        margin: 0 0px;
    }

    .wd_50_prview-wd-1 {
        margin: 0 15px;
        margin-top: 0px;
    }

    .mr-rr {
        margin-top: 15px;
    }

    .mr-rr1 {
        position: relative;
        margin-top: 15px;
    }

    .restore-mr-5 {
        display: block;
    }

    .lt_pr-4 {
        margin-left: 0px;
    }

    .vj_st {
        padding: 0px 15px !important;
        margin-bottom: 50px;
    }

    /* css 13-07-2022 */
    .bg-add-to {
        display: block !important;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .rm_padding_quicks li:last-child {

        margin-bottom: 15px;
    }

    .pd_add_bm_quicks {
        margin-bottom: 90px;
    }

    .mb_pd_qucik_rm {
        margin: 0 15px !important;
    }

    .new-user-hr {
        border-bottom: 1px solid #ccc;

        margin: 0 15px;
    }

    .add-to-btn-pd {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dt_archive {
        padding-top: 0px;
    }

    .archive-rr {
        padding-top: 15px;
    }

    .bg_color_acrhove .chakra-avatar {
        margin-right: 0px;
    }

    .model-block-none {
        display: none;
    }

    .open-drawer-none {
        display: block;
    }

    .modal-form-group-lv .modal-form-input-lv {
        width: 100%;
    }

    .modal-form-group-lv {
        margin-right: 0px;
    }

    .drawer-btn-color {
        color: #EC7700 !important;
        background: none !important;
        box-shadow: none !important;
        margin-bottom: 20px;

    }

    .open-dig {
        width: 90%;
        margin: auto;
    }

    .bg-invoice-to {
        margin: 0px 0px;
    }

    .modal-form-group-main {
        margin: 0 15px;
    }

    .modal-form-group-main1 {
        padding: 15px;
        margin: auto;
        width: 95% !important;
        margin-top: 15px;
    }

    .wd_50_prview-wd {
        width: 100%;
        margin: 0 0px;
    }

    .wd_50_prview-wd-1 {
        margin: 0 15px;
        margin-top: 0px;
    }

    .mr-rr {
        margin-top: 15px;
    }

    .mr-rr1 {
        position: relative;
        margin-top: 0px;
    }

    .restore-mr-5 {
        display: block;
    }

    .lt_pr-4 {
        margin-left: 0px;
    }

    .vj_st {
        padding: 0px 15px !important;
        margin-bottom: 50px;
    }

    .title-c {
        padding: 30px 15px;
        font-size: 30px !important;
        line-height: 43px !important;
    }

    .bg_banner_web {
        padding: 0px 0px;
    }

    .product-bg-t-paddinng {
        padding: 30px 30px 30px 30px !important;
        width: 100%;
        box-sizing: border-box;
    }

    .product-bg-t-or {
        display: block !important;
    }

    .product-bg-t-p-img {
        padding: 0px 0px !important;
        width: 200px;
    }

    .product-bg-t-img img {
        margin-top: 30px !important;
        width: 100% !important;
        height: auto !important;
    }

    .product-bg-t-img {
        width: 100% !important;
        height: auto !important;
    }

    /* css 13-07-2022 */
}

/*vijay css start*/

/* rs css start ipad 4-11-2022 */
@media (max-width: 1400px) {
    .drill_clb_bg .css-k008qs {
        display: block;
    }
}

@media (min-width: 500px) and (max-width: 1366px) {
    /* .drillcutsearchMainResult .searchDatamt{
            overflow: visible!important;
    margin-bottom: 250px!important;
    }
    .drillcutsearchMainResult .css-i6bazn{
         overflow: visible!important;
    } */
}

@media (max-width: 1366px) {
    p.chakra-text.latest_product_div_contain_heading {
        font-size: 18px;
    }

    .searchDrillcutfilters {
        display: flex;
        justify-content: space-between;
    }

    .drillcutsearchMainResult .search_Image_container {
        height: 100%;
    }

    .model-block-none .css-k008qs {
        flex-wrap: wrap;
    }

    .model-block-none .css-k008qs .modal-form-group-lv {
        margin-bottom: 10px;
    }

    .tabs-menu ul li a {
        font-size: 13.5px !important;


    }

    .box_homepage_designs_heading {
        letter-spacing: 0.15px;
        font-size: 26px !important;

    }

    .box_width_70 {

        max-width: 100%;
    }

    .form_login_Button {
        line-height: 0px !important;
    }

    .ct_img_rill img {

        width: 60% !important;
    }

    .tabs-menu ul li {
        padding: 10px 14px !important;

    }

    p.latest_product_div_contain_price {
        font-size: 18px;
    }

    .brand_logo_aboutuspage .css-1wkijx5 {
        grid-template-columns: repeat(2, 1fr);


    }

    .latest_product_div_contain_button {
        margin-top: 11px;
    }

    .drill_clb_bg .css-k008qs {
        display: block;
    }

    .drill_block_2 {
        padding-left: 0px;
    }

    .downloads_page_space .orange_button_drillcut {
        margin-top: 30px;
    }

    .download_subtags_box {
        padding-left: 15px;
    }

    .drill_block_3 h2 {
        font-size: 24px;
        padding: 4px 0px 5px;
    }

    .pg_bar .css-150tos1 {
        max-width: 62%;
    }

    .drill_block_1 a {
        padding-top: 0px;
        margin-bottom: 10px;
        text-align: left;
    }

    .option_form {
        margin: 20px 15px 0px 15px;
        z-index: -1 !important;
    }

    .menu_open_mt {
        width: 325px;
        left: -10px;

    }

    .chiled_open_mt {
        position: absolute;
        width: 325px;
        left: 325px;
    }

    .chiled_open_mt-2 {
        position: absolute;
        width: 325px;
        left: 319px;
    }

    .rect_bx_ribon {
        z-index: 999;
    }

    .main_slider_block_prduct {
        min-height: auto;
        height: auto;
    }

    .Img_block_pd_slide_prduct img {
        position: inherit;
        top: inherit;
        left: inherit;
        transform: inherit;
        width: 100%;
    }

    #upper_logo_threesixzero img {
        max-width: 95% !important;
    }

    .drill_club_web_ct .dril_club_noclr img {
        max-width: 30% !important;
        margin-top: -15px;
    }

    .main_block_sp_offer h6 {
        font-size: 18px !important;
    }

    .overlay-ribbon:before {
        border-left: 106px solid transparent !important;
        border-right: 101px solid transparent !important;
        width: 177px !important;
        bottom: -1px !important;
    }

    .overlay-ribbon {
        max-width: 205px !important;
    }

    .ribbon-content p {
        font-size: 28px !important;
        padding-top: 22px !important;
    }

    #upper_logo_threesixzero {

        padding: 124px 0 175px 88px !important;
    }
}

@media (max-width: 992px) {

    .half_width_class_mt {
        width: 100%;
    }

    .about_us_content_mt {
        padding: 0px 20px;
    }

    .cart_container .desktop_cart {
        display: none !important;
    }

    .mob_img_bx img {
        max-width: 100%;
    }

    .CollectionsData {
        flex-direction: column;
    }

    .collection_grid {
        padding: 20px;
        grid-template-columns: repeat(3, 1fr);
    }

    .CollectionsData {
        flex-direction: column;
    }

    .drillcut_companies {

        padding: 0px 30px;
    }


    .about_container .css-biwl99 {
        display: block !important;
        width: 100% !important;


    }

    #an_all_comment_box {
        display: block !important;

    }

    .about_container .about_contain {
        width: 100%;
    }

    .blog_section_drillcut {
        flex-direction: row !important;
        gap: 10px;
    }

    .backgorund_latest_prod_mt {
        height: 250px;
    }

    .latest_product_div_mt {
        margin: 15px 0;
        flex-direction: column;
        height: 100%;
    }

    .latest_product_contain,
    .blog_section_drillcut {
        flex-direction: column;
    }

}

@media (min-width: 1270px) {
    .bg_banner_web {
        height: 350px !important;
    }
}

@media (max-width: 1270px) {
    .bg_banner_web {
        height: 300px !important;
    }

    .main_block_sp_offer h6 {
        font-size: 18px !important;
    }

    .overlay-ribbon:before {
        border-left: 108px solid transparent !important;
        border-right: 96px solid transparent !important;
        width: 177px !important;
    }

    .overlay-ribbon {
        max-width: 205px !important;
    }

    .ribbon-content p {
        font-size: 28px !important;
        padding-top: 22px !important;
    }

    .dril_club_noclr {
        background: #ededed;
        width: 100%;
        padding: 130px 0 150px 88px !important;
    }

}

@media (max-width: 1366px) {
    .box_view_design_mt {
        display: flex !important;
    }

    .overlaybody {
        display: none;
    }
}

@media (max-width: 1180px) {
    .box_view_design_mt {
        display: block !important;
    }

    .overlaybody {
        display: none;
    }

    .half_mini_width_drillcut {
        width: 100% !important;
        background-position: center;
        margin-bottom: 30px;
        /* min-height: 458px;*/
    }

    .half_mini_width_drillcut img {
        width: 100% !important;
    }

    .box_design {
        height: auto !important;
    }
}

@media (max-width: 1024px) {
    .first_bx_accrdion h2 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 10px;
    }

    .css-1nravos {
        max-width: 320px;
        margin-bottom: 0px;
        box-shadow: 3px 3px 4px rgb(0 0 0 / 25%);
        width: 100%;
    }

    .brands_image .css-0 {
        max-width: 235px;
        width: 100%;
        height: auto;
    }

    .footer_logo_main_logo {
        width: 90%;
    }

    .orange_button_drillcut {
        margin-top: 20px !important;
    }

    .css-zipzvv {
        overflow-y: visible !important;
        overflow-x: visible !important;
    }

    .css-zipzvv .chakra-table:first-child {
        overflow-y: scroll;
        overflow-x: scroll;
        /* width: 90%; */
        display: inline-block;
    }

    .CollectionsData {
        flex-direction: column;
    }

    .cart_dt_pp {
        display: block !important;
    }

    #overlay {
        display: none !important;
    }

    .width_25DrillCut {
        width: 100%;
    }

    .searchDatamt ul {
        grid-template-columns: repeat(2, 1fr);
    }

    .Sort_pagination {
        justify-content: center;
        width: 100%;
        margin-bottom: 20px;
    }

    .pagination_top {
        display: none;
    }

    .width_75DrillCut {
        width: 75%;
        max-width: 100%;
        width: 100%;
    }

    .paginate_count {
        width: 100%;
    }

    .searchPage_pagination_bottom {
        padding: 0px 20px 20px 20px;
        flex-wrap: wrap;
        flex-direction: column-reverse;
    }

    .searchPage_pagination .ais-Pagination {
        margin-left: 0px;
    }

    .selectbox_Box {
        width: 100%;
    }

    .searchmobileviewmt {
        flex-direction: column;
    }

    .cstm_pslider {
        padding: 0px !important;
    }

    .headericons_mobile_view .chakra-avatar__badge {
        height: 18px;
        width: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px !important;
    }

    .header_center_mt {
        padding: 15px 30px !important;
    }

    .dril_club_noclr {
        background: #ededed;
        width: 100%;
        padding: 40px 0px !important;
    }

    .main_container {
        padding: 10px 30px;
    }

    .logo_width_set {
        margin-right: 15px;
    }

    .chakra-table .css-0 {
        /* position: relative; */
    }

    .chakra-table .css-de1rql {
        /* position: fixed; */
        z-index: 99;
    }

    #upper_logo_threesixzero {

        padding: 40px 0px !important;
    }

    .menu_open_mt button,
    .chiled_header {
        padding: 20px 20px;
    }

    .chiled_header span {
        font-size: 17px !important;
    }

    .menu_open_mt {
        width: 260px;
        left: 0px;
    }

    .chiled_open_mt {
        position: absolute;
        width: 263px;
        left: 261px;
    }

    .chiled_open_mt-2 {
        position: absolute;
        width: 240px;
        left: 260px;
    }

    .pd_typs {
        padding-top: 11px;
    }

    .bg_color_acrhove .lt_brder {
        display: inherit !important;
    }

    .drill_club_web_ct .dril_club_wb img {
        max-width: 50% !important;
        margin-top: 0px;
    }
}

/* rs css end ipad 4-11-2022 */
/* mobile issue css start 10-11-2022 */
@media (max-width: 369px) {
    .lt_pr {
        margin-left: 5px;
    }
}

@media (max-width: 428px) {
    .lt_pr {
        margin-left: 0px;
    }
}

@media (max-width: 450px) {
    .text_logo_section_logo_mt {
        grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    }

}

@media (max-width: 560px) {
    .searchBox_searchPage {
        margin: 0 !important;
        padding: 0px 25px 20px !important;
    }

    .searchDatamt ul {
        grid-template-columns: repeat(1, 1fr);
    }
}

@media (max-width: 768px) {
    .add-to-btn {
     margin-left: 0px;
    }
    .bg_svdl:after {
        width: auto;
        left: auto;
    }

    .price_dt_summry {
        margin-right: 0px;
    }

    .desktop_cart_view {
        display: none !important;
    }

    .cart_view_mobile {
        display: block;
    }

    .chakra-modal__content .css-z7mtfw {
        flex-wrap: wrap-reverse;
        /* margin-top: 10px; */
        justify-content: center;
        gap: 15px;
        top: 0px;
        margin-top: 0px;
    }

    .chakra-modal__content .css-k008qs {
        width: 100%;
    }

    .chakra-modal__content .css-jvwk1r {
        width: 100% !important;
    }

    .ArticleProductButton {
        width: 96%;
    }

    .brands_image p {

        -webkit-line-clamp: inherit;
    }

    .brand_logo_aboutuspage .css-70qvj9 .css-0 a {
        margin-bottom: 20px;
    }

    .brands_image img,
    .bg_image img {

        max-width: 100% !important;
    }

    .css-1wkijx5 .brand_logo_aboutuspage .css-0 a {
        width: 130px;
        height: 30px;
        line-height: 30px;
        margin-top: 15px;
        margin-bottom: 20px;
    }

    .css-1wkijx5 .brands_image p {
        overflow: hidden;
        text-overflow: unset;
        display: -webkit-box;
        -webkit-line-clamp: 0;
        -webkit-box-orient: vertical;
        font-size: 18px;
        line-height: 24px;
        padding: 15px 10px;
    }

    .css-1wkijx5 .brands_image img,
    .bg_image img {
        width: 100%;
        object-fit: contain;
        background: #f1f1f1;
        max-width: 100% !important;
    }

    .css-1wkijx5 .brands_image .css-0 {

        max-width: 100%;
    }

    .css-1wkijx5 .about_container .css-k008qs {
        display: block !important;
        margin-top: 30px !important;
    }

    .about_page_slider_container_contentmt .slick_arrows_custom_logo_next {
        right: 0px !important;
    }

    .about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {
        left: 0px !important;
    }

    .box_design {

        height: auto !important;

    }

    .about_slider_bg_image_mt {
        min-height: 600px;
    }

    .aboutpage_sliderBox {
        max-width: 320px;
    }

    .chiled_header {
        position: relative;
        display: block !important;
    }

    .drillcuttv_subfilters_button_mt {
        width: 60%;

    }

    .collectionImage {
        background-color: #f2f2f4;
    }

    .collectionImage img {
        object-fit: contain;
    }

    .header_center_mt .chakra-avatar__group {
        margin-top: 4px;
    }

    .searchBox_searchPage {
        margin: 0 !important;
        padding: 1px 20px 0px;
    }

    .rectangle-bottom:after {
        border-left: 37px solid transparent;
        border-right: 37px solid transparent;
        margin-top: -1px;
    }

    .drill_cut_tv_popup {
        margin: 0px 10px;
    }

    .bg_strip_btn_save button {
        line-height: 41px;

        margin-top: 0px;
        margin-left: 5px !important;

    }

    .srch_filter .form_controll {
        display: block;
        padding-bottom: 30px;
    }

    .downloads_page_content_mt {
        padding: 30px 15px !important;
        align-items: unset !important;
    }

    .text_logo_section_logo_mt {
        grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    }

    .logo_text_block_contain {
        justify-content: center;
    }

    .downloads_page_content_td_mt_heading {

        white-space: nowrap;
        padding-left: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .download_button_mt {
        padding: 6px 15px !important;
    }

    .project_br .flx_bx_wd:last-child {
        padding: 0px !important;
        margin-bottom: 83px;
    }

    .contactUspage_block_Form_block .form_controll {
        padding: 0px 0px;
        grid-gap: 0px;
        display: block;
    }

    .label_name_Contactform {

        padding: 20px 0px 0px;
    }

    .contactUspage_block_Form_block {

        margin-bottom: 36px;
        margin-top: 30px;
    }

    .map_section_block {

        padding: 0px 0px;
    }

    .account_info {
        margin-bottom: 20px !important;
    }

    /*.slider_image_mt img {*/
    /*    height: 200px;*/
    /*}*/
    ul.mobile_menu_list {

        height: 90%;
        overflow-y: scroll;
    }

    .first_bx_accrdion h2 {

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 10px;
    }

    .background_image_mt_content_main_text form {

        width: 90%;
    }

    .css-14tkcur {

        width: 100% !important;
        display: block !important;
    }

    /*.css-ry7qsg {*/

    /*    margin: 0px;*/
    /*    margin-left: 0px !important;*/
    /*    display: block !important;*/
    /*    margin-top: 13px;*/
    /*}*/

    .brand_logo_aboutuspage .css-1wkijx5 {
        grid-template-columns: repeat(1, 1fr);


    }

    .brand_logo_aboutuspage .brands_image {
        max-width: 100%;
    }

    .brands_image .css-70qvj9 {
        display: block;
    }

    .home_page_main_slider_mt .slick-dots {

        bottom: 0px !important;

    }

    .home_page_main_slider_mt .slick-dots {

        padding-left: 0px !important;
    }

    .slick_slider_custom_arrows {
        display: none !important;
    }

    .bg_color_acrhove {

        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .rl_dets label {
        font-weight: 500;
        font-size: 18px;
    }

    .chiled_header a {
        /* position: absolute;
        right: 50px;
        top: 23px; */
        margin-top: 10px;
        display: block;
    }

    .options_txt {
        display: none;
    }

    .block_tb_dt span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .pages_project_bar_heading {
        padding-left: 0px;
    }

    .bg_color_acrhove .lt_brder {

        align-items: center;
    }

    .lt_pr {

        display: flex;
        align-items: center;
    }

    .bd_crum h1 {
        padding-left: 0px;
    }

    .sbMittal_frm .chakra-form-control {
        margin-right: 20px;
        max-width: 155px;
        max-width: 100%;
        margin-bottom: 10px;
    }

    .sbMittal_frm .chakra-form__label {
        font-size: 12px;
    }

    .sbMittal_frm input {
        max-width: 100%;
        width: 100%;
    }

    .sbMittal_frm {
        display: block;
    }

    .flx_bx_stp {
        display: block;
    }

    .mr-rr1 {
        font-size: 12px;
        text-align: center;
        /* letter-spacing: -0.5px; */
        margin-top: 0px;
    }

    .lt_pr_4sbmt_det {
        margin-left: 0px !important;
    }

    .lt_pr_4sbmt_det {
        margin-right: 7px;
    }

    .restore-mr-5 {

        display: flex;
        flex-wrap: wrap;
    }

    .flx_bx_stp .css-k008qs {
        flex-wrap: wrap;
    }

    .qt_mb_pg button {
        margin-left: 0px;
        padding: p;
        padding: 0px;
        display: block;
        height: 20px;
        padding-top: 6px;
    }

    .flx_bx_wd {

        padding: 0px !important;
    }
}

@media (max-width: 700px) {
    .about-us-wrapper {
        margin-top: 10px;
        justify-content: center;
        flex-direction: column;
    }

    .nps-score {
        margin: auto;
    }

    .css-zipzvv .option_table .css-womqfz {
        max-width: 300px;
        /*right: 30px;*/
        /*left: 30px;*/
        /*width: 100%;*/
        /*left: 50%;*/
        /*right: 0;*/
        /*top: auto;*/


        /*transform: translate(-50%, -0%);*/
    }
}

@media (max-width: 550px) {
    .modal-form-group-main1 {

        width: 80% !important;

        position: inherit !important;
    }

    .sbMittal_frm {
        display: block !important;
    }

    .sbMittal_frm .chakra-form-control {

        margin-bottom: 17px;
    }

    .sbMittal_frm .chakra-form-control:last-child {

        margin-bottom: 0px;
    }

    .price-checkbox-mr {
        display: flex !important;
    }

    .price-checkbox-main .css-6x44c9 {

        display: inline-grid;
        margin-left: 10px;
        height: 20px;

    }

    .text-nn {
        margin-bottom: 20px !important;
        max-width: 100% !important;
    }

    .branch_table_company_page .css-9xtqsk {
        display: block;
    }

    .branch_table_company_page .chakra-form-control {
        padding-top: 10px;
    }

    .branchInformationHeading {

        min-width: 100px;
        max-width: 100%;
    }

    .tble_dt td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

@media (max-width: 766px) {
    .chakra-table .css-de1rql {
        max-width: 90%;
        left: 20px;
        overflow: hidden;
    }
}

@media (max-width: 768px) {
    .full_width_container {
        max-width: 100% !important;
        padding: 0 !important;
        position: relative !important;
        width: 100%;
        height: 100%;
        margin: 0;
        /* overflow: hidden; */
        /* position: absolute!important; */
        top: 0;
        left: 0;
        overflow-x: hidden;
    }

    .prduct_image img {
        max-width: 100px;
        border: none;
    }

    .prduct_image {
        top: -6px;
    }

    .about_contain {

        padding-top: 30px !important;
        padding-bottom: 30px !important;
    }

}

@media only screen and (max-width: 767px) {
    .tabs-menu ul li {
        padding: 10px 10px;
        margin: 4px 1px;
        max-width: 110px;
        width: 100%;
    }

    .know-us-image-main {

        border: 1px solid #592c82 !important;
        width: 90.5% !important;
        padding-bottom: 20px !important;
    }

    .know-us-image-top {
        width: 100% !important;
    }
}

@media (max-width: 1500px) {

    .home_page_main_slider_mt .slick-dots,
    .slick_slider_custom_arrows {
        /* padding-left: 50px; */
        top: unset;
        /* width: 100%; */
        left: 50%;
        /* top: 50%; */
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }
}

/*@media (max-width: 1370px) {*/
/*    .orange_button_drillcut {*/
/*        margin-top: 30px;*/
/*    }*/
/*}*/

@media (max-width: 1200px) {
    .spec_dt {
        position: inherit;
        margin-left: 0px;
        bottom: 0px;
    }

    .box_design {
        margin: 0px 0px !important;
        margin-bottom: 30px !important;
    }

    .spec_accordian_box .flxe_accrdion {
        display: block;
    }
}

@media (min-width: 1400px) {
    /* .slider_image_mt img {
        height: 95vh;
    }
    .slider_image_mt{
        height: 95vh;
    } */
}

@media (min-width: 1600px) {
    .slider_image_mt img {
        height: 100%;
    }

    .slider_image_mt {
        height: 100%;
    }
}

/* mobile issue css start 10-11-2022 */

/* vijay css */
button.btn_drpdwn {
    margin-top: 0px;
}

body::-webkit-scrollbar {
    width: 6px;
    overflow-y: auto;
    /* width of the entire scrollbar */
}

body::-webkit-scrollbar-track {
    background: #fff;
    overflow-y: auto;
    /* color of the tracking area */
}

body::-webkit-scrollbar-thumb {
    background-color: #f2f2f2;
    border: 1px solid #8c8e8f;
    /* color of the scroll thumb */
    overflow-y: auto;
}

body::-webkit-scrollbar {
    -webkit-appearance: none;
    background-color: #f2f2f2;
}

body::-webkit-scrollbar:horizontal {
    height: 6px;
}

body::-webkit-scrollbar-thumb {
    background-color: #8c8e8f;
}

body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f2f2f2;
}

.drill_cut_tv_popup {
    max-width: 736px !important;
}

.css-zipzvv::-webkit-scrollbar {
    width: 10px;
    overflow-y: hidden;
    /* width of the entire scrollbar */
}

.css-zipzvv::-webkit-scrollbar-track {
    background: #fff;
    overflow-y: hidden;
    /* color of the tracking area */
}

.css-zipzvv::-webkit-scrollbar-thumb {
    background-color: #f2f2f2;
    border: 1px solid #8c8e8f;
    /* color of the scroll thumb */
    overflow-y: hidden;
}

.css-zipzvv::-webkit-scrollbar {
    -webkit-appearance: none;
    background-color: #f2f2f2;
}

.css-zipzvv::-webkit-scrollbar:horizontal {
    height: 10px;
}

.css-zipzvv::-webkit-scrollbar-thumb {
    background-color: #8c8e8f;
}

.css-zipzvv::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
    background-color: #f2f2f2;
}


.ArticleProductTitle.drillcut_purple {
    padding-bottom: 7px;
}

.css-1dklj6k {
    padding-bottom: 7px;
}

.dril_club_noclr {
    padding: 135px 0 175px 88px !important;
}

.bg_color_acrhove .css-0 {
    display: flex;
    align-items: center;

}

.lt_pr_4sbmt_det {
    /* margin-right: 12px; */
    display: flex;
    align-items: center;
}

/* vijay css */

button.btn_drpdwn {
    margin-top: 0px;
}


@media (max-width: 1160px) {
    .spec_table_list {
        display: none !important;
    }

    .spec_accordian_box {
        display: block;
    }
}

@media (min-width: 1160px) {
    .spec_table_list {
        display: block;
    }

    .spec_accordian_box {
        display: none !important;
    }
}

.display-block {
    display: block !important;
}

.ruby div[role='progressbar'] {
    background-color: #c22e4f;
}

.sapphire div[role='progressbar'] {
    background-color: #4061ad;
}

.emerald div[role='progressbar'] {
    background-color: #008473;
}

.diamond div[role='progressbar'] {
    background-color: #a692be;
}

@media (min-width: 1000px) {
    .overflow-inherit {
        overflow-x: inherit !important;
        overflow-y: inherit !important;
    }
}
/* 11-04 */
.slick_slider_custom_arrows {
    position: relative;
    z-index: 9;
}
.slick_slider_custom_arrow {
    position: absolute;
    width: 20px;
    z-index: 9;
    top: -30px;
}

@media (max-width: 500px) {
    .mob_img_bx {
        background-color: #f2f2f2;
        height: 80px;
        max-width: 80px;
        position: relative;
        width: 80px;
        display: block;
    }

    .mob_img_bx img {
        max-width: 100%;
        width: 100%;
        object-fit: contain;
        height: 80px;
    }

    .mob_pd_nm {
        padding-left: 15px;
        padding-top: 15px;

        width: calc(100% - 95px);
        display: block;
        word-wrap: break-word;

    }

    .pd_name_bmt {
        display: block;
        overflow-wrap: break-word;

    }
}

@media (max-width: 450px) {

    .wd_50_prview-wd-1 td.css-1f2qau6 {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/rs-style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IAEZ,qCAAqC;IACrC,mCAAmC;AACvC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,sBAAsB;IACtB,6BAA6B;IAC7B,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,WAAW;IACX,SAAS;IACT,oBAAoB;IACpB,6BAA6B;IAC7B,MAAM;IACN,OAAO;IACP,sBAAsB;IACtB,eAAe;IACf,2BAA2B;;AAE/B;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;;IAEV,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;IACd,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;;IAEI,sBAAsB;IACtB,8BAA8B;IAC9B,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,YAAY;;IAEZ,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;;AAExB;;AAEA;;;GAGG;AACH;IACI,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;IAEtB,cAAc;;AAElB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,qCAAqC;;;IAGrC,sBAAsB;IACtB,kCAAkC;IAClC,yBAAyB;IACzB,YAAY;;AAEhB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sCAAsC;IACtC;gCAC4B;IAC5B,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,qBAAqB;;IAErB,oBAAoB;;IAEpB,cAAc;;;AAGlB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;;IAEnB,oBAAoB;;IAEpB,cAAc;;AAElB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,UAAU;IACV,kBAAkB;;IAElB,SAAS;IAET,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,4BAA4B;;;IAG5B,qBAAqB;IACrB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,sBAAsB;;IAEtB,oBAAoB;;IAEpB,cAAc;;AAElB;;AAEA;IACI,6BAA6B;;AAEjC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,SAAS;;IAET,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;;IAE/B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,oBAAoB;;IAEpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;IAC/B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;;IAEb,+BAA+B;;IAE/B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;;AAElB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;;IAEtB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;;IAEtB,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,kBAAkB;IAClB,sBAAsB;;IAEtB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,qCAAqC;;IAErC,sBAAsB;IACtB,gCAAgC;IAChC,cAAc;;AAElB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;;IAEzC,UAAU;IACV,+BAA+B;IAC/B,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;;IAEjB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;;IAEzB,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;;;IAGrB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;IAC7B,YAAY;;AAEhB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;AACA;;AAEA;;IAEI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;IAEtB,cAAc;;IAEd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,iBAAiB;;IAEjB,WAAW;;IAEX,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;;IAG5B,qBAAqB;IACrB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;IAChB,uBAAuB;;IAEvB,sBAAsB;;IAEtB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,sBAAsB;;IAEtB,WAAW;;IAEX,cAAc;;AAElB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,mCAAmC;IACnC,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,cAAc;IACd,cAAc;;;AAGlB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;;AAElB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,0BAA0B;IAC1B,oDAAoD;;AAExD;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,uBAAuB;IACvB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;;AAEjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,YAAY;IACZ,qBAAqB;;IAErB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;;IAEtB,oBAAoB;;IAEpB,cAAc;;AAElB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;;IAEtB,oBAAoB;;IAEpB,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,UAAU;IACV,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;IAGI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;;;;uCAImC;AACvC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;;IAEhB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,qCAAqC;;;IAGrC,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC;eACW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,WAAW;AACf;;AAEA,yBAAyB;AACzB,qBAAqB;AACrB,IAAI;;AAEJ;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,YAAY;IACZ;sBACkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;IAChC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;IAChB,sBAAsB;;IAEtB,oBAAoB;;IAEpB,cAAc;IACd,sBAAsB;;AAE1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;IAChB,sBAAsB;;IAEtB,oBAAoB;;IAEpB,cAAc;IACd,sBAAsB;;AAE1B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;;IAEpB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,uDAAuD;IACvD,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;IACZ,uBAAuB;IACvB,oCAAoC;IACpC,sCAAsC;IACtC,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;;IAErB,cAAc;;AAElB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;IAEI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,qBAAqB;;AAEzB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;GAEG;AACH;IACI,6DAAiD;IACjD,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAET,gCAAgC;AACpC;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,cAAc;;IAEd,iBAAiB;;AAErB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,qCAAqC;IACrC,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,SAAS;IAET,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;;;IAGI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,mBAAmB;;AAEvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;IAEI,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,uBAAuB;;IAEvB,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,kBAAkB;;AAEtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;;uCAEmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,wCAAwC;IACxC,2BAA2B;AAC/B;;;AAGA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oDAAoD;IACpD,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IAEZ,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,YAAY;IAEZ,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,gBAAgB;IAChB,qBAAqB;;IAErB,oBAAoB;;IAEpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,qCAAqC;;IAErC,gBAAgB;;IAEhB,oBAAoB;;IAEpB,cAAc;;AAElB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;;;IAGf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;;IAErB,aAAa;;IAEb,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;;IAGZ,aAAa;IACb,mBAAmB;IACnB,qBAAqB;;IAErB,aAAa;;IAEb,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oCAAoC;;IAEpC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,6BAA6B;IAC7B,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,qCAAqC;;;IAGrC,qBAAqB;IACrB,YAAY;IACZ,cAAc;;;AAGlB;;AAEA;;IAEI,cAAc;IACd,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,gBAAgB;IAChB,qBAAqB;;IAErB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;;IAEI,cAAc;IACd,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;;IAElB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;;IAE9B,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,+BAA+B;;IAE/B,oBAAoB;;IAEpB,cAAc;;AAElB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,kBAAkB;IAClB,sBAAsB;;IAEtB,oBAAoB;;IAEpB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;;IAEzB,oBAAoB;;IAEpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,oBAAoB;;AAExB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;;AAEnC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;;AAEf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;;IAEX,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,YAAY;IACZ,qBAAqB;IACrB,gCAAgC;IAChC,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,YAAY;IACZ,gCAAgC;IAChC,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;;AAElB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,qBAAqB;;IAErB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,gCAAgC;IAChC,qBAAqB;;IAErB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,oBAAoB;IAKpB,yBAAyB;IACzB,mBAAmB;;;AAGvB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,gCAAgC;IAChC,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;;AAElB;;;AAGA;;IAEI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,WAAW;;AAEf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;;IAEI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;;IAEI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;IACZ,gBAAgB;;IAEhB,oBAAoB;;IAEpB,cAAc;IACd,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;;IAEzB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;;IAEjB,gBAAgB;;IAEhB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;IAEtB,cAAc;;IAEd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;;IAEX,mBAAmB;IACnB,sBAAsB;;IAEtB,WAAW;;IAEX,cAAc;AAClB;;AAEA;;IAEI,WAAW;;IAEX,cAAc;AAClB;;AAEA;;;IAGI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;;IAElB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;;AAEb;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,WAAW;;IAEX,cAAc;;AAElB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;;IAElB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,oBAAoB;;AAExB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;;AAE1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;;IAEI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,SAAS;IAET,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;;IAElB,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,YAAY;IACZ,aAAa;;;IAGb,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,mBAAmB;IACnB,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,qBAAqB;;IAErB,cAAc;;AAElB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,qBAAqB;;IAErB,cAAc;;AAElB;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;;IAElB,cAAc;IACd,eAAe;IACf,iBAAiB;;;AAGrB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;;IAEtB,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,iBAAiB;IACjB,sBAAsB;;IAEtB,cAAc;;AAElB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,iCAAiC;IACjC,uBAAuB;IACvB,4BAA4B;IAC5B,yBAAyB;IACzB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,oCAAoC;;;IAGpC,iCAAiC;;IAEjC,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,qBAAqB;;IAErB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC;;yBAEqB;IACrB,sBAAsB;;IAEtB,oBAAoB;;IAEpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI;qCACiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;;IAEnB,sBAAsB;;IAEtB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,UAAU;;IAEV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,UAAU;IACV,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;;AAE1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;;IAEvB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,qCAAqC;;;IAGrC,uBAAuB;;;IAGvB,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,WAAW;;AAEf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;;IAEI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA,wCAAwC;AACxC;;IAEI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;;IAEtB,sBAAsB;IACtB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;IACtB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,gBAAgB;IAChB,qBAAqB;;IAErB,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,sBAAsB;IACtB,+BAA+B;;IAE/B,WAAW;;IAEX,cAAc;;AAElB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,sBAAsB;;IAEtB,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,iBAAiB;IACjB,sBAAsB;;IAEtB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;IAEI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,iBAAiB;IACjB,sBAAsB;;IAEtB,cAAc;;IAEd,YAAY;IACZ,cAAc;AAClB;;AAEA,sCAAsC;AACtC,8BAA8B;AAC9B;IACI,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;;IAEzB,oBAAoB;;IAEpB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;;IAElB,sBAAsB;;IAEtB,oBAAoB;;IAEpB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;;IAEnB,WAAW;AACf;;AAEA;;;IAGI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;IAChB,qBAAqB;;IAErB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,4BAA4B;IAC5B,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;;IAEzB,cAAc;;AAElB;;AAEA;IACI,wCAAwC;IACxC,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;IAEtB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;;IAEZ,sBAAsB;;IAEtB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IAET,8BAA8B;IAC9B,aAAa;;;IAGb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA,4BAA4B;AAC5B,uCAAuC;AACvC;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,iBAAiB;IACjB,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA,uCAAuC;AACvC,oCAAoC;AACpC;IACI,WAAW;IACX,YAAY;IAEZ,qCAAqC;IAGrC,mCAAmC;AACvC;;AAEA;IACI,qEAAqE;IACrE,qEAAqE;IACrE,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,6DAAkD;IAClD,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;;IAErB,oBAAoB;;IAEpB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qEAAqE;IACrE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,cAAc;;AAElB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;;IAEzB,oBAAoB;;IAEpB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,kBAAkB;IAClB,sBAAsB;;IAEtB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;;;AAGlB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;;IAEhB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;;IAEZ,gCAAgC;IAChC,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,qBAAqB;;IAErB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;;AAExB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,aAAa;IACb,UAAU;IACV,SAAS;IACT,sCAAsC;IACtC,cAAc;IACd,qEAAqE;IACrE,sDAAsD;IACtD,wBAAwB;IACxB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,YAAY;IACZ,+BAA+B;IAC/B,mCAAmC;IACnC,oCAAoC;IACpC,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,kCAAkC;IAClC,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oCAAoC;;;IAGpC,sBAAsB;;IAEtB,gBAAgB;;IAEhB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;;AAExB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;IAChB,cAAc;;IAEd,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;;AAGA,oCAAoC;AACpC,qCAAqC;AACrC;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;IAEtB,cAAc;IACd,sBAAsB;;AAE1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,4BAA4B;;AAEhC;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;AACxC;;;AAGA,mCAAmC;AACnC,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,UAAU;IACV,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,4BAA4B;AAC5B,+BAA+B;AAC/B;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B,2BAA2B;AAC3B,IAAI;;AAEJ,2BAA2B;AAC3B,8BAA8B;AAC9B;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B,2CAA2C;AAC3C;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,oCAAoC;IACpC,WAAW;IACX,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,gBAAgB;;AAEpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,2CAA2C;AAC3C,qCAAqC;AACrC;IACI,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;;AAEhC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,mCAAmC;AACnC,uCAAuC;AACvC;IACI,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;AAClC;;;AAGA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA,yBAAyB;AACzB;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,mBAAmB;;IAEnB,oBAAoB;;IAEpB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;;IAG5B,qBAAqB;IACrB,yBAAyB;;IAEzB,cAAc;;AAElB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;;IAG5B,qBAAqB;IACrB,yBAAyB;;IAEzB,cAAc;;AAElB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;;AAE7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,gBAAgB;IAChB,qBAAqB;;IAErB,oBAAoB;;IAEpB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,gBAAgB;IAChB,sBAAsB;;IAEtB,oBAAoB;IACpB,gBAAgB;;IAEhB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;;IAEpB,cAAc;;AAElB;;AAEA;IACI,WAAW;AACf;;AAEA,uBAAuB;;AAEvB,yBAAyB;AACzB;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,qBAAqB;;IAErB,cAAc;;IAEd,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,8BAA8B;IAC9B,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;;AAEpB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,wBAAwB;IACxB,cAAc;;AAElB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAE1B,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,OAAO;AACX;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;;IAEI,cAAc;IACd,UAAU;;AAEd;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,wBAAwB;AACxB;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA,sBAAsB;;AAEtB;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,iBAAiB;;AAErB;;;AAGA;IACI,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,cAAc;IACd,WAAW;;AAEf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sCAAsC;IACtC,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA,8BAA8B;AAC9B;IACI;QACI,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,4BAA4B;QAC5B,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,qBAAqB;QACrB,uBAAuB;QACvB,4BAA4B;IAChC;AACJ;;AAEA,4BAA4B;;AAE5B;IACI;;QAEI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;;AAGA,uBAAuB;AACvB;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ;;;AAGA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;AAEJ;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,yBAAyB;IAC7B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QAEI,qCAAqC;QACrC,mCAAmC;IACvC;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,UAAU;;QAEV,cAAc;QACd,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA,iCAAiC;IACjC,kCAAkC;IAClC,IAAI;IACJ;QACI,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;;QAEI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,wBAAwB;;QAExB,YAAY;QACZ,WAAW;IACf;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,WAAW;;IAEf;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,eAAe;QACf,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,mBAAmB;;IAEvB;;IAEA;;QAEI,mBAAmB;;IAEvB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;QAEI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;;QAEb,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iCAAiC;QACjC,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI;IACJ;;IAEA;;QAEI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gCAAgC;QAChC,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;;IAGA;QACI,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,qCAAqC;;QAErC,kBAAkB;QAClB,sBAAsB;;QAEtB,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;;IAGA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,wBAAwB;IAC5B;;;IAGA;QACI,2BAA2B;QAC3B,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,WAAW;QACX,mCAAmC;IACvC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,eAAe;QACf,wBAAwB;;IAE5B;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,cAAc;QAEd,qCAAqC;QACrC,mCAAmC;IACvC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,iBAAiB;;IAErB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;QAC1B,YAAY;;IAEhB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,SAAS;;IAEb;;IAEA;QACI,qBAAqB;QACrB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,cAAc;QACd,mCAAmC;QACnC,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;;IAGA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;AAEJ;;AAEA;IACI;QACI,gDAAgD;IACpD;;IAEA;QACI,4BAA4B;QAC5B,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;QACnB,0BAA0B;IAC9B;;IAEA;;QAEI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QAEI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;;IAEnB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;;QAEI,gBAAgB;QAChB,mBAAmB;IACvB;;;IAGA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;;QAEI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,cAAc;QACd,WAAW;QACX,QAAQ;QACR,SAAS;QAET,gCAAgC;QAChC,kBAAkB;QAClB,kBAAkB;QAClB,UAAU;IACd;AACJ;;AAEA,kBAAkB;AAClB,kBAAkB;AAClB;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;;AAE1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;;IAEI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;mBACmB;;AAEnB;;IAEI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;;AAE/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;;AAElC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;;IAEhB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;;AAElC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,SAAS;IACT,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;;IAEhB,yBAAyB;IACzB,kBAAkB;;AAEtB;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA,wBAAwB;AACxB;IACI,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,kCAAkC;AAClC,0CAA0C;AAC1C,IAAI;;AAEJ;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,YAAY;;AAEhB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,oCAAoC;;;AAGxC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,mBAAmB;AACnB;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;;IAEI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;mBACmB;;AAEnB;IACI,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;;AAE/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;;IAEnC,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;;AAElC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;;IAEhB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;;AAElC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,SAAS;IACT,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;;IAEhB,yBAAyB;IACzB,kBAAkB;;AAEtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,kCAAkC;AAClC,0CAA0C;AAC1C,IAAI;;AAEJ;IACI;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;;QAE7B,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,2BAA2B;QAC3B,mBAAmB;;IAEvB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA,mBAAmB;IACnB;QACI,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;;QAE7B,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,2BAA2B;QAC3B,mBAAmB;;IAEvB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uCAAuC;QACvC,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;QAC3B,YAAY;IAChB;;IAEA;QACI,2BAA2B;QAC3B,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA,mBAAmB;AACvB;;AAEA,kBAAkB;;AAElB,gCAAgC;AAChC;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;;;;;;OAMG;AACP;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;;;IAGhC;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;;IAE9B;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;QACI,6BAA6B;;IAEjC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;;;IAGzC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,WAAW;;IAEf;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,+CAA+C;QAC/C,gDAAgD;QAChD,uBAAuB;QACvB,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;;QAEI,sCAAsC;IAC1C;AACJ;;AAEA;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,iBAAiB;IACrB;;;IAGA;QACI,yBAAyB;QACzB,sBAAsB;;;IAG1B;;IAEA;QACI,yBAAyB;;IAE7B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,sBAAsB;QACtB,YAAY;IAChB;;IAEA;;QAEI,sBAAsB;IAC1B;;AAEJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,+CAA+C;QAC/C,+CAA+C;QAC/C,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,sCAAsC;IAC1C;;AAEJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,wCAAwC;QACxC,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,uBAAuB;QACvB,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,2BAA2B;QAC3B,eAAe;QACf,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,qBAAqB;QACrB,WAAW;IACf;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;QACzB,eAAe;IACnB;AACJ;;AAEA,8BAA8B;AAC9B,sCAAsC;AACtC;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,2DAA2D;IAC/D;;AAEJ;;AAEA;IACI;QACI,oBAAoB;QACpB,iCAAiC;IACrC;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;KACC,gBAAgB;IACjB;IACA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;IACd;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;QAGI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;QACpB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;QAC5B,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;QACnB,0BAA0B;IAC9B;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;QAEI,uBAAuB;;IAE3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,UAAU;;IAEd;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mCAAmC;QACnC,oCAAoC;QACpC,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;;QAEjB,eAAe;QACf,2BAA2B;;IAE/B;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,6BAA6B;QAC7B,6BAA6B;IACjC;;IAEA;QACI,2DAA2D;IAC/D;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,cAAc;IAClB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA,yBAAyB;IACzB,qBAAqB;IACrB,IAAI;IACJ;;QAEI,WAAW;QACX,kBAAkB;IACtB;;IAEA;;QAEI,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA,gBAAgB;;IAEhB,mBAAmB;IACnB,mCAAmC;IACnC,iCAAiC;IACjC,wBAAwB;IACxB,IAAI;;IAEJ;QACI,qCAAqC;;;IAGzC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,sBAAsB;;IAE1B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,aAAa;QACb,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI;;oBAEY;QACZ,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,YAAY;QACZ,cAAc;QACd,YAAY;QACZ,gBAAgB;IACpB;;IAEA;;QAEI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,eAAe;QACf,aAAa;QACb,YAAY;QACZ,aAAa;;;QAGb,mCAAmC;IACvC;AACJ;;AAEA;IACI;;QAEI,qBAAqB;;QAErB,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,oBAAoB;QACpB,iBAAiB;QACjB,YAAY;;IAEhB;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,cAAc;QACd,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,qBAAqB;QACrB,6BAA6B;QAC7B,WAAW;QACX,YAAY;QACZ,SAAS;QACT,sBAAsB;QACtB,kCAAkC;QAClC,MAAM;QACN,OAAO;QACP,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;;QAEI,4BAA4B;QAC5B,+BAA+B;IACnC;;AAEJ;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;;IAEA;;QAEI,oCAAoC;QACpC,uBAAuB;QACvB,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;IAEI;;QAEI,wBAAwB;QACxB,UAAU;QACV,iBAAiB;QACjB,SAAS;QACT,cAAc;QACd,SAAS;QAET,gCAAgC;QAChC,kBAAkB;IACtB;AACJ;;AAEA,+BAA+B;AAC/B,gCAAgC;AAChC,4BAA4B;AAC5B,QAAQ;AACR,IAAI;;AAEJ;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;;;;;OAKG;AACP;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,sCAAsC;;AAEtC,cAAc;AACd;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;AAC7B;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;AACvB;;AAEA,cAAc;;AAEd;IACI,eAAe;AACnB;;;AAGA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,8BAA8B;QAC9B,8BAA8B;IAClC;AACJ;AACA,UAAU;AACV;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;AACd;;AAEA;IACI;QACI,yBAAyB;QACzB,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;;QAEjB,wBAAwB;QACxB,cAAc;QACd,qBAAqB;;IAEzB;;IAEA;QACI,cAAc;QACd,yBAAyB;;IAE7B;AACJ;;AAEA;;IAEI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".projectoverview_page_container {\r\n    padding: 0px;\r\n    -webkit-padding-start: 0rem !important;\r\n    padding-inline-start: 0rem !important;\r\n    padding-inline-end: 0rem !important;\r\n}\r\n\r\n\r\nhtml {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0;\r\n    /* overflow: hidden; */\r\n    position: absolute !important;\r\n    top: 0;\r\n    left: 0;\r\n    overflow-x: hidden;\r\n    max-width: 100%;\r\n    min-height: 100% !important;\r\n}\r\n\r\nbody {\r\n    -webkit-overflow-scrolling: auto;\r\n    /* Stops scrolling immediately */\r\n    width: 100%;\r\n    margin: 0;\r\n    /*overflow: hidden;*/\r\n    position: absolute !important;\r\n    top: 0;\r\n    left: 0;\r\n    /*overflow-x: hidden;*/\r\n    max-width: 100%;\r\n    min-height: 100% !important;\r\n\r\n}\r\n\r\n.block_tb_dt li:last-child {\r\n    display: none;\r\n}\r\n\r\n.tble_fd .chakra-checkbox__control {\r\n\r\n    display: none;\r\n}\r\n\r\n.tble_fd tr td:first-child {\r\n\r\n    /*display: none;*/\r\n}\r\n\r\n.bg_strip_btn_save .chakra-text {\r\n    margin-right: 15px;\r\n}\r\n\r\nbody::-webkit-scrollbar:horizontal {\r\n    display: none;\r\n}\r\n\r\n.blog_design_mt {\r\n    margin: 30px 8px 20px !important;\r\n}\r\n\r\n.searchBox_searchPage input.ais-SearchBox-input {\r\n    -webkit-appearance: none !important;\r\n}\r\n\r\n.ProductImageSearchPage {\r\n    object-fit: contain;\r\n}\r\n\r\n\r\n.side-menuct {\r\n    padding-inline-start: 0rem !important;\r\n    padding-inline-end: 0rem !important;\r\n}\r\n\r\n.lt_pr_4sbmt_de {\r\n    display: flex;\r\n}\r\n\r\n.box_width_30 {\r\n    max-width: 450px;\r\n    width: 30%;\r\n    min-width: 300px;\r\n    background: #F7F7F7;\r\n    /* Dropy */\r\n\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.box_width_70 {\r\n    width: 100%;\r\n    min-width: 70%;\r\n    max-width: 100%;\r\n}\r\n\r\n.List_db1 {\r\n    padding: 0px;\r\n    margin-inline-start: 0em !important;\r\n    margin: 0px;\r\n    list-style-type: none !important;\r\n}\r\n\r\n.List_main {\r\n    background-color: #592C82;\r\n    height: 88px;\r\n    display: block;\r\n    text-align: left;\r\n\r\n}\r\n\r\n.content__block_brandpage {\r\n    margin-top: 75px !important;\r\n    margin-bottom: 75px !important;\r\n}\r\n\r\n.List_main {\r\n    background-color: #592C82 !important;\r\n    height: 88px;\r\n    display: block;\r\n    text-align: left;\r\n    font-weight: 700;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 100% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 30px;\r\n    letter-spacing: 0.18px;\r\n    border: 0px solid #C4C4C4 !important;\r\n    color: #FFFFFF !important;\r\n}\r\n\r\n.List_main .chakra-avatar {\r\n    background-color: transparent;\r\n    max-width: 36px;\r\n    margin-right: 13px;\r\n}\r\n\r\n.List_main .user_nm_db {\r\n    padding-top: 4px;\r\n\r\n}\r\n\r\n.List_db1 {\r\n    color: #F7F7F7;\r\n    padding-bottom: 30px;\r\n}\r\n\r\n.List_db1 li {\r\n    padding: 24px 30px 24px;\r\n    /* background-color: #000; */\r\n    text-align: left;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    background-color: #fff;\r\n    color: #000000;\r\n    transition: all 0.3s ease-in;\r\n    border: 1px solid #C4C4C4;\r\n}\r\n\r\n.List_db1 li:hover {\r\n\r\n    letter-spacing: 0.15px;\r\n    border-left: 8px solid #F58220;\r\n    color: #F58220;\r\n    transition: all 0.3s ease-in;\r\n}\r\n\r\n.list_dt_01 {\r\n    height: 60px;\r\n\r\n    background: #592C82 !important;\r\n}\r\n\r\n.list_dt_01 {\r\n    font-weight: 700;\r\n    font-size: 16px !important;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    border-left: 0px solid #F58220 !important;\r\n    color: #FFFFFF !important;\r\n}\r\n\r\n.list_dt_01 .chakra-avatar {\r\n    background-color: transparent;\r\n    max-width: 36px;\r\n    margin-right: 15.5px;\r\n\r\n}\r\n\r\n/* .list_dt{\r\n\r\n\r\n} */\r\n.list_dt_01:hover {\r\n    border-left: 0px solid #F58220 !important;\r\n}\r\n\r\n.list_db2 li {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.lg_out {\r\n    background-color: transparent !important;\r\n    font-weight: 700;\r\n    font-size: 20px !important;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n\r\n    letter-spacing: 0.15px;\r\n    text-transform: inherit !important;\r\n    color: #000000 !important;\r\n    height: 76px;\r\n\r\n}\r\n\r\n.lg_out .chakra-avatar {\r\n\r\n    margin-right: 9px;\r\n}\r\n\r\n.pd_bm {\r\n    padding-bottom: 0px !important;\r\n}\r\n\r\n.project_br {\r\n    -webkit-padding-start: 0rem !important;\r\n    /* padding-inline-start: 1rem;\r\n    -webkit-padding-end: 1rem; */\r\n    padding-inline-end: 0rem !important;\r\n}\r\n\r\n.bd_crum {\r\n    background: #F2F2F2;\r\n    width: 100%;\r\n    text-align: left;\r\n    color: #000;\r\n    /* height: 107px; */\r\n    padding: 20px 43px;\r\n}\r\n\r\n.pages_project_bar_sub_heading {\r\n    font-weight: 500;\r\n    font-size: 10px;\r\n    line-height: 12px;\r\n    /* identical to box height, or 120% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 1.5px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n\r\n\r\n}\r\n\r\n.pages_project_bar_heading {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 34px;\r\n    line-height: 36px;\r\n    /* identical to box height, or 106% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n\r\n}\r\n\r\n.bd_crum .chakra-avatar {\r\n    background-color: transparent;\r\n    margin-left: 17px;\r\n}\r\n\r\n.bd_crum a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n\r\n    letter-spacing: 1.25px;\r\n    text-transform: uppercase;\r\n    color: #EC7700;\r\n    transition: all 0.3s ease-in;\r\n}\r\n\r\n.bd_crum a:hover {\r\n    transition: all 0.3s ease-in;\r\n    color: #1A1A1A;\r\n}\r\n\r\n.bg_color_acrhove {\r\n    background: #F2F2F2;\r\n    text-align: left;\r\n    margin: 20px 35px;\r\n    gap: 20px;\r\n    padding: 5px 20px;\r\n\r\n}\r\n\r\n.articleproducts_mt_content {\r\n    padding: 15px;\r\n    /* height: 100%; */\r\n    display: block;\r\n    min-height: 150px;\r\n}\r\n\r\n.articleproducts_mt {\r\n    position: relative;\r\n}\r\n\r\n.ArticleProductButton {\r\n    display: block;\r\n    padding: 7px;\r\n    width: 90%;\r\n    position: absolute;\r\n\r\n    left: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    bottom: -10px;\r\n}\r\n\r\n.productpricearticlepage {\r\n    display: none;\r\n}\r\n\r\n.bg_color_acrhove .chakra-avatar {\r\n    background-color: transparent;\r\n    max-width: 36px;\r\n    /* margin-right: 13px; */\r\n}\r\n\r\n.dt_archive {\r\n    padding-top: 0px;\r\n    display: inline-block;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    cursor: pointer;\r\n    /* identical to box height */\r\n\r\n\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.header_center_mt {\r\n    padding: 7px 0px !important;\r\n}\r\n\r\n.lt_brder {\r\n    position: relative;\r\n}\r\n\r\n.lt_brder:after {\r\n    content: '';\r\n    position: absolute;\r\n    height: 45px;\r\n    border-right: 1px solid #C4C4C4;\r\n    right: -18px;\r\n}\r\n\r\n.lt_pr {\r\n    margin-left: 27px;\r\n}\r\n\r\n.flx_sp_bt {\r\n    justify-content: end !important;\r\n    border: none !important;\r\n    padding: 5px 10px 5px !important;\r\n    margin-bottom: 0px !important;\r\n}\r\n\r\n.sp_qtdt {\r\n    width: 150px;\r\n}\r\n\r\n.color_strip {\r\n    background: #E9EAEB;\r\n    display: flex;\r\n    height: 40px;\r\n    justify-content: space-between;\r\n    padding: 12px 15px 4px;\r\n    margin: 0px 35px 0px 35px;\r\n    position: relative;\r\n}\r\n\r\n.tb_grid h2 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n\r\n    letter-spacing: 0.15px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n\r\n}\r\n\r\n.tb_grid .chakra-avatar {\r\n    background-color: transparent;\r\n\r\n}\r\n\r\n.color_strip a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    position: absolute;\r\n    right: 0px;\r\n    top: -4px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.25px;\r\n    text-decoration-line: underline;\r\n\r\n    color: #F58220 !important;\r\n}\r\n\r\n.bgFlx {\r\n    background: #F7F7F7;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 0px 34px 20px 35px;\r\n    padding: 12px 15px 4px;\r\n}\r\n\r\n.bgFlx p {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 133% */\r\n    padding: 17px 0px 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\nimg.image-360 {\r\n\r\n    height: 44px;\r\n    object-fit: contain;\r\n}\r\n\r\n.bgFlx h3 {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n    text-align: left;\r\n    padding-bottom: 40px;\r\n    color: #000000;\r\n}\r\n\r\n.wd_50_prview {\r\n    max-width: 50%;\r\n    width: 100%;\r\n}\r\n\r\n.bg_pj {\r\n    background: #E9EAEB;\r\n    /* margin: 0px 35px 0px 35px; */\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 14px 15px 10px;\r\n    position: relative;\r\n    height: 40px;\r\n}\r\n\r\n.bg_pj h2 {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 114% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n}\r\n\r\n.bg_pj a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 143% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.25px;\r\n    text-decoration-line: underline;\r\n    position: absolute;\r\n    right: 0;\r\n    top: -3px;\r\n    right: 0px;\r\n    color: #F58220;\r\n}\r\n\r\n.bg_pj .chakra-avatar {\r\n    background-color: transparent;\r\n}\r\n\r\n.dt_frman {\r\n    height: 256px;\r\n\r\n    /* margin: 0px 35px 0px 35px; */\r\n\r\n    padding: 14px 15px 10px;\r\n    background: #F7F7F7;\r\n}\r\n\r\n.dt_frman p {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 133% */\r\n    padding: 10px 0px 17px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.dt_frman ul {\r\n    list-style-type: none;\r\n    padding: 0px 0px 0px 0px;\r\n    margin: 0px;\r\n    text-align: left;\r\n}\r\n\r\n.smith_jhn {\r\n    font-style: normal;\r\n    font-weight: 700 !important;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.dt_frman li {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.space_sd {\r\n    margin: 0px 17px 0px 35px;\r\n}\r\n\r\n.chakra-modal__content .css-z7mtfw {\r\n    align-items: center;\r\n    gap: 20px;\r\n}\r\n\r\n.chakra-modal__content .orange_button_drillcut {\r\n    margin-top: 0px !important;\r\n}\r\n\r\n.space_sd1 {\r\n    margin: 0px 35px 0px 17px;\r\n}\r\n\r\n.ht_rm {\r\n    height: auto;\r\n    margin-bottom: 21px;\r\n}\r\n\r\n.lmPs {\r\n    background: #FFFFFF;\r\n    border: 0px solid #E2E2E2 !important;\r\n    border-radius: 4px;\r\n}\r\n\r\n.lmPs .checkbox__control {\r\n    border: 0px !important;;\r\n}\r\n\r\n.cl_bf {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n\r\n    padding-left: 10px;\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.st_lt {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px !important;\r\n    /* identical to box height, or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n    padding: 12px 0px 3px !important;\r\n    color: #000000;\r\n\r\n}\r\n\r\n.button_list_dt {\r\n    list-style-type: none !important;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    display: flex;\r\n    justify-content: space-around;\r\n    padding: 27px 15px 10px;\r\n}\r\n\r\n.wd_50_prview-wd-1 {\r\n    position: relative;\r\n}\r\n\r\n.button_list_dt li {\r\n    background-color: #592C82;\r\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\r\n\r\n    width: 13%;\r\n    transition: all .5s ease-in-out;\r\n    height: 104px;\r\n    position: relative;\r\n    text-align: center;\r\n}\r\n\r\n.button_list_dt li:hover {\r\n    transform: scale(1.1);\r\n}\r\n\r\n.button_list_dt span {\r\n    font-weight: 700;\r\n    font-size: 12.5px;\r\n    line-height: 20px;\r\n\r\n    text-align: center;\r\n    letter-spacing: 0.25px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.button_list_dt .chakra-avatar {\r\n    background-color: transparent;\r\n    display: block;\r\n    margin: 0px auto;\r\n    margin-top: 17px;\r\n}\r\n\r\n.button_list_dt img {\r\n    border-radius: 0px !important;\r\n}\r\n\r\n.projcts_lt {\r\n    height: 80px;\r\n    position: relative;\r\n    padding-left: 20px;\r\n}\r\n\r\n.projcts_lt:after {\r\n    position: absolute;\r\n    content: '';\r\n    left: 0px;\r\n    height: 100%;\r\n    border-left: 8px solid #F58220 !important;\r\n}\r\n\r\n.mob_v {\r\n    padding-left: 10px;\r\n}\r\n\r\n.hd_dtp {\r\n    display: none;\r\n}\r\n\r\n.options_txt {\r\n    background: #F2F2F2;\r\n    height: 60px;\r\n    margin: 20px 35px;\r\n    padding: 5px 20px;\r\n}\r\n\r\n.options_txt p {\r\n\r\n    text-align: left;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.options_txt .chakra-avatar {\r\n    background-color: transparent;\r\n}\r\n\r\n.options_txt {\r\n    display: none;\r\n}\r\n\r\n.rmv_brder {\r\n    position: inherit;\r\n}\r\n\r\n/* qoutes page css start */\r\n.tab_bar {\r\n    background: #592C82;\r\n    height: 49px;\r\n    color: #fff;\r\n    margin: 20px 35px;\r\n    border-bottom: none !important;\r\n}\r\n\r\n.tab_bar button {\r\n    text-transform: uppercase;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 13px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    /* color: #FFFFFF; */\r\n    padding-top: 11px;\r\n    opacity: 0.5;\r\n}\r\n\r\n.search_filter {\r\n    width: auto !important;\r\n}\r\n\r\n.tab_bar button[aria-selected=true] {\r\n    color: #FFFFFF !important;\r\n    opacity: 1 !important;\r\n\r\n\r\n    position: relative;\r\n}\r\n\r\n.tab_bar button[aria-selected=true]:after {\r\n    width: 0;\r\n    position: absolute;\r\n    content: '';\r\n    height: 0;\r\n    border-left: 8px solid transparent;\r\n    border-right: 8px solid transparent;\r\n    border-bottom: 9px solid #fff;\r\n    bottom: -1px;\r\n\r\n}\r\n\r\n.search_filter input {\r\n    background: #FFFFFF;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n    width: 330px;\r\n    /* width: 100%; */\r\n    height: 40px;\r\n    position: relative;\r\n    padding-left: 40px;\r\n    font-size: 12px;\r\n}\r\n\r\n.search_filter input {\r\n}\r\n\r\n.search_filter input:focus,\r\n.search_filter input[data-focus] {\r\n    box-shadow: none !important;\r\n    border-color: #C4C4C4 !important;\r\n}\r\n\r\n.search_filter input::placeholder {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 133% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #000000;\r\n\r\n    opacity: 0.5;\r\n}\r\n\r\n.bx_flx_filt {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 0px 19px;\r\n}\r\n\r\n.bx_flx_filt img {\r\n    position: absolute;\r\n    z-index: 9;\r\n    top: 11px;\r\n    left: 13px;\r\n}\r\n\r\n.tab_dt {\r\n    padding-top: 0px !important;\r\n}\r\n\r\n.tab_dt a {\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    /* identical to box height, or 373% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: right;\r\n\r\n    /* Orange */\r\n\r\n    color: #EC7700;\r\n}\r\n\r\n.footer_logo_main_logo {\r\n    max-width: 241px;\r\n    width: 100%;\r\n}\r\n\r\n.tble_dt {\r\n    margin: 5px 19px;\r\n}\r\n\r\n.tble_dt th {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n\r\n\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.tble_dt td {\r\n    font-weight: 300;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 143% */\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n    padding-top: 12px;\r\n    padding-bottom: 12px;\r\n    border-bottom: 0px !important;\r\n    position: relative;\r\n}\r\n\r\n.tble_dt span {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    /* Orange */\r\n\r\n    color: #EC7700;\r\n\r\n}\r\n\r\n.main_th {\r\n    background: #E9EAEB;\r\n}\r\n\r\n.tble_dt tr:nth-child(even) {\r\n    background: #F2F2F2;\r\n}\r\n\r\n.hd_menu {\r\n    display: none;\r\n}\r\n\r\n.block_tb_dt {\r\n    padding: 0px;\r\n    margin: 0px;\r\n    background: #F2F2F2;\r\n    list-style-type: none !important;\r\n    margin-inline-start: 0em !important;\r\n    padding: 29px 15px 15px;\r\n    display: none;\r\n    margin-bottom: 11px;\r\n}\r\n\r\n.lt_tbl_mb {\r\n    margin-bottom: 127px;\r\n}\r\n\r\n.block_tb_dt p {\r\n\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    width: 35%;\r\n    min-width: 35%;\r\n    display: block;\r\n\r\n\r\n}\r\n\r\n.block_tb_dt span {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.block_tb_dt li {\r\n    display: flex;\r\n    text-align: left;\r\n    height: 27px;\r\n}\r\n\r\n.block_tb_dt button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    /* line-height: 56px; */\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    text-transform: uppercase;\r\n    width: 100%;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    height: 24px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.block_tb_dt button:hover {\r\n    color: #EC7700;\r\n\r\n}\r\n\r\n.block_tb_dt button:focus,\r\n.block_tb_dt button[data-focus] {\r\n    box-shadow: none !important;\r\n}\r\n\r\n.model_dt {\r\n\r\n    background: #F2F2F2 !important;\r\n    border: 10px solid #F2F2F2;\r\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%) !important;\r\n\r\n}\r\n\r\n.model_dt h2 {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n    display: block;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.15px;\r\n    padding-top: 25px;\r\n\r\n}\r\n\r\n.model_dt p {\r\n    font-weight: 300;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    padding-top: 18px;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.model_dt button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 14px;\r\n    /* or 93% */\r\n    /* max-width: 154px; */\r\n    height: 44px;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    margin: 0px 5px;\r\n    color: #FFFFFF;\r\n    transition: all 0.3s ease-in;\r\n    border: 1px solid transparent;\r\n}\r\n\r\n.model_dt button:hover {\r\n    color: #EC7700;\r\n    background-color: #FFFFFF;\r\n    transition: all 0.3s ease-in;\r\n    border: 1px solid rgb(185, 185, 185);\r\n}\r\n\r\n.model_dt button:focus,\r\n.model_dt button[data-focus] {\r\n    box-shadow: none !important;\r\n}\r\n\r\n.model_dt .chakra-modal__footer {\r\n    justify-content: center;\r\n}\r\n\r\n..half_width_class_mt {\r\n    width: 50%;\r\n}\r\n\r\n.model_dt span {\r\n    font-weight: 300;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* display: inline-block; */\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.25px;\r\n    text-decoration-line: underline;\r\n    color: #000000;\r\n    padding: 5px 0px 25px;\r\n    cursor: pointer;\r\n}\r\n\r\n.flx_bx_stp {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.flx_bx_stp .chakra-avatar {\r\n    margin-right: 2px;\r\n}\r\n\r\n.cstm_project {\r\n    max-height: 190px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.cstm_project a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.25px;\r\n    text-decoration-line: underline;\r\n    color: #F58220;\r\n    padding: 10px 0px 16px;\r\n}\r\n\r\n.option_form {\r\n    margin: 20px 35px 0px 35px;\r\n}\r\n\r\n.bg_form_qoutes {\r\n    background: #F6F6F6;\r\n    padding: 30px 15px 1px;\r\n}\r\n\r\n.bg_form_qoutes .chakra-switch__track {\r\n    background: #fff;\r\n    border: 1px solid #E2E2E2;\r\n}\r\n\r\n.bg_form_qoutes .chakra-switch__thumb {\r\n    background: #EC7700 !important;\r\n}\r\n\r\n.bg_form_qoutes .chakra-switch__track[aria-checked=true],\r\n.bg_form_qoutes .chakra-switch__track[data-checked] {\r\n    border: none !important;\r\n    box-shadow: none !important;\r\n    background: #e9eaeb !important;\r\n}\r\n\r\n.bg_form_qoutes .chakra-switch__track[data-focus] {\r\n    box-shadow: none !important;\r\n}\r\n\r\n.bg_form_qoutes p {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n\r\n\r\n    letter-spacing: 0.15px;\r\n    padding: 4px 0px 0px 14px;\r\n    color: #000000;\r\n}\r\n\r\n.form_options_block label {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 9px;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n}\r\n\r\n.form_options_block input {\r\n    background: #FFFFFF;\r\n    border-radius: 5px;\r\n\r\n}\r\n\r\n.form_options_block textarea {\r\n    background: #FFFFFF;\r\n    border-radius: 5px;\r\n    height: 121px;\r\n\r\n}\r\n\r\n.form_options_block {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.tg_switchblck {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.form_options_block input:focus,\r\n.form_options_block input[data-focus] {\r\n    z-index: 1;\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n}\r\n\r\n.form_options_block textarea:focus,\r\n.form_options_block textarea[data-focus] {\r\n    z-index: 1;\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n}\r\n\r\n.option_table thead {\r\n    background: #F2F2F2;\r\n    height: 49px;\r\n\r\n}\r\n\r\n.warning_table thead {\r\n    background: #FF000060;\r\n    height: 49px;\r\n}\r\n\r\n.warning_table tr:nth-child(even) {\r\n    background: rgb(255 0 0 / 40%);\r\n}\r\n\r\n.warning_table tr:nth-child(odd) {\r\n    background: rgb(255 0 0 / 20%);\r\n}\r\n\r\n.option_table {\r\n    margin-top: 7px;\r\n}\r\n\r\n.option_table th {\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n}\r\n\r\n.option_table input {\r\n    background: #F2F2F2;\r\n    border-radius: 5px;\r\n    height: 40px;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    /* identical to box height, or 100% */\r\n\r\n    border: none;\r\n    letter-spacing: 0.1px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.dt_ip_wd {\r\n    max-width: 85px;\r\n    width: 100%;\r\n    text-align: center;\r\n    font-weight: 700 !important;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 171% */\r\n\r\n\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.18px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n\r\n}\r\n\r\n.option_table td {\r\n    border-bottom: 0px !important;\r\n}\r\n\r\n.option_table .chakra-avatar {\r\n    background-color: transparent;\r\n}\r\n\r\n.price_inline_td {\r\n    font-weight: 700 !important;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 171% */\r\n\r\n\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.18px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n}\r\n\r\n.option_table tr:nth-child(even) {\r\n    background: rgb(242 242 242 / 50%);\r\n}\r\n\r\n.option_table input:focus,\r\n.option_table input[data-focus] {\r\n    z-index: 1;\r\n    /*border-color: transparent !important;*/\r\n    box-shadow: none !important;\r\n}\r\n\r\n.price_dt a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.25px;\r\n    text-decoration-line: underline;\r\n    color: #F58220;\r\n    margin: 70px 0px 9px;\r\n}\r\n\r\n.overlaybody {\r\n    z-index: auto !important;\r\n}\r\n\r\n.price_dt {\r\n\r\n\r\n    border-bottom: 1px solid #C4C4C4;\r\n}\r\n\r\n.price_dt_summry {\r\n    list-style-type: none !important;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    float: right;\r\n    margin-top: 50px;\r\n    margin-right: 70px;\r\n}\r\n\r\n.option_table .css-womqfz {\r\n    /* right: 0px;\r\n    top: 527px;\r\n    left: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%); */\r\n}\r\n\r\n.price_dt_summry li {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.price_tl_pr {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n    /* float:left; */\r\n\r\n    letter-spacing: 0.15px;\r\n    text-align: left;\r\n    color: #000000;\r\n\r\n}\r\n\r\n.option_table th:first-child {\r\n    width: 148px;\r\n}\r\n\r\n.option_table th:nth-child(2) {\r\n    width: 148px;\r\n}\r\n\r\n.price_tl_pr1 {\r\n    width: 150px;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    /* float:right; */\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n\r\n    text-align: right;\r\n    letter-spacing: 0.15px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    color: #000000;\r\n\r\n}\r\n\r\n.gst_bl {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n    /* text-align: left; */\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    float: left;\r\n    color: #000000;\r\n}\r\n\r\n.gst_bl_inside {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n    /* text-align: left; */\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.gst_bl_1 {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n    /* text-align: right;\r\nfloat: right; */\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    text-align: right;\r\n    display: block;\r\n    color: #000000;\r\n}\r\n\r\n.slider_image_mt {\r\n    background-size: contain;\r\n    /*height: 400px;*/\r\n    width: 100%;\r\n}\r\n\r\n/*.slider_image_mt img {*/\r\n/*    height: 400px;*/\r\n/*}*/\r\n\r\n.drillcuttv_popup_close_btn {\r\n    z-index: 9;\r\n}\r\n\r\n.chakra-popover__popper.css-1qq679y {\r\n    z-index: 1500 !important;\r\n}\r\n\r\n.price_dt_summry li:last-child {\r\n    margin-top: 30px;\r\n    margin-bottom: 75px;\r\n}\r\n\r\n.spec_table {\r\n    border: 1.5px solid #C4C4C4;\r\n    overflow-x: auto;\r\n}\r\n\r\n.spec_card {\r\n    border-top: 1px solid #C4C4C4;\r\n    padding-bottom: 33px;\r\n    margin: 40px 100px 0;\r\n}\r\n\r\n.spec_table th {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 114% */\r\n    height: 50px;\r\n    /* display: flex;\r\nalign-items: center; */\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    color: #000000;\r\n\r\n}\r\n\r\n.spec_table td {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    letter-spacing: 0.1px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    color: #000000;\r\n    text-align: left;\r\n}\r\n\r\n.spec_card h2 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 100% */\r\n    text-align: left;\r\n    letter-spacing: 0.18px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n    padding: 25px 0px 20px;\r\n\r\n}\r\n\r\n.spec_card h3 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 100% */\r\n    text-align: left;\r\n    letter-spacing: 0.18px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n    padding: 25px 0px 20px;\r\n\r\n}\r\n\r\n.spec_card .chakra-table__container {\r\n    /*max-width: 1000px;*/\r\n    width: 100%;\r\n    margin: 0px auto;\r\n    display: block;\r\n}\r\n\r\n.block_feat_inner {\r\n    width: 100%;\r\n    margin: 0px auto;\r\n    display: block;\r\n}\r\n\r\n.block_feat h2 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 100% */\r\n\r\n    letter-spacing: 0.18px;\r\n    text-align: left;\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n}\r\n\r\n.block_feat p {\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n    text-align: left;\r\n    letter-spacing: 0.25px;\r\n    color: #000000;\r\n    padding-top: 10px;\r\n}\r\n\r\n.block_feat {\r\n    border-bottom: 1px solid #C4C4C4;\r\n    padding-bottom: 27px;\r\n    margin: 40px 100px 33px;\r\n}\r\n\r\n.btn_1dwnlod {\r\n    background: #FFFFFF !important;\r\n    border-radius: 5px;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25) !important;\r\n    margin-right: 23px;\r\n    transition: all 0.3s ease-in;\r\n    padding: 0px;\r\n    height: 58px !important;\r\n    padding-inline-start: 0px !important;;\r\n    justify-content: flex-start !important;\r\n    width: 325px !important;;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n    margin-top: 16px;\r\n    letter-spacing: 0.1px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.mb_hd_rill {\r\n    display: none;\r\n}\r\n\r\n.btn_1dwnlod:hover {\r\n    transition: all 0.3s ease-in;\r\n    background: #fcfcfc !important;\r\n}\r\n\r\n.btn_1dwnlod span {\r\n    background: #F2F2F2;\r\n    padding: 10px;\r\n    border-top-left-radius: 5px;\r\n    border-bottom-left-radius: 5px;\r\n    margin-right: 33px;\r\n}\r\n\r\n.productImageBackground {\r\n\r\n    height: auto !important;\r\n    justify-content: center;\r\n}\r\n\r\n.collectionImage {\r\n    height: auto !important;\r\n}\r\n\r\n.collection_title_collectionPage {\r\n\r\n    padding-bottom: 16px !important;\r\n}\r\n\r\n.brand_logo_aboutuspage {\r\n    max-width: 1000px;\r\n}\r\n\r\n.css-1nravos {\r\n    max-width: 320px;\r\n    margin-bottom: 0px;\r\n    box-shadow: 3px 3px 4px rgb(0 0 0 / 25%);\r\n}\r\n\r\n.brand__page .brands_image.css-1nravos a {\r\n    padding: 10px;\r\n    min-width: 237px !important;\r\n    background: #EC7700;\r\n    font-size: 10px;\r\n    padding: 0 !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.brand__page .brands_image .css-0 a {\r\n    font-size: 14px !important;\r\n    font-weight: bold;\r\n    letter-spacing: 0.5px;\r\n\r\n}\r\n\r\n.brand__page .brands_image img, .bg_image img {\r\n    width: 100%;\r\n    max-width: 237px;\r\n    min-height: 210px;\r\n    object-fit: contain;\r\n    background: #f1f1f1;\r\n}\r\n\r\n.brands_image img,\r\n.bg_image img {\r\n    width: 100%;\r\n    max-width: 160px;\r\n    min-height: 166px;\r\n    object-fit: contain;\r\n    background: #f1f1f1;\r\n}\r\n\r\n.brands_image p {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: initial;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 6;\r\n    -webkit-box-orient: vertical;\r\n    font-size: 10px;\r\n    line-height: 14px;\r\n    padding: 30px 15px;\r\n}\r\n\r\n.css-1wkijx5 .brands_image {\r\n\r\n    margin-bottom: 0px !important;\r\n}\r\n\r\n.brand_logo_aboutuspage .css-70qvj9 .css-0 a {\r\n    /* background: #000; */\r\n    background: #ec7700;\r\n    border-radius: 5px;\r\n    display: block;\r\n    height: 22px;\r\n    line-height: 30px;\r\n    margin: 20px auto auto;\r\n    min-width: 0 !important;\r\n    min-width: auto !important;\r\n    padding: 84px;\r\n    max-width: 173px;\r\n    width: 100%;\r\n    height: 32px;\r\n    position: absolute;\r\n    left: 0px;\r\n    right: 0px;\r\n    bottom: -55px\r\n}\r\n\r\n.brand__page .brands_image .css-0 {\r\n    position: relative;\r\n}\r\n\r\n.btn_1dwnlod img {\r\n    max-width: 34px;\r\n}\r\n\r\n.bg_color_btn_dwn span {\r\n    background: #EC7700 !important;\r\n}\r\n\r\n.bloc_two_feat {\r\n    padding-bottom: 0;\r\n    border-bottom: none;\r\n}\r\n\r\n.top_border {\r\n    border-top: 1px solid #C4C4C4;\r\n    padding-top: 25px;\r\n    margin-top: 25px;\r\n}\r\n\r\n.bot_border {\r\n    border-bottom: 1px solid #C4C4C4;\r\n    padding-bottom: 25px;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.top_border_only {\r\n    border-bottom: 1px solid #C4C4C4;\r\n}\r\n\r\n.pd_rm_signup {\r\n    padding: 0px !important;\r\n}\r\n\r\n.signUp_tb button {\r\n    width: 100%;\r\n    background: #F2F2F2;\r\n    border-radius: 10px 10px 0px 0px;\r\n    border: none;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #1A1A1A;\r\n}\r\n\r\n.signUp_tb button:focus,\r\n.signUp_tb button[data-focus] {\r\n    box-shadow: none !important;\r\n}\r\n\r\n.signUp_tb .chakra-tabs__tab-panels {\r\n    background: #cbd5e0;\r\n}\r\n\r\n.signUp_tb {\r\n    margin-top: 60px;\r\n}\r\n\r\n.pd_lft_signup {\r\n    padding: 0px 16px;\r\n}\r\n\r\n/* .signUp_tb .form_controll{\r\n    grid-gap: inherit!important;\r\n} */\r\n.video_block_bg_img {\r\n    background: url(./image/login_page.jpg) no-repeat;\r\n    position: relative;\r\n    max-width: 670px;\r\n    width: 100%;\r\n    margin: 0px auto;\r\n    display: block;\r\n    background-position: center center;\r\n    background-size: cover;\r\n    height: 380px;\r\n}\r\n\r\n.video_block_bg_img:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    background: rgba(242, 242, 242, 0.5);\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\n\r\n.video_block_bg_img img {\r\n    z-index: 999;\r\n    position: absolute;\r\n    background-color: #fff;\r\n    border-radius: 50%;\r\n    top: 45%;\r\n    left: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.video_block_bg_img p {\r\n\r\n    position: absolute;\r\n    bottom: 0px;\r\n    background-color: #eee;\r\n    font-weight: 700;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    letter-spacing: 0.18px;\r\n    color: #1A1A1A;\r\n    height: 85px;\r\n    /* top: 50%; */\r\n\r\n    padding-top: 29px;\r\n\r\n}\r\n\r\n.video_block {\r\n    border-bottom: 1px solid #C4C4C4;\r\n    padding-bottom: 44px;\r\n    margin: 40px 100px 33px;\r\n}\r\n\r\n.rectangle-bottom:after {\r\n    display: block;\r\n    height: 0px;\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 100%;\r\n    border-left: 38.5px solid transparent;\r\n    border-right: 38.5px solid transparent;\r\n    border-top: 21px solid #1384b8;\r\n}\r\n\r\n.rect_bx_ribon {\r\n    background-color: #1384B8;\r\n    max-width: 77px;\r\n    /* position: relative; */\r\n    /* height: 200px; */\r\n    position: absolute;\r\n    width: 77px;\r\n    right: 6px;\r\n    z-index: 99;\r\n}\r\n\r\n.card_bloc_slider {\r\n    position: relative;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.productContent {\r\n    position: relative;\r\n}\r\n\r\n.productContent span,\r\n.card_bloc_slider span {\r\n    background: #F5C582;\r\n    border-radius: 3px;\r\n    /* padding: 10px 20px; */\r\n    position: absolute;\r\n    left: 10px;\r\n    height: 20px;\r\n    width: 63px;\r\n    font-weight: 700;\r\n    font-size: 9px;\r\n    line-height: 21px;\r\n    /* display: flex; */\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n    color: #4D4D4D;\r\n    top: -11px;\r\n}\r\n\r\n.productContent span {\r\n    width: 80px;\r\n}\r\n\r\n.rect_bx_ribon p {\r\n\r\n    font-weight: 700;\r\n    font-size: 11px;\r\n    line-height: 13px;\r\n    /* display: flex; */\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    text-align: center;\r\n    position: relative;\r\n    padding-top: 7px;\r\n}\r\n\r\n.main_slider_block {\r\n\r\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\r\n    margin: 0px 10px;\r\n}\r\n\r\n.Img_block_pd_slide {\r\n    background: #F2F2F2;\r\n    position: relative;\r\n    height: 191px;\r\n}\r\n\r\n.rect_bx_ribon {\r\n    margin: 0px auto;\r\n}\r\n\r\n.card_bloc_slider {\r\n    position: relative;\r\n}\r\n\r\n.Img_block_pd_slide img {\r\n    top: 50%;\r\n    left: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    position: absolute;\r\n}\r\n\r\n.card_bloc_slider h2 {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    color: #592C82;\r\n    padding-top: 7px;\r\n    text-align: left;\r\n}\r\n\r\n.card_bloc_slider p {\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 10px;\r\n    line-height: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 1.5px;\r\n    color: #4D4D4D;\r\n    padding-top: 2px;\r\n}\r\n\r\n.card_bloc_slider a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    /* display: flex; */\r\n    text-align: right;\r\n    letter-spacing: 0.18px;\r\n    text-decoration-line: underline;\r\n    color: #1A1A1A;\r\n    text-align: right;\r\n    display: block;\r\n    padding-top: 5px;\r\n}\r\n\r\n.card_bloc_slider button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    width: 100%;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    transition: all 0.3s ease-in;\r\n    margin: 10px 0px;\r\n}\r\n\r\n.card_bloc_slider button:focus,\r\n.card_bloc_slider button[data-focus] {\r\n\r\n    box-shadow: none !important;\r\n}\r\n\r\n.card_bloc_slider button:hover {\r\n    color: #EC7700;\r\n    background: #fcfcfc;\r\n\r\n}\r\n\r\n.cstm_slider_pd .slick-dots li button {\r\n    width: 16px !important;\r\n    height: 16px !important;\r\n}\r\n\r\n.cstm_slider_pd .slick-dots li button:before {\r\n\r\n    font-size: 16px !important;\r\n    opacity: 1 !important;\r\n    color: #f2f2f2 !important;\r\n}\r\n\r\n.cstm_slider_pd .slick-dots li.slick-active button:before {\r\n    color: #EC7700 !important;\r\n}\r\n\r\n.wd_60_pd_slider {\r\n    max-width: 60%;\r\n    width: 100%;\r\n    background-color: #f2f2f2;\r\n    overflow: hidden;\r\n}\r\n\r\n.wd_40_pd_details {\r\n\r\n    max-width: 40%;\r\n    width: 100%;\r\n    padding: 57px 40px 30px;\r\n\r\n    max-width: 40%;\r\n    width: 100%;\r\n    padding: 57px 40px 30px;\r\n    position: relative;\r\n\r\n}\r\n\r\n\r\n.main_slider_block_prduct {\r\n    height: 554px;\r\n    background: #F2F2F2;\r\n    position: relative;\r\n}\r\n\r\n.Img_block_pd_slide_prduct img {\r\n    /* top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%); */\r\n    position: absolute;\r\n}\r\n\r\n.zoom-root-container img + div + div {\r\n    z-index: 33 !important;\r\n    width: 1460px !important;\r\n    height: 1186px !important;\r\n    left: 0 !important;\r\n    margin-left: 0 !important;\r\n}\r\n\r\n.slick_dt_pd_main .slick-dots {\r\n    bottom: 20px !important;\r\n\r\n}\r\n\r\n.right_arrow_pd_cp {\r\n    /*right: 225px !important;*/\r\n    top: 50% !important;\r\n    background-color: transparent !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n\r\n.slick_dt_pd_main .slick-dots li button:before {\r\n    font-size: 16px !important;\r\n    opacity: 1 !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.right_arrow_pd_cp svg {\r\n    fill: #C4C4C4;\r\n}\r\n\r\n.left_arrow_pd_cp svg {\r\n    fill: #C4C4C4;\r\n}\r\n\r\n.main_block_slider {\r\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%) !important;\r\n    display: flex;\r\n    margin: 40px 101px 0px;\r\n    /* overflow: hidden; */\r\n}\r\n\r\n.cstm_pslider {\r\n    padding: 0px;\r\n    -webkit-padding-start: 0rem !important;\r\n    padding-inline-start: 0rem !important;\r\n    padding-inline-end: 0rem !important;\r\n}\r\n\r\n.cstm_pslider .mini_container_mt {\r\n    padding: 0px;\r\n    -webkit-padding-start: 0rem !important;\r\n    padding-inline-start: 0rem !important;\r\n    padding-inline-end: 0rem !important;\r\n}\r\n\r\n.cstm_pslider .Logo_icons_full_width {\r\n    padding: 0px;\r\n}\r\n\r\n.slick_dt_pd_main {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n.capliry_p {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 133% */\r\n\r\n    text-align: left;\r\n    letter-spacing: 0.4px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n}\r\n\r\n.capliry_h2 {\r\n    font-weight: 700;\r\n    font-size: 34px !important;\r\n    line-height: 36px !important;\r\n    /* identical to box height, or 106% */\r\n\r\n    text-align: left;\r\n\r\n    /* Drillcut Purple */\r\n\r\n    color: #592C82;\r\n\r\n}\r\n\r\n.capliry_span {\r\n\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 10px;\r\n    line-height: 12px;\r\n    /* or 120% */\r\n\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 12px;\r\n    line-height: 12px;\r\n    /* or 120% */\r\n    margin-top: 5px;\r\n\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 1.5px;\r\n\r\n    /* Black 70 */\r\n\r\n    color: #4D4D4D;\r\n    padding-top: 5px;\r\n}\r\n\r\n.flx_bx_stp .css-k008qs {\r\n\r\n    gap: 20px;\r\n}\r\n\r\n.brand__page {\r\n    max-width: 1490px;\r\n    margin-bottom: 100px;\r\n}\r\n\r\n.brand__page .css-1wkijx5 {\r\n\r\n    grid-gap: 23px 20px !important;\r\n    margin-top: 0px !important;\r\n}\r\n\r\n.brand__page p {\r\n    font-size: 14px;\r\n    line-height: 18px;\r\n    padding: 0px 15px 20px 15px !important;\r\n    height: 55px;\r\n}\r\n\r\n.content__block__brandpage {\r\n    max-width: 850px !important;\r\n    margin-top: 75px !important;\r\n    margin-bottom: 75px !important;\r\n}\r\n\r\n.capliry_span_2 {\r\n\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 10px;\r\n    line-height: 12px;\r\n    /* or 120% */\r\n\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 12px;\r\n    line-height: 12px;\r\n    /* or 120% */\r\n\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 1.5px;\r\n\r\n    /* Black 70 */\r\n\r\n    color: #4D4D4D;\r\n    padding-top: 7px;\r\n}\r\n\r\n.capliry_h3 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 30px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 80% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.18px;\r\n    padding-top: 9px;\r\n    color: #1A1A1A;\r\n}\r\n\r\n.stock_data {\r\n    position: relative;\r\n    width: 100%;\r\n    margin: 10px 0px 15px;\r\n}\r\n\r\n.stock_data select {\r\n    background: #F2F2F2;\r\n    border-radius: 2px;\r\n    border: none;\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    letter-spacing: 1.5px;\r\n    color: #1A1A1A;\r\n    padding-left: 37px;\r\n    height: 32px;\r\n    position: relative;\r\n}\r\n\r\n.stock_data select:focus,\r\n.stock_data select[data-focus] {\r\n    z-index: unset;\r\n    border-color: transparent !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.stock_data img {\r\n    position: absolute;\r\n    z-index: 8;\r\n    top: 8.3px;\r\n    left: 9px;\r\n}\r\n\r\n.capliry_p_1 {\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    letter-spacing: 0.25px;\r\n    color: #000000;\r\n    text-align: left;\r\n    margin-bottom: 37px;\r\n}\r\n\r\n.select_size {\r\n    background: #FFFFFF !important;\r\n    border: 1px solid #C4C4C4 !important;\r\n    border-radius: 5px !important;\r\n    font-weight: 400;\r\n    font-size: 14px !important;\r\n    line-height: 16px !important;\r\n    /* identical to box height, or 100% */\r\n\r\n\r\n    letter-spacing: 0.1px;\r\n    height: 32px;\r\n    color: #000000;\r\n\r\n\r\n}\r\n\r\n.select_size:focus,\r\n.select_size[data-focus] {\r\n    z-index: unset;\r\n    /* border-color: transparent!important; */\r\n    box-shadow: none !important;\r\n}\r\n\r\n.qty_flx {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 20px 0px;\r\n}\r\n\r\n.qty_flx label {\r\n    font-weight: 500;\r\n    font-size: 10px;\r\n    line-height: 12px;\r\n    /* identical to box height, or 120% */\r\n\r\n\r\n    text-align: left;\r\n    letter-spacing: 1.5px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.qty_flx input {\r\n    background: #F2F2F2;\r\n    border-radius: 5px;\r\n    height: 40px;\r\n    max-width: 80px;\r\n    width: 100%;\r\n    display: block;\r\n    text-align: center\r\n}\r\n\r\n.qty_flx .chakra-form-control {\r\n    width: auto !important;\r\n    margin-right: 14px;\r\n}\r\n\r\n.qty_flx button:focus,\r\n.qty_flx button[data-focus] {\r\n    z-index: unset;\r\n    border-color: transparent !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.qty_flx input:focus,\r\n.qty_flx input[data-focus] {\r\n    z-index: unset;\r\n    border-color: transparent !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.qty_flx button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    display: block;\r\n    transition: all 0.3s ease-in;\r\n    width: 100%;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    /* or 373% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n\r\n    color: #FFFFFF;\r\n    margin-top: 20px;\r\n}\r\n\r\n.qty_flx button:hover {\r\n    transition: all 0.3s ease-in;\r\n    background: #F2F2F2;\r\n    color: #EC7700;\r\n}\r\n\r\n.spec_dt {\r\n\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    display: flex;\r\n    justify-content: space-between;\r\n    position: absolute;\r\n    bottom: 10px;\r\n\r\n}\r\n\r\n.spec_dt a {\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    /* identical to box height, or 373% */\r\n\r\n\r\n    text-decoration-line: underline;\r\n\r\n    /* Drillcut Purple */\r\n\r\n    color: #592C82;\r\n\r\n}\r\n\r\n.mb_pd_slider {\r\n    margin-bottom: 70px;\r\n}\r\n\r\n.related_blck_slider {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 100% */\r\n\r\n    text-align: center;\r\n    letter-spacing: 0.18px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.related_blck_slider_p {\r\n\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n\r\n    text-align: center;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n}\r\n\r\n.flxe_accrdion {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.first_bx_accrdion {\r\n    max-width: 210px;\r\n    width: 33%;\r\n}\r\n\r\n.first_bx_accrdion span {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    line-height: 14px;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    opacity: 0.5;\r\n    display: block;\r\n    margin: 2px 0 10px;\r\n}\r\n\r\n.first_bx_accrdion h3 {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n    padding: 0px;\r\n    color: #000000;\r\n    margin-bottom: 26px;\r\n    margin-top: 15px;\r\n\r\n}\r\n\r\n.first_bx_accrdion p,\r\n.first_bx_accrdion h2 {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n    padding: 0px;\r\n    color: #000000;\r\n    padding-bottom: 10px;\r\n\r\n}\r\n\r\n.second_bx_accrdion span {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    line-height: 14px;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n    display: block;\r\n    color: #000000;\r\n    opacity: 0.5;\r\n    padding-bottom: 5px;;\r\n}\r\n\r\n.second_bx_accrdion h3 {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n    padding: 0px;\r\n    color: #000000;\r\n    margin-top: 15px;\r\n\r\n}\r\n\r\n.sixTmm {\r\n    margin-top: 0px !important;\r\n}\r\n\r\n.accrdion_box {\r\n    border: 1px solid #C4C4C4;\r\n}\r\n\r\n.accrdion_box .button {\r\n    border: 1px solid #C4C4C4;\r\n}\r\n\r\n.accrdion_box {\r\n    display: block;\r\n    width: 50%;\r\n}\r\n\r\n.pd_bm_main_blck {\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.model_pd {\r\n    max-width: 570px !important;\r\n    background-color: transparent !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.model_pd .ct_acc {\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    align-items: center;\r\n    display: block;\r\n    text-align: center !important;\r\n    color: #EC7700;\r\n    transition: all 0.3s ease-in;\r\n}\r\n\r\n.list_detail {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    padding-bottom: 27px;\r\n}\r\n\r\n.list_detail li {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    letter-spacing: 0.25px;\r\n    color: #000000;\r\n    text-align: left;\r\n}\r\n\r\n.list_detail span {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    letter-spacing: 0.25px;\r\n    color: #000000;\r\n    text-align: left;\r\n}\r\n\r\n.bundle_tb td {\r\n    height: 100px !important;\r\n}\r\n\r\n.cstm_arrow_lt .slick_arrows_custom_logo {\r\n\r\n    top: 43% !important;\r\n}\r\n\r\n.bundle_scond_tbl {\r\n    margin-top: 26px;\r\n}\r\n\r\n.bundle_scond_tbl td {\r\n    padding-top: 15px !important;\r\n    padding-bottom: 11px !important;\r\n\r\n}\r\n\r\n.bundle_scond_tbl button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    color: #fff;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    line-height: 56px;\r\n    /* display: flex; */\r\n    max-width: 152px;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    width: 100%;\r\n}\r\n\r\n.bundle_scond_tbl button:hover {\r\n    color: #000;\r\n}\r\n\r\n.bundle_scond_tbl button:focus,\r\n.bundle_scond_tbl button[data-focus] {\r\n    box-shadow: none !important;\r\n    border-color: #C4C4C4 !important;\r\n}\r\n\r\n.bundle_tbl_bx {\r\n    margin: 40px 180px 66px;\r\n\r\n}\r\n\r\n.last_bundleTbl-1 {\r\n    border-bottom: 1px solid #C4C4C4;\r\n    margin: 0px 100px 0px;\r\n}\r\n\r\n.table_grid_mob {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    border: 1px solid #C4C4C4;\r\n\r\n}\r\n\r\n.hd_mb_bndle {\r\n    display: none;\r\n}\r\n\r\n.left_arrow_pd_cp {\r\n    /*left: 225px !important;*/\r\n    top: 50% !important;\r\n    background-color: transparent !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.table_grid_mob ul {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n\r\n}\r\n\r\n.table_grid_mob_2 {\r\n    max-width: 33%;\r\n    width: 100%;\r\n}\r\n\r\n.table_grid_mob_1 {\r\n    max-width: 33%;\r\n    width: 100%;\r\n}\r\n\r\n.table_grid_mob_1 span {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n\r\n    letter-spacing: 0.1px;\r\n    position: relative;\r\n    bottom: 2px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.table_grid_mob_2 li {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n    height: 70px;\r\n    letter-spacing: 0.1px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    color: #000000;\r\n    padding: 10px;\r\n}\r\n\r\n.table_grid_mob_1 li {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n    height: 70px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    letter-spacing: 0.1px;\r\n    text-align: left;\r\n    color: #000000;\r\n    padding: 10px;\r\n}\r\n\r\n.table_grid_mob_2 button {\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    line-height: 56px;\r\n    /* display: flex; */\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    background-color: #ec7700;\r\n    margin-top: 6px;\r\n}\r\n\r\n.cart_container {\r\n    max-width: 1100px !important;\r\n    width: 100% !important;\r\n    margin: 0px auto;\r\n    display: block;\r\n}\r\n\r\n.prduct_image {\r\n    /*background-color: #f2f2f2;*/\r\n    display: inline-block;\r\n    height: auto;\r\n    max-width: 85px;\r\n    width: 100%;\r\n    position: relative;\r\n    /* border: 2px solid #000; */\r\n    top: -5px;\r\n}\r\n\r\n.number_bmt {\r\n    font-weight: 700;\r\n    font-size: 10px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 160% */\r\n\r\n\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.pd_name_bmt {\r\n\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    /* identical to box height, or 100% */\r\n\r\n    letter-spacing: 0.1px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.cart_container td {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    /* identical to box height, or 100% */\r\n\r\n    border-bottom: 1px solid #C4C4C4;\r\n    letter-spacing: 0.1px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.prduct_image img {\r\n    max-width: 86px;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    position: absolute;\r\n    border: 3px solid #f2f2f2;\r\n}\r\n\r\n\r\n.min-add-button {\r\n    max-width: 80px;\r\n    margin: 20px auto;\r\n}\r\n\r\n.min-add-button a {\r\n    background: #aaa;\r\n    color: #fff;\r\n    border: 0px;\r\n    padding: 11.1px 10px;\r\n    -webkit-transition: all 0.3s ease;\r\n    -moz-transition: all 0.3s ease;\r\n    -ms-transition: all 0.3s ease;\r\n    -o-transition: all 0.3s ease;\r\n    transition: all 0.3s ease;\r\n    background: #F2F2F2;\r\n\r\n\r\n}\r\n\r\n.minusbtn {\r\n    border-top-left-radius: 5px;\r\n    border-bottom-left-radius: 5px;\r\n    height: 40px;\r\n}\r\n\r\n.min-add-button input {\r\n    background: #F2F2F2;\r\n    border: none;\r\n\r\n}\r\n\r\n.plusbtn {\r\n    border-top-right-radius: 5px;\r\n    border-bottom-right-radius: 5px;\r\n    height: 40px;\r\n}\r\n\r\n.minusbtn svg {\r\n    color: #000;\r\n}\r\n\r\n.plusbtn svg {\r\n    color: #000;\r\n}\r\n\r\n.min-add-button a:hover {\r\n    background: #f3f3f3;\r\n}\r\n\r\n.min-add-button input {\r\n    height: 37px;\r\n    text-align: center;\r\n    font-weight: 700;\r\n    padding: 18.8px 20px 17.6px;\r\n    color: #000;\r\n    border-left: 1px solid #C4C4C4;\r\n    border-right: 1px solid #C4C4C4;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    letter-spacing: 0.18px\r\n}\r\n\r\n.cart_container th {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 114% */\r\n    border-bottom: 1px solid #C4C4C4;\r\n    height: 50px;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n\r\n.min-add-button input:focus,\r\n.min-add-button input[data-focus] {\r\n    box-shadow: none !important;\r\n    border-color: #C4C4C4 !important;\r\n}\r\n\r\n.cart_container table {\r\n    border: 1px solid #C4C4C4;\r\n}\r\n\r\n.cart_container h2 {\r\n    font-weight: 700;\r\n    font-size: 54px;\r\n    line-height: 54px;\r\n    /* display: flex; */\r\n    align-items: center;\r\n    letter-spacing: -0.5px;\r\n    color: #000000;\r\n    padding: 62px 0px;\r\n}\r\n\r\nimg.image-360 {\r\n    padding: 3px 0px;\r\n    height: 63px;\r\n    object-fit: cover;\r\n    width: fit-content;\r\n    max-width: 170px;\r\n    max-height: 63px;\r\n}\r\n\r\n.chakra-select .option[value*=\"hvac\"] {\r\n    text-transform: uppercase;\r\n}\r\n\r\n.cart_dt_pp {\r\n    justify-content: end;\r\n}\r\n\r\n.price_dt_bill {\r\n    margin-top: 30px;\r\n    float: none;\r\n}\r\n\r\n.price_dt_bill li:last-child {\r\n\r\n    margin-bottom: 36px;\r\n}\r\n\r\n.checkOut_bt_cart {\r\n    background: #EC7700 !important;\r\n    border-radius: 5px !important;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n\r\n    color: #FFFFFF !important;\r\n    width: 100% !important;\r\n    height: 64px !important;\r\n}\r\n\r\n.billing_details {\r\n    max-width: 440px;\r\n    width: 100%;\r\n\r\n}\r\n\r\n.flx_spc_betwen {\r\n    justify-content: space-between;\r\n}\r\n\r\n.checkOut_bt_cart:hover {\r\n    background: #F2F2F2 !important;\r\n    color: #000 !important;;\r\n}\r\n\r\n.checkOut_bt_cart:focus,\r\n.checkOut_bt_cart[data-focus] {\r\n    box-shadow: none !important;\r\n    border-color: none !important;\r\n}\r\n\r\n.checkOut_bt_cart_shoppig:focus,\r\n.checkOut_bt_cart_shoppig[data-focus] {\r\n    box-shadow: none !important;\r\n    border-color: none !important;\r\n}\r\n\r\n.checkOut_bt_cart_shoppig:hover {\r\n    background: #EC7700 !important;\r\n    color: #fff !important;;\r\n}\r\n\r\n.chakra-modal__footer .css-2kyq28 {\r\n    background: #ec7700 !important;\r\n    color: #fff;\r\n}\r\n\r\n.checkOut_bt_cart_shoppig {\r\n    background: #F2F2F2 !important;\r\n    border-radius: 5px !important;\r\n    font-weight: 700 !important;\r\n    font-size: 15px !important;\r\n    line-height: 56px !important;\r\n    /* or 373% */\r\n    margin-top: 10px;\r\n\r\n    margin-bottom: 134px;\r\n\r\n    color: #000000;\r\n    height: 32px !important;;\r\n    width: 100% !important;\r\n}\r\n\r\n.flx_bx_mob_ct {\r\n    display: flex;\r\n\r\n}\r\n\r\n.btnmob_pls_minus {\r\n    justify-content: space-between;\r\n    margin-bottom: 10px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    margin-bottom: 20px;\r\n    padding-bottom: 23px;\r\n}\r\n\r\n.mob_img_bx {\r\n    background-color: #f2f2f2;\r\n\r\n    height: 70px;\r\n    max-width: 85px;\r\n    width: 100%;\r\n    position: relative;\r\n}\r\n\r\n.mob_img_bx img {\r\n    max-width: 44px;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    position: absolute;\r\n}\r\n\r\n.mob_pd_nm {\r\n    text-align: left;\r\n    padding-left: 20px;\r\n    padding-top: 15px;\r\n}\r\n\r\n.mob_pd_nm .pd_name_bmt {\r\n    display: block;\r\n}\r\n\r\n.hd_cart_mb_hd_btn {\r\n    display: block;\r\n}\r\n\r\n\r\n.btnmob_pls_minus .number_bmt {\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n    text-align: right;\r\n    letter-spacing: 0.1px;\r\n    color: #000000;\r\n    display: block;\r\n\r\n}\r\n\r\n.number_unit_price {\r\n    font-weight: 400;\r\n    font-size: 10px;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #4D4D4D;\r\n    display: block;\r\n    padding: 0px;\r\n}\r\n\r\n.btnmob_pls_minus .min-add-button {\r\n    margin: 0px;\r\n    margin-top: 15px;\r\n}\r\n\r\n.btnmob_pls_minus .min-add-button input {\r\n\r\n    padding: 21.1px 20px 19.2px;\r\n}\r\n\r\n.price_md_test {\r\n    text-align: right;\r\n\r\n    margin-top: 22px;\r\n\r\n    padding-left: 30px;\r\n}\r\n\r\n.dlt_mb_crown img {\r\n    padding-top: 22px;\r\n}\r\n\r\n.hd_desktop_btn {\r\n    display: none !important;\r\n}\r\n\r\n.hd_md_dtps {\r\n    display: none;\r\n}\r\n\r\n.new_roles ul {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    display: flex;\r\n}\r\n\r\n.new_roles li {\r\n    margin-right: 20px;\r\n}\r\n\r\n.new_roles {\r\n    margin: 0px 34px;\r\n}\r\n\r\n.rl_dets {\r\n    margin: 0px 35px 35px;\r\n    padding-bottom: 25px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n}\r\n\r\n.edit_roles {\r\n    margin: 0px 34px;\r\n}\r\n\r\n.rl_dets h2 {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #000000;\r\n\r\n    padding-top: 16px;\r\n    padding-bottom: 18px;\r\n}\r\n\r\n.rl_dets input {\r\n    background: #FFFFFF;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n    height: 40px;\r\n    max-width: 286px;\r\n    width: 100%;\r\n    display: block;\r\n}\r\n\r\n.rl_dets label {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 12px;\r\n    /* identical to box height, or 133% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.edit_roles h2 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    color: #000000;\r\n    padding-bottom: 26px;\r\n}\r\n\r\n.edit_roles ul {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    display: flex;\r\n}\r\n\r\n.edit_roles li {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 13px;\r\n    /* or 93% */\r\n\r\n    padding-right: 45px;\r\n    letter-spacing: 0.25px;\r\n\r\n    /* Orange */\r\n\r\n    color: #EC7700;\r\n}\r\n\r\n.manage_roles1 {\r\n\r\n    /* Orange */\r\n\r\n    color: #EC7700;\r\n}\r\n\r\n.manage_roles2 {\r\n\r\n\r\n    color: #C4C4C4 !important;\r\n\r\n}\r\n\r\n.edit_roles tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n.manage_role3 {\r\n    opacity: 0.5 !important;\r\n    color: #C4C4C4 !important;\r\n}\r\n\r\n.bg_strip_btn_save {\r\n    background: #f2f2f2;\r\n    /* margin-top: 250px; */\r\n    margin: 250px 34px 53px;\r\n    background: #f2f2f2;\r\n    /* margin-top: 250px; */\r\n    padding: 14px 20px;\r\n\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap: 10px;\r\n\r\n}\r\n\r\n.bg_color_acrhove a,\r\n.bg_strip_btn_save a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 114% */\r\n    padding: 3px 0px;\r\n    display: flex;\r\n    margin-right: 37px;\r\n    align-items: center;\r\n    letter-spacing: 1.25px;\r\n    text-transform: uppercase;\r\n\r\n    /* Orange */\r\n\r\n    color: #EC7700;\r\n\r\n}\r\n\r\n.bg_strip_btn_save button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    /* or 373% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n\r\n    color: #FFFFFF;\r\n}\r\n\r\nbutton.bg_strip_btn_long_text {\r\n    white-space: pre-line;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.bg_strip_btn_long_text_span {\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.bg_strip_btn_save button:hover {\r\n    background-color: #592C82 !important;\r\n}\r\n\r\n.box_wd6hdpx {\r\n    max-width: 600px;\r\n    width: 100%;\r\n}\r\n\r\n.box_form_blck {\r\n    margin: 0px 34px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n}\r\n\r\n.box_form_blck .form_controll {\r\n    padding: 0px;\r\n    padding-bottom: 20px;\r\n\r\n}\r\n\r\n.box_form_blck h2 {\r\n\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    color: #000000;\r\n    padding: 15px 0px 20px;\r\n\r\n}\r\n\r\n.box_form_blck label {\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    padding-top: 1px;\r\n}\r\n\r\n.box_form_blck .chakra-input {\r\n    background: #FFFFFF;\r\n    /*border: 1px solid #C4C4C4;*/\r\n    border-radius: 5px;\r\n}\r\n\r\n.box_form_blck input:focus,\r\n.box_form_blck input[data-focus] {\r\n    /*border: 1px solid #C4C4C4;*/\r\n    box-shadow: none;\r\n}\r\n\r\n.pd-tp35 h2 {\r\n    padding-top: 35px;\r\n}\r\n\r\n.box_form_blck button:focus,\r\n.box_form_blck button[data-focus] {\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.home_page_main_slider_mt .slick-dots,\r\n.slick_slider_custom_arrows {\r\n    padding-left: 0px;\r\n    top:unset;\r\n    bottom: 20px !important;\r\n    /* width: 100%; */\r\n    /* left: 50%; */\r\n    /* top: 50%; */\r\n    left: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    text-align: center;\r\n}\r\n\r\n.slick_slider_custom_arrow {\r\n    position: inherit !important;\r\n}\r\n\r\n.slick_left_arrow {\r\n    left: 0;\r\n    right: 0;\r\n}\r\n\r\n.slick_slider_custom_arrows {\r\n    max-width: 0px;\r\n    /* z-index: 99999; */\r\n}\r\n\r\n.slick_right_arrow {\r\n    left: 0;\r\n}\r\n\r\n.slick_right_arrow {\r\n    /* left: 28%; */\r\n    right: 0;\r\n}\r\n\r\n.box_form_blck button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    line-height: 56px;\r\n    /* identical to box height, or 467% */\r\n    transition: all 0.3s ease-in;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n\r\n    color: #FFFFFF;\r\n    height: 24px;\r\n    margin-top: 12px;\r\n}\r\n\r\n.box_form_blck button:hover {\r\n    background: #f2f2f2;\r\n    color: #EC7700;\r\n    transition: all 0.3s ease-in;\r\n}\r\n\r\n.box_form_blck p {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    display: flex;\r\n    text-align: left;\r\n    align-items: center;\r\n    letter-spacing: 0.4px;\r\n    color: #000000;\r\n    display: block;\r\n    position: relative;\r\n    top: -10px;\r\n}\r\n\r\n.rm_bd_ud {\r\n    border-bottom: none;\r\n    /* padding-bottom:10px; */\r\n}\r\n\r\n.pd_tp_bm_tc {\r\n    margin: 30px 34px 53px !important;\r\n}\r\n\r\n.blck-srtdt img {\r\n    float: left;\r\n    margin-right: 14px;\r\n    position: relative;\r\n    top: 3px;\r\n}\r\n\r\n.css-zipzvv .option_table .css-womqfz {\r\n    /*max-width: 300px;*/\r\n    /*right: 30px;*/\r\n    /*left: 30px;*/\r\n    /*width: 100%;*/\r\n    /*left: 50%;*/\r\n    /*right: 0;*/\r\n    /*top: auto;*/\r\n\r\n\r\n    /*transform: translate(-50%, -0%);*/\r\n}\r\n\r\n.blck-srtdt {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 143% */\r\n\r\n\r\n    align-items: center;\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.srch_filter {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 0px 20px;\r\n    border-top: 1px solid #C4C4C4;\r\n    padding-top: 18px;\r\n    align-items: center;\r\n}\r\n\r\n.srch_filter input {\r\n    background: #FFFFFF;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n    margin-bottom: 16px;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    /* identical to box height, or 100% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.1px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.srch_filter select {\r\n    background: #FFFFFF;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n    margin-bottom: 16px;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    /* identical to box height, or 100% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.1px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.srch_filter input:focus,\r\n.srch_filter input[data-focus] {\r\n    border: 1px solid #C4C4C4;\r\n    box-shadow: none;\r\n}\r\n\r\n.css-zipzvv .chakra-table .css-xumdn4:first-child {\r\n    padding: 10px 10px 10px 25px;\r\n    /* width: 300px;*/\r\n}\r\n\r\n.srch_filter button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    /* or 373% */\r\n    transition: all 0.3s ease-in;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n\r\n    color: #FFFFFF;\r\n    margin-top: 9px;\r\n    padding: 1px 33px;\r\n\r\n\r\n}\r\n\r\n.srch_filter button:hover {\r\n    transition: all 0.3s ease-in;\r\n    background: #f2f2f2;\r\n    color: #EC7700;\r\n}\r\n\r\n.srch_filter button:focus,\r\n.srch_filter button[data-focus] {\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.srch_filter .form_controll {\r\n    padding: 0px;\r\n}\r\n\r\n.srch_filter label {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 133% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.fgt_pw_btn {\r\n    margin: 0px 0px 17px !important;\r\n}\r\n\r\n.fg_pw_blck {\r\n    height: 635px !important;\r\n}\r\n\r\n.pn_btn {\r\n    background-color: #EC7700 !important;\r\n    border-radius: 5px !important;\r\n    font-weight: 700 !important;\r\n    font-size: 15px !important;\r\n    line-height: 56px !important;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    margin-top: 5px;\r\n    transition: all 0.3s ease-in;\r\n}\r\n\r\n.btPd_voic {\r\n    margin: 20px 35px 10px !important;\r\n}\r\n\r\n.pn_btn:focus,\r\n.pn_btn[data-focus] {\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.pn_btn:hover {\r\n    background: #fff !important;\r\n    color: #EC7700;\r\n    transition: all 0.3s ease-in;\r\n}\r\n\r\n.cstm_invoices {\r\n    margin: 0px 35px;\r\n}\r\n\r\n.fx_bx_vic {\r\n    max-width: 230px;\r\n    width: 100%;\r\n}\r\n\r\n.fx_bx_vic li {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.ct_comp {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.ct_comp1 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    text-align: right;\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.ct_invoice {\r\n    height: 85px !important;\r\n    background: #F7F7F7;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.ct_outstading {\r\n    font-weight: 700 !important;\r\n    font-size: 14px !important;\r\n    line-height: 20px !important;\r\n    letter-spacing: 0.25px !important;\r\n    padding: 0px !important;\r\n    text-align: right !important;\r\n    display: block !important;\r\n    padding-bottom: 5px !important;\r\n    color: #000000 !important;\r\n}\r\n\r\n.ct_outstading_1 {\r\n    font-weight: 700 !important;\r\n    font-size: 40px !important;\r\n    line-height: 20px !important;\r\n    /* identical to box height, or 50% */\r\n\r\n\r\n    letter-spacing: 0.25px !important;\r\n\r\n    color: #000000 !important;\r\n}\r\n\r\n.invoice_tble_cm {\r\n    font-weight: 400 !important;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    /* identical to box height, or 100% */\r\n\r\n\r\n    letter-spacing: 0.1px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.invoice_tble_cm_mn td {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 171% */\r\n\r\n    /* display: flex;\r\n    align-items: center;\r\n    text-align: center; */\r\n    letter-spacing: 0.18px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n}\r\n\r\n.invoice_tble_cm_mn {\r\n    margin: 0px 35px;\r\n}\r\n\r\n.invoice_tble_cm_mn .option_table {\r\n    margin-top: 12px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n}\r\n\r\n.invoice_dtTotal {\r\n    margin-top: 32px;\r\n}\r\n\r\n.checkout_page_container {\r\n    max-width: 900px !important;\r\n    margin: 0px auto !important;\r\n    width: 100% !important;\r\n}\r\n\r\n.check_heading {\r\n    font-weight: 700;\r\n    font-size: 54px;\r\n    line-height: 54px;\r\n    /* display: flex; */\r\n    align-items: center;\r\n    letter-spacing: -0.5px;\r\n    color: #000000;\r\n    text-align: left;\r\n    padding: 61px 0px 56px;\r\n}\r\n\r\n.billing_details {\r\n    /* display:flex;\r\n    justify-content: space-between; */\r\n}\r\n\r\n.billing_details_1 {\r\n    background: #E9EAEB;\r\n    height: 40px;\r\n    padding: 15px;\r\n    width: 100%;\r\n    display: block;\r\n    margin: 0px auto;\r\n    display: flex;\r\n    position: relative;\r\n    max-width: 440px;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n}\r\n\r\n.flx_spc_betwen .css-0 {\r\n    max-width: 425px;\r\n    width: 100%;\r\n}\r\n\r\n.billing_details_1 h2 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #1A1A1A;\r\n}\r\n\r\n.billing_details_1 a {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* display: flex; */\r\n    align-items: center;\r\n    letter-spacing: 0.25px;\r\n    text-decoration-line: underline;\r\n    color: #F58220;\r\n    display: block;\r\n    margin-top: -5px;\r\n}\r\n\r\n.order_details_prduct {\r\n    border: 1px solid #C4C4C4;\r\n    background: #F6F6F6;\r\n    padding: 0px 0px 0px;\r\n}\r\n\r\n.billing_details_1 .chakra-avatar {\r\n    background-color: transparent !important;\r\n    max-width: 16px;\r\n    margin-top: -15px;\r\n    padding-right: 0px;\r\n    margin-left: 10px;\r\n}\r\n\r\n.billing_details ul {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    background: #F7F7F7;\r\n    padding: 13px;\r\n    text-align: left;\r\n}\r\n\r\n.billing_details li:first-of-type {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.prduct_total ul {\r\n    background-color: #fff !important;\r\n    border: 1px solid #C4C4C4 !important;\r\n    margin: 15px;\r\n    padding: 0px;\r\n}\r\n\r\n.order_details_dt_ord_dt li {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-weight: 400 !important;\r\n    font-size: 14px !important;\r\n    line-height: 16px !important;\r\n    /* identical to box height, or 114% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px !important;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.order_details_prduct {\r\n    background: #F7F7F7 !important;\r\n}\r\n\r\n.order_details_dt_ord_dt li {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    padding: 15px 10px 15px;\r\n    /* or 143% */\r\n    text-align: left;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    margin-bottom: 10px;\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n    text-align: left;\r\n    border-bottom: 1px solid #C4C4C4;\r\n}\r\n\r\n.order_details_dt_ord_dt img {\r\n    max-width: 64px !important;\r\n    width: 100%;\r\n}\r\n\r\n.mb_rm_tst {\r\n    margin-bottom: 0px !important;\r\n    padding: 5px 10px 13px !important;\r\n    position: relative;\r\n}\r\n\r\n.mb_rm_tst .in_voice {\r\n    position: absolute;\r\n    left: 80px;\r\n}\r\n\r\n.flx_sp_bt span {\r\n    text-transform: capitalize !important;\r\n}\r\n\r\n.sb_frm {\r\n    padding: 0px 15px;\r\n}\r\n\r\n.sb_frm label {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    padding-top: 30px;\r\n}\r\n\r\n.sb_frm input {\r\n    width: 100%;\r\n    display: block;\r\n    background: #FFFFFF;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.sb_frm button {\r\n    position: absolute;\r\n    background: #EC7700;\r\n    border-radius: 0px 5px 5px 0px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    /* or 373% */\r\n    z-index: 2;\r\n    right: 0px;\r\n    bottom: 0px;\r\n    padding: 0px 28px;\r\n    color: #FFFFFF;\r\n    transition: all .5s ease;\r\n}\r\n\r\n.sb_frm button:hover {\r\n    background-color: #592C82 !important;\r\n}\r\n\r\n.sb_frm button:focus,\r\n.sb_frm button[data-focus] {\r\n    z-index: 1;\r\n\r\n    box-shadow: none;;\r\n}\r\n\r\n.pm_tnw {\r\n    padding: 0px 15px;\r\n}\r\n\r\n.pm_tnw p {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    padding-top: 30px;\r\n    padding-bottom: 11px;\r\n}\r\n\r\n.sb_frm input:focus,\r\n.sb_frm input[data-focus] {\r\n    z-index: 1;\r\n    border: 1px solid #C4C4C4;\r\n    box-shadow: none;;\r\n}\r\n\r\n.pm_tnw .chakra-radio__control:focus,\r\n.pm_tnw .chakra-radio__control[data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.pm_tnw .chakra-radio__control {\r\n\r\n    height: 24px;\r\n    background-color: #fff;\r\n    width: 24px;\r\n}\r\n\r\n.pm_tnw .chakra-radio:last-child {\r\n    margin-top: 20px;\r\n}\r\n\r\n.check_bx_blck {\r\n    padding: 60px 15px 0px;\r\n\r\n}\r\n\r\n.det_checkt {\r\n    margin-left: 120px;\r\n}\r\n\r\n.check_bx_blck .chakra-checkbox__control:focus,\r\n.check_bx_blck .chakra-checkbox__control[data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.pd_bm_bill_dt_pg {\r\n    margin-bottom: 90px;\r\n}\r\n\r\n.check_bx_blck .chakra-checkbox__label {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.check_bx_blck .chakra-checkbox__control {\r\n    width: 24px;\r\n    height: 24px;\r\n    background: #fff;\r\n}\r\n\r\n.check_bx_blck .chakra-checkbox:last-child {\r\n    margin-top: 20px;\r\n}\r\n\r\n.check_bx_blck button {\r\n    margin-top: 47px;\r\n    background-color: #888;\r\n    width: 100%;\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    color: #fff;\r\n    height: 64px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    transition: all .5s ease;\r\n}\r\n\r\n.check_bx_blck button:hover {\r\n    background-color: #592C82 !important;\r\n    transition: all .5s ease;\r\n}\r\n\r\n.check_bx_blck img {\r\n    width: 20px !important;\r\n    height: 20px;\r\n    object-fit: contain;\r\n    margin-right: 10px;\r\n}\r\n\r\n.check_bx_blck p {\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    padding: 30px 0px 60px;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    /* line-height: 56px; */\r\n    /* identical to box height, or 400% */\r\n\r\n\r\n    align-items: self-start;\r\n\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.bg_color_acrhove {\r\n    display: flex;\r\n    align-self: center;\r\n}\r\n\r\n.searchDrillcutfilters {\r\n    display: flex !important;\r\n    justify-content: space-between;\r\n}\r\n\r\n.pm_tnw .chakra-radio__label {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.pd-btm-notes {\r\n    margin-top: 22px;\r\n}\r\n\r\n.pd-btm-notes label {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 133% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.form_dt_notes {\r\n    padding: 0px 15px 15px 15px;\r\n    background: #F7F7F7;\r\n}\r\n\r\n.form_dt_notes label {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    padding: 14px 0px 5px;\r\n    margin: 0px;\r\n\r\n}\r\n\r\n.form_dt_notes input {\r\n    background: #FFFFFF;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n}\r\n\r\n.form_dt_notes textarea {\r\n    background: #FFFFFF;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n}\r\n\r\n.form_dt_notes input:focus,\r\n.form_dt_notes input[data-focus] {\r\n    box-shadow: none !important;\r\n    border-color: #C4C4C4 !important;\r\n}\r\n\r\n.form_dt_notes textarea:focus,\r\n.form_dt_notes textarea[data-focus] {\r\n    box-shadow: none !important;\r\n    border-color: #C4C4C4 !important;\r\n}\r\n\r\n/* account information page css start  */\r\n.acc_ctent_block {\r\n\r\n    padding: 28px 35px 33px 35px;\r\n}\r\n\r\n.acc_ctent_block h2 {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    color: #1A1A1A;\r\n    padding-bottom: 16px;\r\n}\r\n\r\n.account_info li span {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n    float: left !important;\r\n\r\n    letter-spacing: 0.25px;\r\n    height: 70px;\r\n    color: #000000;\r\n}\r\n\r\n.account_info li {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n    height: 70px;\r\n    color: #000000;\r\n}\r\n\r\n.account_info li:last-child {\r\n    height: 0px;\r\n    padding-bottom: 30px;\r\n}\r\n\r\n.acc_ctent_block p {\r\n    font-weight: 300;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* or 150% */\r\n\r\n    text-align: left;\r\n    letter-spacing: 0.5px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.account_info a {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n    text-decoration-line: underline;\r\n\r\n    /* Orange */\r\n\r\n    color: #EC7700;\r\n\r\n}\r\n\r\n.account_info {\r\n    height: auto;\r\n    margin-bottom: 27px;\r\n}\r\n\r\n.address_info li {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.address_info li span {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.address_info {\r\n    height: auto;\r\n    padding-bottom: 17px;\r\n}\r\n\r\n.def_projct li {\r\n    height: 50px;\r\n}\r\n\r\n.account_statment label {\r\n\r\n    padding: 0px;\r\n    margin: 0px;\r\n    font-weight: 400;\r\n    font-size: 13px;\r\n    line-height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    color: #000000;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.account_statment select {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 21px;\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    letter-spacing: 0.1px;\r\n    color: #000000;\r\n    background-color: #fff;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n}\r\n\r\n.acc_blnc_act {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.bill_total {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.acc_blnc_total p {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n    text-transform: uppercase;\r\n    padding: 0px;\r\n    color: #000000;\r\n}\r\n\r\n.acc_blnc_total p {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.acc_blnc_total_bll p {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    text-align: right;\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n    padding: 0px;\r\n}\r\n\r\n.def_projct li:last-child {\r\n    height: 0px;\r\n    padding-bottom: 45px;\r\n}\r\n\r\n.acc_blnc_total_details {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.acc_blnc_act {\r\n\r\n    font-weight: 700 !important;\r\n    font-size: 14px !important;\r\n    line-height: 20px !important;\r\n    letter-spacing: 0.25px !important;\r\n    color: #000000 !important;\r\n}\r\n\r\n.acc_blnc_total_details ul {\r\n    padding: 0px;\r\n    list-style-type: none;\r\n    margin: 0px;\r\n    text-align: inherit;\r\n    padding-top: 14px;\r\n    padding-bottom: 15px;\r\n}\r\n\r\n.account_statment {\r\n    height: auto;\r\n    margin-bottom: 27px;\r\n}\r\n\r\n.acc_blnc_total_details li {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.dt_ttl_sm {\r\n    display: block;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    padding-right: 17px;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    letter-spacing: 0.25px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.drill_table tr:nth-child(4) {\r\n    background: rgb(242 242 242 / 50%);\r\n}\r\n\r\n.dt_ttl_sm_1 {\r\n\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    text-align: right;\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n\r\n    padding: 0px;\r\n    display: block;\r\n}\r\n\r\n/* account information page css end  */\r\n/* drill club page css start */\r\n.drill_clb_bg {\r\n    background: #F2F2F2;\r\n    margin: 35px 35px 0px;\r\n    padding: 28px 20px 20px;\r\n}\r\n\r\n.drill_block_1 h2 {\r\n    font-size: 28px;\r\n    color: #1A1A1A;\r\n    text-align: left;\r\n}\r\n\r\n.drill_block_1 h2 span {\r\n    font-weight: bolder;\r\n}\r\n\r\n.drill_block_1 h3 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n\r\n    text-align: left;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    /* Drillcut Purple */\r\n\r\n    color: #592C82;\r\n    padding-top: 10px;\r\n}\r\n\r\n.drill_block_1 h3 span {\r\n    font-weight: 700;\r\n    font-size: 40px;\r\n    line-height: 24px;\r\n    text-align: left;\r\n    padding-right: 5px;\r\n\r\n    letter-spacing: 0.15px;\r\n\r\n    /* Drillcut Purple */\r\n\r\n    color: #592C82;\r\n\r\n}\r\n\r\n.drill_block_1 p {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    letter-spacing: 0.4px;\r\n    color: #4D4D4D;\r\n    padding-bottom: 16px;\r\n    text-align: left;\r\n    display: block;\r\n    padding-top: 9px;\r\n}\r\n\r\n.drill_block_1 button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    color: #fff;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 40px;\r\n    display: block;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    display: block;\r\n    padding: 0px 28px;\r\n    height: 48px;\r\n    transition: all 0.3s ease-in;\r\n}\r\n\r\n.drill_block_1 button:hover {\r\n    transition: all 0.3s ease-in;\r\n    background: #592C82;\r\n\r\n    color: #fff;\r\n}\r\n\r\n.drill_block_1 button:focus,\r\n.drill_block_1 button[data-focus] {\r\n\r\n    box-shadow: none !important;\r\n}\r\n\r\n.drill_block_1 a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* display: flex; */\r\n    align-items: center;\r\n    letter-spacing: 0.25px;\r\n    color: #F58220;\r\n    /* padding-top: 28px; */\r\n    display: block;\r\n    padding-top: 18px;\r\n}\r\n\r\n.drill_block_1 {\r\n    position: relative;\r\n}\r\n\r\n.drill_block_1:after {\r\n    position: absolute;\r\n    content: '';\r\n    width: 1px;\r\n    border-right: 1px solid #fff;\r\n    height: 100%;\r\n    right: -25px;\r\n    top: 0px;\r\n}\r\n\r\n.drill_block_2 {\r\n    padding-left: 60px;\r\n}\r\n\r\n.drill_block_2 {\r\n    padding-left: 60px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n}\r\n\r\n.drill_block_3 p {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 133% */\r\n    text-align: left;\r\n    letter-spacing: 0.4px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.drill_block_3 h2 {\r\n    font-weight: 700;\r\n    font-size: 34px;\r\n    line-height: 36px;\r\n    text-align: left;\r\n    color: #000000;\r\n    padding: 7px 0px 19px;\r\n}\r\n\r\n.project_br .md_lftd .chakra-accordion {\r\n    display: none;\r\n}\r\n\r\n.drill_block_3 h3 {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    letter-spacing: 0.15px;\r\n    color: #000000;\r\n    text-align: left;\r\n}\r\n\r\n.drill_block_3 h3 span {\r\n    font-weight: bolder;\r\n\r\n}\r\n\r\n.drill_block_3 a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.25px;\r\n    color: #F58220;\r\n    margin-top: 47px;\r\n}\r\n\r\n.drill_block_4 ul {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.drill_block_4 li {\r\n    margin-left: 45px;\r\n\r\n}\r\n\r\n.drill_block_4 li img {\r\n    margin: 0px auto;\r\n}\r\n\r\n.drill_block_4 li p {\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 10px;\r\n    padding-top: 8px;\r\n    line-height: 12px;\r\n    /* identical to box height, or 120% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 1.5px;\r\n    transition: all 0.3s ease-in;\r\n    color: #000000;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.drill_block_4 li p:hover {\r\n    transition: all 0.3s ease-in;\r\n    font-weight: 700;\r\n\r\n}\r\n\r\n.drill_block_3 {\r\n    max-width: 30%;\r\n    width: 100%;\r\n}\r\n\r\n.drill_block_4 {\r\n    max-width: 70%;\r\n    width: 100%;\r\n}\r\n\r\n.pg_bar .css-150tos1 {\r\n    background-color: #fff;\r\n    max-width: 82%;\r\n}\r\n\r\n.pg_bar {\r\n    position: relative;\r\n}\r\n\r\n.pg_bar span {\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 0px;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.drill_select_bx {\r\n    background-color: transparent !important;\r\n    border: none !important;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 143% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #F58220;\r\n\r\n}\r\n\r\n.drill_select_bx {\r\n    margin-top: 51px;\r\n}\r\n\r\n.drill_block_4 .chakra-select__wrapper {\r\n    border: none;\r\n    max-width: 170px;\r\n    width: 100%;\r\n    border: none;\r\n}\r\n\r\n.drill_block_4 .chakra-select__icon-wrapper {\r\n    color: #F58220;\r\n}\r\n\r\n.drill_select_bx:focus,\r\n.drill_select_bx[data-focus] {\r\n    box-shadow: none !important;\r\n}\r\n\r\n.drill_table {\r\n    /* padding:0px 35px; */\r\n    width: 100%;\r\n}\r\n\r\n.drill_table tr:nth-child(2n) {\r\n    background: rgb(242 242 242 / 50%);\r\n}\r\n\r\n.drill_table td {\r\n\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 7px;\r\n    /* or 150% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.md_lftd {\r\n    margin: 0px 35px;\r\n}\r\n\r\n.pr_drill {\r\n    font-weight: 700 !important;\r\n    font-size: 14px;\r\n    line-height: 21px;\r\n    /* or 150% */\r\n\r\n    letter-spacing: 0.25px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.modal_dataDrill_cbt {\r\n    height: auto;\r\n    margin: 0px auto;\r\n    display: block;\r\n    position: absolute;\r\n    /* text-align: center; */\r\n    left: 50%;\r\n    right: 50%;\r\n    top: 50%;\r\n    left: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, 0%);\r\n    width: 1010px;\r\n\r\n\r\n    background: #FFFFFF;\r\n}\r\n\r\n.modal_dataDrill_cbt h3 {\r\n    font-weight: 700;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    letter-spacing: 0.18px;\r\n    color: #1A1A1A;\r\n    text-align: center;\r\n    padding: 65px 0px 25px;\r\n}\r\n\r\n.modal_dataDrill_cbt .chakra-accordion__button {\r\n    background: #F2F2F2;\r\n    /* Keyline */\r\n    display: flex;\r\n    align-items: center;\r\n    height: 64px;\r\n    border-top: 1px solid #C4C4C4;\r\n    border-left: 1px solid #C4C4C4;\r\n    border-right: 1px solid #C4C4C4;\r\n}\r\n\r\n.whle_modal .chakra-modal__close-btn {\r\n    right: -344px;\r\n    position: absolute;\r\n    z-index: 9;\r\n}\r\n\r\n/* drill club page css end */\r\n/* drill club statment page css start */\r\n.flx_bx_drill_statment {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 35px 35px 0px;\r\n}\r\n\r\n.drill_stment_brder:after {\r\n    top: -13px !important;\r\n\r\n}\r\n\r\n.flx_bx_option_statment select {\r\n\r\n    font-weight: 300;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    background: #FFFFFF;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n    letter-spacing: 0.25px;\r\n    max-width: 100%;\r\n    width: 182px;\r\n    height: 40px;\r\n    color: #000000;\r\n}\r\n\r\n.flx_bx_option_statment select:focus,\r\n.flx_bx_option_statment select[data-focus] {\r\n    box-shadow: none;\r\n    border: 1px solid #C4C4C4;\r\n}\r\n\r\n.acct_statment h2 {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n    padding-top: 10px;\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.price_tl_pr_1 {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 167% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.price_tl_pr_2 {\r\n\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* identical to box height, or 143% */\r\n\r\n    text-align: right;\r\n    text-align: right;\r\n    letter-spacing: 0.15px;\r\n    display: inline-block;\r\n    width: 150px;\r\n    color: #000000;\r\n}\r\n\r\n.pd_lf_stment {\r\n    float: none;\r\n}\r\n\r\n.pd_lf_stment li:last-child {\r\n    margin-top: 10px;\r\n    padding-top: 7px;\r\n    border-top: 1px solid #C4C4C4;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.poingt_spnt {\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n}\r\n\r\n.acct_statment .price_dt_summry {\r\n    margin-top: 31px !important;\r\n    margin-inline-start: 0em !important;\r\n}\r\n\r\n/* drill club statment page css start */\r\n/* drill club web page css started */\r\n.drill_club_web_ct {\r\n    margin: 0px;\r\n    padding: 0px;\r\n    -webkit-padding-start: 0rem !important;\r\n    padding-inline-start: 0rem !important;\r\n\r\n    -webkit-padding-end: 0rem !important;\r\n    padding-inline-end: 0rem !important;\r\n}\r\n\r\n.dril_club_wb {\r\n    background: linear-gradient(105.17deg, #0094B8 0.56%, #5C2870 97.85%);\r\n    background: linear-gradient(105.17deg, #0094B8 0.56%, #5C2870 97.85%);\r\n    width: 35.2%;\r\n    padding: 175px 0px;\r\n}\r\n\r\n.bg_banner_web {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    background: url(./image/Bannerimage.png) no-repeat;\r\n    background-position: right;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n}\r\n\r\n.dril_club_wb p {\r\n    font-weight: 700;\r\n    font-size: 53px;\r\n    line-height: 24px;\r\n    letter-spacing: 0.15px;\r\n    color: #FFFFFF;\r\n    text-align: center;\r\n}\r\n\r\n.dril_club_wb img {\r\n    display: block;\r\n    margin-bottom: 21px;\r\n}\r\n\r\n.blck_web_1 h2 {\r\n    font-weight: 700;\r\n    font-size: 34px;\r\n    line-height: 36px;\r\n    /* display: flex; */\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #592C82;\r\n    text-align: center;\r\n    display: block;\r\n    padding: 60px 0px 30px;\r\n}\r\n\r\n.blck_web_1 p {\r\n    max-width: 900px;\r\n    width: 100%;\r\n    text-align: center;\r\n    margin: 0px auto;\r\n    font-weight: 300;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    text-align: center;\r\n    letter-spacing: 0.5px;\r\n    color: #000000;\r\n}\r\n\r\n.blck_web_2 {\r\n    display: flex;\r\n    justify-content: center;\r\n    text-align: center;\r\n    width: 100%;\r\n    max-width: 800px;\r\n    margin: 0px auto;\r\n}\r\n\r\n.blck_web_2_1 {\r\n\r\n    width: 100%;\r\n    padding: 0px 25px;\r\n    margin-top: 45px;\r\n}\r\n\r\n.blck_web_2_1 img {\r\n    margin: 0px auto;\r\n    display: block;\r\n    text-align: center;\r\n    margin-bottom: 18px;\r\n}\r\n\r\n.blck_web_2_1 p {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    text-align: center;\r\n    letter-spacing: 0.1px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n    padding-bottom: 88px;\r\n}\r\n\r\n.blck_web_jon_dril_clb {\r\n    background: linear-gradient(105.17deg, #0094B8 0.56%, #5C2870 97.85%);\r\n    padding: 65px 0px 60px;\r\n    max-width: 1130px;\r\n    margin: 0px auto;\r\n    position: relative;\r\n}\r\n\r\n.blck_web_jon_dril_clb h3 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 50px;\r\n    line-height: 24px;\r\n    letter-spacing: 0.15px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.ct_img_rill {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: baseline;\r\n}\r\n\r\n.ct_img_rill img {\r\n    margin-left: 10px;\r\n}\r\n\r\n.blck_web_jon_dril_clb button {\r\n    background: #BDD635;\r\n    border-radius: 5px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 60px;\r\n    text-align: center;\r\n    color: #592C82;\r\n    padding: 26px 80px;\r\n    /* height: 26px; */\r\n    text-transform: uppercase;\r\n    transition: all .5s ease;\r\n}\r\n\r\n.blck_web_jon_dril_clb button:hover {\r\n    background-color: #FFF;\r\n    color: #1A1A1A;\r\n\r\n}\r\n\r\n.blck_web_jon_dril_clb button:focus,\r\n.blck_web_jon_dril_clb button[data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.blck_web_jon_dril_clb p {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    text-align: center;\r\n    letter-spacing: 0.15px;\r\n    color: #FFFFFF;\r\n    padding: 30px 0px 20px;\r\n}\r\n\r\n.block_left_rill1 {\r\n    max-width: 410px;\r\n    width: 100%;\r\n}\r\n\r\n.block_left_rill1 h4 {\r\n    font-weight: 700;\r\n    font-size: 34px;\r\n    line-height: 36px;\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    color: #592C82;\r\n    text-align: left;\r\n\r\n}\r\n\r\n.block_left_rill2 {\r\n    max-width: 450px;\r\n    width: 100%;\r\n}\r\n\r\n.block_left_rill2 p {\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    letter-spacing: 0.5px;\r\n    color: #000000;\r\n    text-align: left;\r\n\r\n}\r\n\r\n.cntnt_blck_wrk_grw {\r\n    justify-content: space-between;\r\n    max-width: 900px;\r\n    margin: 0px auto;\r\n    padding: 72px 0px 83px;\r\n}\r\n\r\n.explore-the-rewards {\r\n    justify-content: space-between;\r\n    max-width: 900px;\r\n    margin: 0px auto;\r\n}\r\n\r\n.explore-the-rewards span {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n\r\n    text-align: center;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n}\r\n\r\n.explore-the-rewards h5 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 100% */\r\n\r\n    text-align: center;\r\n    letter-spacing: 0.18px;\r\n\r\n    /* Black 90 (Text) */\r\n    padding-top: 5px;\r\n    color: #1A1A1A;\r\n}\r\n\r\n.explore-the-rewards p {\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* or 150% */\r\n\r\n    text-align: center;\r\n    letter-spacing: 0.5px;\r\n    padding: 20px 0px;\r\n    color: #000000;\r\n\r\n\r\n}\r\n\r\n.wd_block {\r\n    max-width: 900px;\r\n    width: 100%;\r\n    margin: 0px auto;\r\n\r\n    border: 1px solid #C4C4C4;\r\n}\r\n\r\n.wd_block button {\r\n    background: #F2F2F2;\r\n    border: none;\r\n\r\n    border-bottom: 1px solid #C4C4C4;\r\n    height: 64px;\r\n}\r\n\r\n.wd_block button:focus,\r\n.wd_block button[data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.points_block {\r\n    max-width: 900px;\r\n    width: 100%;\r\n    margin: 0px auto;\r\n}\r\n\r\n.pt_blcks_jc {\r\n    justify-content: space-between;\r\n}\r\n\r\n.points_block p {\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* or 150% */\r\n\r\n    letter-spacing: 0.5px;\r\n\r\n    color: #FFFFFF;\r\n}\r\n\r\n.content_block_drill1 {\r\n    background: #0094B8;\r\n    max-width: 440px;\r\n    padding: 50px 30px;\r\n    color: #fff;\r\n    text-align: left;\r\n}\r\n\r\n.content_block_drill2 {\r\n    background: #592C82;\r\n    padding: 50px 30px;\r\n    color: #fff;\r\n    text-align: left;\r\n    max-width: 440px;\r\n}\r\n\r\n.content_block_drill1 h6 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 34px;\r\n    line-height: 36px;\r\n    /* or 106% */\r\n\r\n    padding-bottom: 15px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.content_block_drill2 h6 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 34px;\r\n    line-height: 36px;\r\n    /* or 106% */\r\n\r\n    padding-bottom: 15px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.content_block_drill1 span {\r\n    font-weight: 700;\r\n}\r\n\r\n.content_block_drill2 span {\r\n    font-weight: 700;\r\n}\r\n\r\n.main_block_sp_offer {\r\n    border: 20px solid #F2F2F2;\r\n    max-width: 900px;\r\n    margin: 0px auto;\r\n    margin-top: 60px;\r\n    margin-bottom: 20px;\r\n    padding: 25px 35px;\r\n    position: relative;\r\n}\r\n\r\n.main_block_sp_offer h6 {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    position: relative;\r\n    letter-spacing: 0.15px;\r\n    color: #1477AF;\r\n    text-align: left;\r\n    padding-bottom: 40px;\r\n}\r\n\r\n.main_block_sp_offer h6:before {\r\n    position: absolute;\r\n    content: '';\r\n    height: 1px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    width: 560px;\r\n    bottom: 20px;\r\n}\r\n\r\n.main_block_sp_offer span {\r\n    color: #EC7700;\r\n}\r\n\r\n.cls_ul_li_rill_clb ul {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n}\r\n\r\n.cls_ul_li_rill_clb li {\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    text-align: left;\r\n    letter-spacing: 0.5px;\r\n    color: #1477AF;\r\n    padding-right: 113px;\r\n\r\n}\r\n\r\n.ribbon-content p {\r\n    font-weight: 700;\r\n    font-size: 33px;\r\n    line-height: 39px;\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    text-align: center;\r\n    letter-spacing: 0.15px;\r\n    color: #FFFFFF;\r\n    text-shadow: 2px 2px 0px rgb(0 0 0 / 25%);\r\n    padding-top: 35px;\r\n}\r\n\r\n.overlay-ribbon {\r\n    position: absolute;\r\n    max-width: 223px;\r\n    width: 100%;\r\n    height: 232px;\r\n    z-index: 9999;\r\n    top: -20px;\r\n    right: 2%;\r\n    /* background: rgb(0 148 184 / 75%); */\r\n    padding: 5px 0;\r\n    background: linear-gradient(105.17deg, #0094B8 0.56%, #5C2870 97.85%);\r\n    /* box-shadow: -5px 21px 28px -4px rgb(0 0 0 / 43%); */\r\n    /* border-radius: 8px; */\r\n    animation: slidein 3s ease-in-out forwards;\r\n}\r\n\r\n.overlay-ribbon:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: 0px;\r\n    left: 0;\r\n    width: 223px;\r\n    border-bottom: 100px solid #fff;\r\n    border-top: 100px solid transparent;\r\n    border-left: 112px solid transparent;\r\n    border-right: 112px solid transparent;\r\n    z-index: 997;\r\n}\r\n\r\n.overlay-ribbon:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: -7em;\r\n    right: 0;\r\n    width: 0;\r\n    height: 0;\r\n    border-top: 7em solid rgb(0 148 184 / 75%);\r\n    border-left: 7em solid transparent;\r\n    z-index: 998;\r\n    display: none;\r\n}\r\n\r\n.points_block {\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.pd_bmrill {\r\n    margin-bottom: 107px;\r\n}\r\n\r\n.cnter_block_rillclb {\r\n    justify-content: center;\r\n    border: 1px solid #C4C4C4;\r\n}\r\n\r\n.block_1_rill_clb {\r\n    background: #F2F2F2;\r\n    max-width: 180px;\r\n    width: 100%;\r\n    max-height: 359px;\r\n}\r\n\r\n.tiers h6 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    text-align: center;\r\n    letter-spacing: 0.18px;\r\n    color: #1A1A1A;\r\n    padding: 70px 0px 23px;\r\n}\r\n\r\n.tiers {\r\n    max-width: 900px;\r\n    margin: 0px auto;\r\n}\r\n\r\n.block_1_rill_clb .members_dt {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n    line-height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    position: relative;\r\n    padding-bottom: 35px;\r\n}\r\n\r\n.block_1_rill_clb ul {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    padding-left: 11px;\r\n    padding-top: 56px;\r\n    padding-bottom: 133px;\r\n}\r\n\r\n.block_1_rill_clb .members_dt:after {\r\n    position: absolute;\r\n    content: '';\r\n    height: 1px;\r\n    width: 150px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    bottom: 17px;\r\n}\r\n\r\n.range_txt {\r\n    font-weight: 700;\r\n    font-size: 25px;\r\n    line-height: 34px;\r\n    padding-top: 18px;\r\n    text-align: left;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.15px;\r\n    color: #F58220;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.ct_suptd {\r\n    font-weight: 700;\r\n    font-size: 10px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 160% */\r\n    text-align: left;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n    padding-bottom: 10px;\r\n    display: block;\r\n    opacity: 0.5;\r\n}\r\n\r\n.cat_spt {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 25px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 64% */\r\n\r\n\r\n    letter-spacing: 0.15px;\r\n\r\n    text-align: left;\r\n\r\n    color: #1A1A1A;\r\n}\r\n\r\n.block_2_rill_clb .members_dt {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n    line-height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    position: relative;\r\n    padding-bottom: 30px;\r\n\r\n}\r\n\r\n.block_2_rill_clb .members_dt:after {\r\n    position: absolute;\r\n    content: '';\r\n    height: 1px;\r\n    width: 150px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n    bottom: 17px;\r\n}\r\n\r\n.block_2_rill_clb ul {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    padding-left: 11px;\r\n    padding-top: 53px;\r\n    padding-bottom: 133px;\r\n}\r\n\r\n.ct_spces {\r\n    padding-top: 30px;\r\n}\r\n\r\n.earn_lirill {\r\n    font-weight: 700;\r\n    font-size: 10px;\r\n    line-height: 16px;\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    opacity: 0.5;\r\n    display: block;\r\n    text-align: left;\r\n    padding-top: 39px;\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.lst_rill_clb {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 34px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 47% */\r\n    text-align: left;\r\n    display: block;\r\n\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #F58220;\r\n}\r\n\r\n.pts_rill {\r\n    font-size: 16px;\r\n}\r\n\r\n.price_rill {\r\n    font-weight: 700;\r\n    font-size: 10px;\r\n    line-height: 16px;\r\n    display: block;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    opacity: 0.5;\r\n    padding-top: 5px;\r\n}\r\n\r\n.block_2_rill_clb {\r\n    max-width: 180px;\r\n    width: 100%;\r\n    max-height: 359px;\r\n}\r\n\r\n.bg_color_2_rill {\r\n    background: #F2F2F2;\r\n}\r\n\r\n.flx_bx_grid_projct {\r\n    display: flex !important;\r\n}\r\n\r\n.brder_rmved_prjct {\r\n    border-top: none;\r\n    margin: 0px 35px;\r\n\r\n}\r\n\r\n.flx_bx_grid_projct {\r\n    width: 100%;\r\n}\r\n\r\n.wd_block .chakra-accordion__item:last-child {\r\n    border-bottom: none !important;\r\n}\r\n\r\n.chakra-accordion__item .wd_block button:last-child {\r\n    border-bottom: none !important;\r\n}\r\n\r\n\r\n/* drill club web page css started */\r\n/* drill club claims page css start */\r\n.cm_frm_claims {\r\n    margin: 0px 35px;\r\n}\r\n\r\n.cm_frm_claims p {\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.5px;\r\n    color: #000000;\r\n    padding: 33px 0px 17px;\r\n}\r\n\r\n.cm_frm_claims h1 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    color: #000000;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.cm_frm_claims label {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    /* identical to box height, or 133% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.cm_frm_claims input {\r\n    background: #FFFFFF;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 5px;\r\n    max-width: 286px;\r\n    width: 100%;\r\n    display: block;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.cm_frm_claims input:focus,\r\n.cm_frm_claims input[data-focus] {\r\n    z-index: 1;\r\n    border: 1px solid #C4C4C4;\r\n    box-shadow: none;\r\n}\r\n\r\n.claim_pg_dril_clb {\r\n    margin: 0px 35px;\r\n}\r\n\r\n.claim_pg_dril_clb h3 {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #000000;\r\n    padding: 42px 0px 22px;\r\n\r\n}\r\n\r\n.claim_pg_dril_clb .chakra-accordion {\r\n    border: 1px solid #C4C4C4;\r\n}\r\n\r\n.claim_pg_dril_clb button {\r\n    background: #F2F2F2;\r\n    height: 64px;\r\n    border-bottom: 1px solid #C4C4C4;\r\n}\r\n\r\n.claim_pg_dril_clb button:focus,\r\n.claim_pg_dril_clb buttonx[data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.claim_pg_dril_clb .chakra-accordion__item {\r\n    border-top-width: 0px;\r\n\r\n}\r\n\r\n.claim_pg_dril_clb .chakra-accordion__item:last-child {\r\n    border-bottom-width: 0px;\r\n\r\n}\r\n\r\n.claim_pg_dril_clb button:last-child {\r\n    border-bottom: 1px solid #C4C4C4;\r\n}\r\n\r\n.headingaccdion {\r\n\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.claim_pg_dril_clb .chakra-checkbox__label {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.15px;\r\n\r\n    color: #000000;\r\n}\r\n\r\n.points_claims {\r\n    font-weight: 700;\r\n}\r\n\r\n.claim_pg_dril_clb .chakra-stack {\r\n    padding: 15px 0px 10px;\r\n}\r\n\r\n.claim_pg_dril_clb .chakra-checkbox__control:focus,\r\n.claim_pg_dril_clb .chakra-checkbox__control[data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.bg_color_btn_claims {\r\n    background: #F2F2F2;\r\n    margin: 32px 35px 43px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    padding: 14px 20px;\r\n}\r\n\r\n.bg_color_btn_claims button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    padding: 8px 45px 10px;\r\n    margin: 0px;\r\n    display: block;\r\n    height: 32px;\r\n    transition: all 0.3s ease-in;\r\n\r\n}\r\n\r\n.bg_color_btn_claims button:focus,\r\n.bg_color_btn_claims button[data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.bg_color_btn_claims button:hover {\r\n    transition: all 0.3s ease-in;\r\n    background-color: #592C82 !important;\r\n}\r\n\r\n\r\n/* drill club claims page css end */\r\n/* submittal page css start  */\r\n.sbMittal_frm .chakra-form__label {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 9px;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n}\r\n\r\n.sbMittal_frm input {\r\n    background: #FFFFFF;\r\n    border-radius: 5px;\r\n    z-index: 1;\r\n}\r\n\r\n.sbMittal_frm input:focus,\r\n.sbMittal_frm input[data-focus] {\r\n    z-index: 1;\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n}\r\n\r\n.sbMittal_frm {\r\n    padding: 10px 0;\r\n}\r\n\r\n.tab_dt {\r\n    padding: 0px 35px !important;\r\n}\r\n\r\n.sbMittal_frm {\r\n    display: flex;\r\n}\r\n\r\n.sbMittal_frm .chakra-form-control {\r\n    margin-right: 20px;\r\n}\r\n\r\n.prct_crtjs {\r\n    padding: 0px 15px !important;\r\n}\r\n\r\n/* submittal page css end  */\r\n/* Project Order css started  */\r\n.date_cd_orders {\r\n    position: relative;\r\n}\r\n\r\n.date_cd_orders img {\r\n    position: absolute;\r\n    bottom: 8px;\r\n    right: 7px;\r\n    z-index: 2;\r\n}\r\n\r\n.sbMittal_frm select {\r\n    background: #FFFFFF;\r\n    border-radius: 5px;\r\n}\r\n\r\n/*.tble_dt tr:nth-child(4) {*/\r\n/*    background: #F2F2F2;*/\r\n/*}*/\r\n\r\n/* Project Order css end  */\r\n/* Manage project css start  */\r\n.dsipl_blck_prkj img {\r\n    max-width: 10px;\r\n    cursor: pointer;\r\n}\r\n\r\n.tble_dt_101 {\r\n    margin: 5px 35px;\r\n}\r\n\r\n/* Manage project css end  */\r\n/* Project Product History Page css start */\r\n.check_bx .chakra-checkbox__control {\r\n    background-color: #fff;\r\n    width: 24px;\r\n    height: 24px;\r\n}\r\n\r\n.check_bx .chakra-checkbox__control:focus,\r\n.check_bx .chakra-checkbox__control[data-focus] {\r\n    box-shadow: none !important;\r\n}\r\n\r\n.check_bx {\r\n    margin-top: 26px;\r\n}\r\n\r\n.img_tick_pph img {\r\n    max-width: 23px !important;\r\n    cursor: pointer;\r\n    margin: 0px auto;\r\n}\r\n\r\n.pph_btn {\r\n\r\n    background-color: #fcfcfc !important;\r\n    color: #000;\r\n    padding: 10px 60px !important;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    margin-top: 13px;\r\n\r\n}\r\n\r\n.pph_btn img {\r\n    padding-right: 5px;\r\n}\r\n\r\n/* Project Product History Page css start */\r\n/* my Order history page css start  */\r\n.advance_search {\r\n    text-align: right;\r\n    padding-top: 25px;\r\n    text-decoration: underline;\r\n}\r\n\r\n.brder_stsreq {\r\n    margin-right: 18px;\r\n}\r\n\r\n.brder_stsreq .chakra-avatar {\r\n    margin-right: 8px !important;\r\n\r\n}\r\n\r\n.pd_btdf_pt {\r\n    padding-bottom: 17px !important;\r\n}\r\n\r\n/* my Order history page css end  */\r\n/* Company Information page css start */\r\n.pd_tp_20 {\r\n    margin-top: 20px;\r\n}\r\n\r\n/* Company Information page css end */\r\n.qucik_order {\r\n    clear: both;\r\n    justify-content: space-between;\r\n}\r\n\r\n.lst_rdqk_rder {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n}\r\n\r\n\r\n.lst_rdqk_rder .dt_archive {\r\n    padding-left: 5px;\r\n    padding-top: 0px;\r\n}\r\n\r\n.flx_qk_order {\r\n    display: flex;\r\n\r\n}\r\n\r\n.btn_drpdwn {\r\n    margin-right: 10px !important;\r\n}\r\n\r\n.bg_strip_btn_save button:focus,\r\n.bg_strip_btn_save button[data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.men_item_qk_order {\r\n    padding: 5px;\r\n}\r\n\r\n.men_item_qk_order button {\r\n    line-height: 20px !important;\r\n    margin-bottom: 10px !important;\r\n}\r\n\r\n.men_item_qk_order button:last-child {\r\n\r\n    margin-bottom: 0px !important;\r\n}\r\n\r\n/* blog page css start  */\r\n.btn_blog_grid {\r\n    display: flex;\r\n}\r\n\r\n.btn_blog_grid a {\r\n    padding: 10px 20px;\r\n    border: 1px solid #592C82;\r\n    color: #fff;\r\n}\r\n\r\n.btn_blog_grid .chakra-select__wrapper {\r\n    max-width: 120px;\r\n    width: 100%;\r\n}\r\n\r\n.btn_blog_grid .chakra-select {\r\n    max-width: 300px;\r\n    width: 100%;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    color: #1A1A1A;\r\n    border: none !important;\r\n}\r\n\r\n.btn_blog_grid option {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    /* or 373% */\r\n\r\n    margin-bottom: 15px;\r\n\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n}\r\n\r\n.btn_blog_grid .chakra-select:focus,\r\n.btn_blog_grid .chakra-select [data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.grid_aside_blog {\r\n    justify-content: space-between;\r\n    padding: 36px 0px 24px;\r\n}\r\n\r\n.grid_aside_blog p {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n\r\n\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.grid_aside_blog img {\r\n    background-color: #4D4D4D;\r\n    border-radius: 5px;\r\n    height: 43px;\r\n    width: 43px;\r\n    margin: 20px 0px;\r\n    display: flex;\r\n    /* padding: 20px; */\r\n    padding-bottom: 10px;\r\n    padding-top: 10px;\r\n}\r\n\r\n.grid_aside_blog ul {\r\n    list-style: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    display: flex;\r\n    padding: 0px 21px;\r\n    align-items: center;\r\n}\r\n\r\n.grid_aside_blog li {\r\n    margin-right: 20px;\r\n}\r\n\r\n.grid_aside_blog li:last-child {\r\n    margin-right: 0px;\r\n}\r\n\r\n.grid_aside_blog a {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    /* identical to box height */\r\n\r\n\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n\r\n    color: #000000;\r\n\r\n}\r\n\r\n.grid_aside_blog a:hover {\r\n    text-decoration: none;\r\n}\r\n\r\n.flx_pagenation_blg_pg {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.bloc_blog {\r\n    background: #FFFFFF;\r\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\r\n\r\n}\r\n\r\n.bloc_blog_inner {\r\n    padding: 25px 20px 50px;\r\n}\r\n\r\n.bloc_blog_inner h2 {\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n    line-height: 22px;\r\n    /* identical to box height */\r\n\r\n    text-align: left;\r\n    letter-spacing: 0.1px;\r\n\r\n    /* Drillcut Purple */\r\n\r\n    color: #592C82;\r\n\r\n}\r\n\r\n.bloc_blog_inner h3 {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 120% */\r\n\r\n    text-align: left;\r\n    letter-spacing: 0.15px;\r\n\r\n    /* Drillcut Purple */\r\n    padding-top: 3px;\r\n\r\n    color: #592C82;\r\n}\r\n\r\n.bloc_blog_inner p {\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    /* or 143% */\r\n\r\n    text-align: left;\r\n    letter-spacing: 0.25px;\r\n    padding-top: 5px;\r\n    /* Black 90 (Text) */\r\n\r\n    color: #1A1A1A;\r\n\r\n}\r\n\r\n.bloc_blog img {\r\n    width: 100%;\r\n}\r\n\r\n/* blog page css end  */\r\n\r\n/* inner blog css start */\r\n.feat_product_inner_blog {\r\n    max-width: 1100px !important;\r\n}\r\n\r\n.feat_product_inner_blog h3 {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    text-align: center;\r\n    letter-spacing: 0.1px;\r\n    text-transform: uppercase;\r\n    color: #1A1A1A;\r\n}\r\n\r\n.feat_product_inner_blog h4 {\r\n    font-weight: 700;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    text-align: center;\r\n    letter-spacing: 0.18px;\r\n    color: #1A1A1A;\r\n    padding-top: 5px;\r\n    padding-bottom: 50px;\r\n}\r\n\r\n.about_us_content_mt_1 {\r\n    max-width: 860px;\r\n    margin: auto;\r\n    margin-top: 20px;\r\n    margin-bottom: 50px;\r\n    text-align: left;\r\n}\r\n\r\n.container_banner_img {\r\n    max-width: 1230px !important;\r\n    padding-right: 21px !important;\r\n    padding-left: 20px !important;\r\n}\r\n\r\n.email_subcriber_banner_img {\r\n    max-width: 526px;\r\n    width: 100%;\r\n}\r\n\r\n.email_subcriber_banner_img input {\r\n    background: #E9EAEB;\r\n    border-radius: 8px;\r\n    height: 48px;\r\n    color: #000000;\r\n    position: relative;\r\n}\r\n\r\n.email_subcriber_banner_img input:placeholder {\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 150% */\r\n\r\n    letter-spacing: 0.5px;\r\n\r\n    color: #000000;\r\n\r\n    opacity: 0.5;\r\n}\r\n\r\n.email_subcriber_banner_img button {\r\n\r\n    position: absolute;\r\n    background: #FFFFFF;\r\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\r\n    border-radius: 0px 8px 8px 0px;\r\n    color: #000;\r\n    right: 0px;\r\n    height: 48px;\r\n}\r\n\r\n.main_export_socialsect {\r\n    max-width: 1200px;\r\n    width: 100%;\r\n    margin: 0px auto;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    /* padding-right: 49px; */\r\n    padding: 0px 5px;\r\n\r\n}\r\n\r\n.main_export_social_tp_brder {\r\n    border-top: 1px solid #C4C4C4;\r\n    margin: 50px 0px 25px;\r\n}\r\n\r\n.main_export_socialsect button {\r\n    background: #EC7700;\r\n    border-radius: 5px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n    /* or 373% */\r\n\r\n    color: #FFFFFF;\r\n    text-transform: uppercase;\r\n    padding: 0px 44px;\r\n    height: 32px;\r\n    transition: all .5s ease;\r\n    color: #FFFFFF;\r\n\r\n}\r\n\r\n.main_export_socialsect button:hover {\r\n    transition: all .5s ease;\r\n    background: #592C82;\r\n    transition: all .5s ease;\r\n}\r\n\r\n.main_export_socialsect ul {\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    display: flex;\r\n}\r\n\r\n.main_export_socialsect li {\r\n    margin-right: 28px;\r\n}\r\n\r\n.main_export_socialsect li:last-child {\r\n    margin-right: 0px;\r\n}\r\n\r\n.abt_img_wd img {\r\n    width: 100%;\r\n}\r\n\r\n.main_container_inner_blg {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    -webkit-padding-start: 0rem !important;\r\n    padding-inline-start: 0rem !important;\r\n    padding-inline-end: 0rem !important;\r\n}\r\n\r\n.height_slider_iner_blg {\r\n    max-height: 615px;\r\n    background-color: transparent !important;\r\n    height: 624px;\r\n}\r\n\r\n.height_slider_iner_blg img {\r\n    width: 100% !important;\r\n    height: 627px;\r\n    object-fit: cover;\r\n}\r\n\r\n.lft_pd_blg {\r\n    left: 720px !important\r\n}\r\n\r\n.rht_pd_blg {\r\n    right: 720px !important\r\n}\r\n\r\n.cstm_arrow_lt1 .slick-slide {\r\n\r\n    transition: all 300ms ease;\r\n    position: relative;\r\n}\r\n\r\n.cstm_arrow_lt1 .slick-slide::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0px;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgb(0 0 0 / 64%);\r\n    left: 0;\r\n}\r\n\r\n.cstm_arrow_lt1 .slick-slide.slick-current::after {\r\n    display: none;\r\n}\r\n\r\n.main_container_inner_blg .slick-active img {\r\n    padding: 0px 21px;\r\n\r\n}\r\n\r\n.cstm_arrow_lt1 .slick-center {\r\n\r\n    color: #e67e22;\r\n    opacity: 1;\r\n\r\n}\r\n\r\n.slider-blog-arrowleft {\r\n    /* position: absolute; */\r\n    bottom: 0px;\r\n    left: 550px;\r\n}\r\n\r\n.slider-blog-arrowright {\r\n    /* position: absolute; */\r\n    bottom: 0px;\r\n    right: 550px;\r\n}\r\n\r\n.slider-blog-arrowleft svg {\r\n    fill: #C4C4C4;\r\n}\r\n\r\n.slider-blog-arrowright svg {\r\n    fill: #C4C4C4;\r\n}\r\n\r\n.main_container_inner_blg .slick-dots {\r\n    bottom: -45px !important;\r\n}\r\n\r\n.arrow_box_cont {\r\n    max-width: 300px;\r\n    width: 100%;\r\n    display: block;\r\n    margin: 0px auto;\r\n    position: relative;\r\n    top: 25px;\r\n    display: flex;\r\n    justify-content: space-around;\r\n}\r\n\r\n.tp_bar_innerblog_bg_color {\r\n    background: #592C82;\r\n    width: 100%;\r\n    text-align: left;\r\n    color: #FFF;\r\n}\r\n\r\n.tp_bar_innerblog {\r\n    padding: 70px 15px;\r\n    max-width: 1100px;\r\n    margin: auto;\r\n}\r\n\r\n.tp_bar_innerblog h2 {\r\n    letter-spacing: 1px;\r\n    text-transform: uppercase;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n}\r\n\r\n.tp_bar_innerblog h3 {\r\n    letter-spacing: -0.5px;\r\n    font-weight: 700 !important;\r\n    font-size: 54px !important;\r\n    line-height: 54px !important;\r\n    color: #FFF;\r\n}\r\n\r\n.tp_bar_innerblog button {\r\n    background: #FFFFFF;\r\n    text-transform: uppercase;\r\n    border-radius: 5px;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    line-height: 56px;\r\n\r\n    color: #EC7700;\r\n    padding: 0px 48px;\r\n    height: 30px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.tp_bar_innerblog button:focus,\r\n.tp_bar_innerblog button[data-focus] {\r\n    box-shadow: none;\r\n}\r\n\r\n.pd_tp_innerblog {\r\n    padding-top: 70px;\r\n}\r\n\r\n.pd_tp_innerblog p {\r\n    padding-top: 20px;\r\n}\r\n\r\n.inner_blg_h2Blginner {\r\n    color: #1A1A1A;\r\n}\r\n\r\n.pd_tp_innerblog .blog_design_mt {\r\n    margin: 0 8px 0px !important;\r\n}\r\n\r\n/* ruby page css start */\r\n.ruby-drill ul {\r\n    margin-bottom: 20px !important;\r\n    justify-content: start !important;\r\n}\r\n\r\n.css-22pr2o {\r\n    background-color: #c22e4f !important;\r\n}\r\n\r\n.ruby-drill li {\r\n    margin-left: 0px !important;\r\n    margin-right: 45px !important;\r\n}\r\n\r\n.ruby-drill li img {\r\n    margin: 0px auto;\r\n    max-width: 100px;\r\n    width: 100%;\r\n}\r\n\r\n/* ruby page css end */\r\n\r\n.smcx-embed {\r\n    margin: auto !important;\r\n    height: 500px !important;\r\n}\r\n\r\n.smcx-iframe-container {\r\n    height: 463px !important;\r\n}\r\n\r\n.cart_view_mobile {\r\n    display: none;\r\n}\r\n\r\n.data-block {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n}\r\n\r\n.mobile-cart {\r\n    padding: 0px 14px;\r\n    /*margin: 0 0 20 0;*/\r\n}\r\n\r\n.mobile-cart .data-block {\r\n    background-color: #F8F8F8;\r\n    padding: 15px 30px 30px 15px;\r\n    margin: 30px 0px;\r\n\r\n}\r\n\r\n.mobile-cart .product {\r\n    display: flex;\r\n    gap: 25px;\r\n    justify-content: space-between;\r\n}\r\n\r\n.mobile-cart .product .main-product-image img {\r\n    max-width: 170px;\r\n    width: 100%;\r\n    height: 127px;\r\n    object-fit: cover;\r\n\r\n}\r\n\r\n\r\n.mobile-cart .product .title {\r\n    font-weight: 700;\r\n    max-width: 36%;\r\n    font-size: 12px !important;\r\n}\r\n\r\n.mobile-cart .product > input {\r\n    width: 37%;\r\n}\r\n\r\n.mobile-cart .product p {\r\n    font-style: normal;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    letter-spacing: 0.15px;\r\n    text-transform: uppercase;\r\n    color: #000000;\r\n    padding: 0px;\r\n    width: 37%;\r\n    text-align: left;\r\n}\r\n\r\n.mobile-cart .product span {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    letter-spacing: 0.25px;\r\n    color: #000000;\r\n    max-width: 50%;\r\n    width: 100%;\r\n\r\n}\r\n\r\n.cart_view_mobile .chakra-collapse {\r\n    overflow: visible !important;\r\n}\r\n\r\n.mobile-cart .cart-content {\r\n    justify-content: flex-start !important;\r\n    gap: 30px !important;\r\n    /*align-items: center;*/\r\n}\r\n\r\n.mobile-cart .product .content {\r\n    width: 50% !important;\r\n}\r\n\r\n.mobile-cart .product .content .pd_name_bmt {\r\n    white-space: pre-line;\r\n    line-height: 1.1;\r\n    word-break: break-word;\r\n    display: table-cell;\r\n}\r\n\r\nimg.del_icon {\r\n    max-width: 18px !important;\r\n    width: 100% !important;\r\n    height: 20px !important;\r\n    object-fit: cover;\r\n    float: right;\r\n    margin-right: 5px;\r\n}\r\n\r\n.cart-additional-info {\r\n    width: 100%;\r\n    flex-direction: column;\r\n    align-items: end;\r\n}\r\n\r\n.cart-additional-info .price_dt_summry {\r\n    max-width: 350px;\r\n}\r\n\r\n.cart-additional-info .cart-checkout {\r\n    max-width: 360px;\r\n}\r\n\r\n.cart-additional-info .cart-checkout {\r\n    width: 100%;\r\n}\r\n\r\n.cart-additional-info .select-project {\r\n    width: 100%;\r\n}\r\n\r\n.bg_strip_no_margin {\r\n    margin: 0px;\r\n}\r\n\r\n/* ruby page media css start */\r\n@media (max-width: 560px) {\r\n    .drill_block_4 li {\r\n        margin-left: 0px;\r\n        margin-right: 15px !important;\r\n    }\r\n\r\n    .about_us_page_sliderContent {\r\n        font-size: 18px;\r\n        line-height: 22px;\r\n        padding: 0px 40px;\r\n        letter-spacing: 0.5px;\r\n    }\r\n\r\n    .box_homepage_designs_button_box {\r\n        bottom: 18px;\r\n    }\r\n\r\n    .chiled_header a {\r\n        position: inherit !important;\r\n        right: 0 !important;\r\n        top: 7px !important;\r\n    }\r\n\r\n    .chiled_header {\r\n        display: block !important;\r\n    }\r\n\r\n    .box_design {\r\n        margin: 15px 0 0;\r\n        background-size: 100%;\r\n        height: auto !important;\r\n        background-repeat: no-repeat;\r\n    }\r\n}\r\n\r\n/* ruby page media css end */\r\n\r\n@media (max-width: 1030px) {\r\n    .cart-additional-info .price_dt_summry,\r\n    .cart-additional-info .cart-checkout {\r\n        width: 100%;\r\n        max-width: 100%;\r\n    }\r\n\r\n    .cart-additional-info .price_dt_summry {\r\n        margin-right: 0px;\r\n        padding: 0 20px;\r\n    }\r\n}\r\n\r\n\r\n/* inner blog css end */\r\n@media (max-width: 1350px) {\r\n    .left_arrow_pd_cp {\r\n        left: 180px !important;\r\n    }\r\n\r\n    .right_arrow_pd_cp {\r\n        right: 180px !important;\r\n    }\r\n\r\n}\r\n\r\n\r\n@media (max-width: 1165px) {\r\n    .right_arrow_pd_cp {\r\n        display: none !important;\r\n    }\r\n\r\n    .project_order_pgs {\r\n        display: block !important;\r\n    }\r\n\r\n    .date_cd_orders img {\r\n        position: absolute;\r\n        bottom: 23px;\r\n        right: 7px;\r\n    }\r\n\r\n    .project_order_pgs input {\r\n        width: 100% !important;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .dril_club_wb p {\r\n        font-weight: 700;\r\n        font-size: 50px;\r\n        line-height: 35px;\r\n    }\r\n\r\n    .spec_dt {\r\n\r\n        margin: 0px 0px 0px 0px;\r\n    }\r\n\r\n    .spec_dt a {\r\n\r\n        font-size: 13px;\r\n    }\r\n\r\n    .left_arrow_pd_cp {\r\n        display: none !important;\r\n    }\r\n\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1220px) {\r\n    .articleproducts_mt_content {\r\n        padding: 15px;\r\n        /* height: 100%; */\r\n        display: block;\r\n        min-height: 200px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .main_export_socialsect {\r\n        padding: 0px 23px;\r\n    }\r\n\r\n    .dropdown__table td:first-child {\r\n        min-width: 148px;\r\n        width: 148px;\r\n    }\r\n\r\n    .dropdown__table td:nth-child(2) {\r\n        min-width: 148px;\r\n        width: 148px;\r\n    }\r\n\r\n    .dropdown__table td:nth-child(3) {\r\n        width: calc(100% - 296px);\r\n    }\r\n\r\n    .dropdown__table .product-cod-st1 {\r\n        max-width: 250px;\r\n    }\r\n\r\n    .dropdown__table td:nth-child(4) {\r\n        display: none;\r\n    }\r\n\r\n    .dropdown__table td:nth-child(5) {\r\n        display: none;\r\n    }\r\n\r\n    .dropdown__table td:nth-child(6) {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .modal_dataDrill_cbt {\r\n        width: 100%;\r\n    }\r\n    .whle_modal .chakra-modal__close-btn {\r\n        right: 5px;\r\n    }\r\n    .project_page {\r\n        display: block !important;\r\n    }\r\n\r\n    .feat_product_inner_blog h4 {\r\n        padding-bottom: 20px;\r\n    }\r\n\r\n    .cstm_arrow_lt1 .slick-slide::after {\r\n        position: inherit;\r\n    }\r\n\r\n    .feat_product_inner_blog {\r\n        padding-top: 20px;\r\n    }\r\n\r\n    .about_us_content_mt_1 {\r\n        padding: 0px !important;\r\n    }\r\n\r\n    .mb_pd_iner_blg {\r\n        padding: 0px !important;\r\n    }\r\n\r\n    .mini_container_mt {\r\n        -webkit-padding-start: 0rem !important;\r\n        padding-inline-start: 0rem !important;\r\n        padding-inline-end: 0rem !important;\r\n    }\r\n\r\n    .tp_bar_innerblog h3 {\r\n        font-size: 24px !important;\r\n        line-height: 30px !important;\r\n    }\r\n\r\n    .height_slider_iner_blg {\r\n        height: 300px !important;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .height_slider_iner_blg img {\r\n        height: 300px !important;\r\n    }\r\n\r\n    .abt_img_wd {\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .email_subcriber_banner_img {\r\n        max-width: 270px;\r\n    }\r\n\r\n    .grid_aside_blog {\r\n        display: block !important;\r\n    }\r\n\r\n    .btn_blog_grid a {\r\n\r\n        margin-bottom: 10px;\r\n        margin-top: 10px;\r\n        max-width: 100%;\r\n        padding: 9px 15px;\r\n        width: 48%;\r\n\r\n        display: block;\r\n        margin: 0px auto;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .grid_aside_blog p {\r\n        text-align: center;\r\n    }\r\n\r\n    .flx_pagenation_blg_pg {\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n\r\n    .btn_blog_grid .chakra-select__wrapper {\r\n        max-width: 48%;\r\n        width: 100%;\r\n    }\r\n\r\n    .btn_blog_grid {\r\n        flex-wrap: wrap;\r\n        padding-left: 28px;\r\n    }\r\n\r\n    .advance_search {\r\n        text-align: left;\r\n    }\r\n\r\n\r\n    .pph_btn {\r\n        width: 100% !important;;\r\n    }\r\n\r\n    .project_orders_tbl {\r\n        margin-bottom: 90px;\r\n    }\r\n\r\n    .project_order_pgs {\r\n        display: block !important;\r\n    }\r\n\r\n    .check_bx {\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .project_order_pgs input {\r\n        width: 100% !important;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    /*.container_padding_remove h2 {*/\r\n    /*    font-size: 12px !important;*/\r\n    /*}*/\r\n    .pd_add_mb_lr {\r\n        padding: 0px 15px !important;\r\n    }\r\n\r\n    .flx_spc_betwen {\r\n        display: block !important;\r\n    }\r\n\r\n    .check_heading {\r\n        font-size: 1.875rem !important;\r\n    }\r\n\r\n    .flx_spc_betwen .css-0 {\r\n        max-width: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n    .drill_block_3 h3 span {\r\n\r\n        display: inline-block;\r\n        padding-left: 5px;\r\n    }\r\n\r\n    .drill_block_3 br {\r\n        display: none;\r\n    }\r\n\r\n    .cm_frm_claims input {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .drill_block_1 a {\r\n\r\n        /* position: absolute; */\r\n\r\n        bottom: 11px;\r\n        left: 225px;\r\n    }\r\n\r\n    .drill_block_1 button {\r\n\r\n        margin-bottom: 25px;\r\n    }\r\n\r\n    .drill_block_4 {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .drill_block_4 ul {\r\n\r\n        justify-content: start;\r\n    }\r\n\r\n    .rill_flx_blxkCbt {\r\n        display: block !important;\r\n    }\r\n\r\n    .drill_block_2 {\r\n        padding-left: 0px;\r\n    }\r\n\r\n    .projct_dt {\r\n        margin: 5px 0px;\r\n    }\r\n\r\n    .brder_rmved_prjct {\r\n\r\n        margin: 0px 15px;\r\n    }\r\n\r\n    .flx_bx_grid_projct {\r\n        display: block !important;\r\n    }\r\n\r\n    .main_block_sp_offer_flx {\r\n        display: block !important;\r\n    }\r\n\r\n    .overlay-ribbon {\r\n        display: none;\r\n    }\r\n\r\n    .cls_ul_li_rill_clb li {\r\n        padding-right: 0px;\r\n    }\r\n\r\n    .rillRby_member {\r\n        display: block !important;\r\n    }\r\n\r\n    .main_block_sp_offer h6:before {\r\n\r\n        width: 100%;\r\n\r\n    }\r\n\r\n    .dril_club_wb img {\r\n        max-width: 250px;\r\n        display: block;\r\n        margin: inherit;\r\n        padding-left: 20px;\r\n        padding-bottom: 12px;\r\n    }\r\n\r\n    .dril_club_wb {\r\n\r\n        padding: 29px 0px;\r\n    }\r\n\r\n    .dril_club_wb p {\r\n\r\n        font-size: 32px;\r\n        padding-left: 20px;\r\n        text-align: left;\r\n    }\r\n\r\n    .mb_hd_rill {\r\n        display: block !important;\r\n    }\r\n\r\n    .pt_blcks_jc {\r\n        display: block !important;\r\n    }\r\n\r\n    .content_block_drill2 {\r\n\r\n        max-width: 100%;\r\n        margin-top: 25px;\r\n    }\r\n\r\n    .content_block_drill1 {\r\n\r\n        max-width: 100%;\r\n\r\n    }\r\n\r\n    .block_left_rill1 {\r\n        max-width: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n    .block_left_rill2 {\r\n        max-width: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n    .bg_banner_web {\r\n        padding: 175px 0px;\r\n    }\r\n\r\n    .dril_club_wb {\r\n        display: none;\r\n    }\r\n\r\n    .cnter_block_rillclb {\r\n        display: block !important;\r\n    }\r\n\r\n    .block_1_rill_clb {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .block_2_rill_clb {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .block_1_rill_clb ul {\r\n\r\n        padding-right: 11px;\r\n\r\n    }\r\n\r\n    .block_2_rill_clb ul {\r\n\r\n        padding-right: 11px;\r\n\r\n    }\r\n\r\n    .flx_mb_rill {\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .block_1_rill_clb .members_dt:after {\r\n        width: 100%;\r\n    }\r\n\r\n    .price_rill {\r\n\r\n        display: inline-block;\r\n    }\r\n\r\n    .block_2_rill_clb ul {\r\n        padding-bottom: 20px;\r\n        padding-top: 20px;\r\n    }\r\n\r\n    .block_1_rill_clb ul {\r\n        padding-bottom: 20px;\r\n        padding-top: 20px;\r\n    }\r\n\r\n    .main_block_sp_offer {\r\n        padding: 25px 20px;\r\n    }\r\n\r\n    .block_2_rill_clb .members_dt:after {\r\n        width: 100%;\r\n    }\r\n\r\n    .ct_img_rill {\r\n        display: block;\r\n    }\r\n\r\n    .ct_img_rill img {\r\n\r\n        display: block;\r\n        margin: 0px auto;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .blck_web_2_1 {\r\n        width: 50%;\r\n    }\r\n\r\n    .cntnt_blck_wrk_grw {\r\n        display: block !important;\r\n    }\r\n\r\n    .cntnt_blck_wrk_grw {\r\n\r\n        padding: 54px 0px 83px;\r\n    }\r\n\r\n    .block_left_rill1 h4 {\r\n        padding-bottom: 22px;\r\n    }\r\n\r\n    .explore-the-rewards span {\r\n\r\n        padding-top: 40px;\r\n        display: block;\r\n    }\r\n\r\n    .explore-the-rewards p {\r\n\r\n        padding-bottom: 156px;\r\n    }\r\n\r\n    .explore-the-rewards br {\r\n        display: none;\r\n    }\r\n\r\n    .tiers h6 {\r\n\r\n        padding: 50px 0px 35px;\r\n    }\r\n\r\n    .blck_web_2 {\r\n        display: flex;\r\n\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .acct_statment h2 {\r\n        text-align: left;\r\n    }\r\n\r\n    .acct_statment .price_dt_summry {\r\n        margin-top: 20px !important;\r\n    }\r\n\r\n    .flx_bx_drill_statment {\r\n        display: block;\r\n        margin: 25px 15px 0px;\r\n    }\r\n\r\n    .flx_bx_option_statment select {\r\n        width: 100%;\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .stment_clb_drill {\r\n        margin-bottom: 35px !important;\r\n    }\r\n\r\n    .spacer_75pstmt {\r\n        height: 55px !important;\r\n    }\r\n\r\n    .acc_ctent_block {\r\n        padding: 28px 15px 20px 15px;\r\n    }\r\n\r\n    .account_info {\r\n        margin-bottom: 83px !important;\r\n    }\r\n\r\n    .invoice_tble_cm_mn {\r\n        margin: 0px 15px;\r\n    }\r\n\r\n    .btPd_voic {\r\n        margin: 20px 15px 10px !important;\r\n        display: block;\r\n        padding-bottom: 20px;\r\n    }\r\n\r\n    .cstm_invoices {\r\n        margin: 0px 5px;\r\n    }\r\n\r\n\r\n    .fg_pw_blck {\r\n        height: 560px !important;\r\n    }\r\n\r\n    .srch_filter input {\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .srch_filter {\r\n        display: block !important\r\n    }\r\n\r\n    .srch_filter button {\r\n\r\n        width: 100%;\r\n        margin-bottom: 30px;\r\n    }\r\n\r\n    .pd_tp_bm_tc {\r\n        margin: 30px 14px 53px !important;\r\n    }\r\n\r\n    .box_form_blck {\r\n        margin: 0px 14px;\r\n    }\r\n\r\n    .mb_st_hd h2 {\r\n        border-bottom: 1px solid #C4C4C4;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .hd_cart_mb_hd {\r\n        display: none;\r\n    }\r\n\r\n    .hd_md_dtps {\r\n        display: block;\r\n    }\r\n\r\n    .pd_rmReorders {\r\n        margin-bottom: 20px !important;\r\n    }\r\n\r\n    .bg_strip_btn_save {\r\n        background: #f2f2f2;\r\n        /* margin-top: 250px; */\r\n        margin: 50px 14px 50px;\r\n    }\r\n\r\n    .hd_desktop_btn {\r\n        display: none !important;\r\n    }\r\n\r\n\r\n    .checkOut_bt_cart_shoppig {\r\n        line-height: 36px !important;\r\n        margin-bottom: 65px;\r\n    }\r\n\r\n    .qucik_order {\r\n        display: block !important;\r\n    }\r\n\r\n    .qucik_order {\r\n        margin: 30px 0px 52px !important;\r\n    }\r\n\r\n    .lst_rdqk_rder {\r\n\r\n        margin-bottom: 10px !important;\r\n    }\r\n\r\n    .mb_pd_tp_qkahuser {\r\n        /* padding-top: 13px !important; */\r\n    }\r\n\r\n    .checkOut_bt_cart {\r\n        margin-top: 30px;\r\n    }\r\n\r\n    .hd_cart_mb_hd_btn {\r\n        /* display: none !important; */\r\n    }\r\n\r\n    .cart_container h2 {\r\n        font-weight: 700;\r\n        font-size: 24px;\r\n        line-height: 24px;\r\n        /* identical to box height, or 100% */\r\n\r\n        text-align: center;\r\n        letter-spacing: 0.18px;\r\n\r\n        color: #000000;\r\n        padding: 30px 0px;\r\n    }\r\n\r\n    .hd_mb_bndle {\r\n        display: block;\r\n    }\r\n\r\n    .table_grid_mob {\r\n        margin-top: 23px;\r\n    }\r\n\r\n    .pd_tp_mm li {\r\n        padding-top: 37px !important;\r\n    }\r\n\r\n    .table_grid_mob_1 li {\r\n        padding-top: 19px;\r\n    }\r\n\r\n    .bundle_tbl_bx {\r\n        margin: 40px 0px 33px;\r\n    }\r\n\r\n    .cstm_arrow_lt .slick_arrows_custom_logo {\r\n\r\n        top: 55% !important;\r\n    }\r\n\r\n    .last_bundleTbl-1 {\r\n\r\n        margin: 0px 22px 35px;\r\n    }\r\n\r\n    .mb_pd_slider {\r\n\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .model_pd .form-login h2 {\r\n        padding-top: 70px;\r\n    }\r\n\r\n    .spec_table {\r\n        display: none;\r\n    }\r\n\r\n    .accrdion_box {\r\n        display: block;\r\n        width: 100%;\r\n    }\r\n\r\n\r\n    .spec_card {\r\n        margin: 0px 22px 33px;\r\n    }\r\n\r\n    .spec_dt {\r\n\r\n        margin: 0px 25px 0px 25px;\r\n    }\r\n\r\n    .block_feat {\r\n        margin: 40px 22px 33px;\r\n    }\r\n\r\n    .capliry_h2 {\r\n        padding: 5px 0px;\r\n    }\r\n\r\n    .flx_bfeatInner {\r\n        display: block !important;\r\n    }\r\n\r\n    .btn_1dwnlod {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .video_block {\r\n\r\n        margin: 40px 22px 33px;\r\n    }\r\n\r\n    .right_arrow_pd_cp {\r\n        display: none !important;\r\n    }\r\n\r\n    .stock_data {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .main_slider_block_prduct {\r\n        height: 375px;\r\n    }\r\n\r\n    .Img_block_pd_slide_prduct img {\r\n        top: 37%;\r\n    }\r\n\r\n    .left_arrow_pd_cp {\r\n        display: none !important;\r\n    }\r\n\r\n\r\n    .main_block_slider {\r\n        box-shadow: none !important;\r\n        display: block;\r\n        margin: 0px;\r\n    }\r\n\r\n    .wd_60_pd_slider {\r\n        max-width: 95%;\r\n        /* margin: 10px 30px; */\r\n        margin: 20px auto;\r\n    }\r\n\r\n    .wd_40_pd_details {\r\n        max-width: 100%;\r\n        padding: 20px 20px 30px;\r\n    }\r\n\r\n    .product_detail_page {\r\n        padding: 0px !important;\r\n    }\r\n\r\n    .rm_bgntes {\r\n        margin: 0px 0px 0px 0px !important;\r\n    }\r\n\r\n    .price_dt_summry {\r\n        float: none;\r\n        margin-inline-start: 0em !important;\r\n    }\r\n\r\n    .option_form {\r\n        margin: 20px 15px 0px 15px;\r\n    }\r\n\r\n    .lt_brder {\r\n        display: block !important;\r\n        position: inherit;\r\n        margin-left: 0px;\r\n    }\r\n\r\n    .flx_bx_stp .lt_pr {\r\n        margin-left: 0px;\r\n    }\r\n\r\n    .lt_brder:after {\r\n        position: inherit;\r\n        content: '';\r\n        border: none;\r\n    }\r\n\r\n    .search_filter input {\r\n        width: 100%;\r\n    }\r\n\r\n    .block_tb_dt {\r\n        display: block !important;\r\n    }\r\n\r\n    .tble_dt {\r\n        display: none !important;\r\n    }\r\n\r\n    .dsipl_blck_prkj {\r\n        display: block !important;\r\n        margin: 5px 0px !important;\r\n    }\r\n\r\n    .qt_mb_pg {\r\n        /* display: none; */\r\n    }\r\n\r\n    .bd_crum h1 {\r\n\r\n        font-size: 24px;\r\n        /* padding-left: 32px; */\r\n\r\n    }\r\n\r\n    .tab_bar {\r\n\r\n        margin: 20px 15px;\r\n    }\r\n\r\n    .new_roles {\r\n        display: block !important;\r\n        margin: 0px 15px;\r\n    }\r\n\r\n    .edit_roles {\r\n        display: block !important;\r\n        margin: 0px 15px;\r\n    }\r\n\r\n    .new_roles img {\r\n        max-width: 20px;\r\n    }\r\n\r\n    .bx_flx_filt {\r\n        display: block;\r\n    }\r\n\r\n    .rl_dets {\r\n        margin: 0px 15px 35px;\r\n    }\r\n\r\n    .tab_dt a {\r\n        display: block;\r\n        text-align: center;\r\n    }\r\n\r\n    .user_dt {\r\n        display: block !important;\r\n    }\r\n\r\n    .user_dt .hd_mdl {\r\n        display: none !important;\r\n    }\r\n\r\n    .tble_dt_101 {\r\n        margin: 5px 15px !important;\r\n    }\r\n\r\n    .hd_menu {\r\n        display: block;\r\n        -webkit-padding-start: 0rem !important;\r\n        padding-inline-start: 0rem !important;\r\n        padding-inline-end: 0rem !important;\r\n    }\r\n\r\n    .options_txt {\r\n        display: block;\r\n    }\r\n\r\n    .wrap_bx {\r\n        width: 50%;\r\n    }\r\n\r\n    .bgFlx {\r\n        flex-flow: wrap;\r\n    }\r\n\r\n    .options_txt {\r\n\r\n        margin: 20px 15px;\r\n        display: none;\r\n    }\r\n\r\n    .bg_color_acrhove {\r\n        margin: 20px 15px;\r\n\r\n    }\r\n\r\n    .button_list_dt li:hover {\r\n        transform: none;\r\n    }\r\n\r\n    .bgFlx {\r\n        margin: 0px 15px 20px 15px;\r\n    }\r\n\r\n    .wd_50_prview {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .space_sd1 {\r\n        margin: 0px;\r\n    }\r\n\r\n    .space_sd {\r\n        margin: 0px;\r\n    }\r\n\r\n    .bg_pj {\r\n        margin: 0px 15px 0px 15px;\r\n    }\r\n\r\n    .dt_frman {\r\n        margin: 0px 15px 20px 15px;\r\n        height: auto;\r\n\r\n    }\r\n\r\n    .button_list_dt img {\r\n        max-width: 24px;\r\n        object-fit: contain;\r\n    }\r\n\r\n    .button_list_dt li {\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    .button_list_dt li {\r\n        text-align: left;\r\n        padding: 5px 23px 5px 23px;\r\n        margin-bottom: 14px;\r\n    }\r\n\r\n    .button_list_dt_spn {\r\n        position: absolute;\r\n        top: 19px;\r\n\r\n    }\r\n\r\n    .button_list_dt .chakra-avatar {\r\n        display: inline-block;\r\n        padding: 0px;\r\n        margin: 0px;\r\n    }\r\n\r\n    .button_list_dt {\r\n        display: block;\r\n        margin-inline-start: 0em !important;\r\n        margin-bottom: 55px;\r\n        padding: 12px 15px 10px;\r\n    }\r\n\r\n    .flx_bx_wd {\r\n        display: block !important;;\r\n    }\r\n\r\n    .color_strip {\r\n\r\n        margin: 0px 15px 0px 15px;\r\n    }\r\n\r\n    .side-menuct {\r\n        display: none;\r\n    }\r\n\r\n    .image-360 {\r\n        width: 50%;\r\n    }\r\n\r\n\r\n    .pages_project_bar_sub_heading {\r\n        display: none;\r\n    }\r\n\r\n    .List_db1 {\r\n        padding-bottom: 0px;\r\n    }\r\n\r\n    .side-menuct {\r\n        position: absolute;\r\n        z-index: 999;\r\n        background-color: #fff;\r\n    }\r\n\r\n    .hd_dtp {\r\n        display: block;\r\n    }\r\n\r\n    .box_width_30 {\r\n        width: 100%;\r\n        max-width: 100%;\r\n    }\r\n\r\n    .box_width_70 {\r\n        width: 100%;\r\n    }\r\n\r\n    .bd_crum .chakra-avatar {\r\n        margin-left: 10px;\r\n    }\r\n\r\n    .bd_crum {\r\n\r\n        padding: 20px 14px;\r\n    }\r\n\r\n    .qoute_pg {\r\n        display: block !important;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 930px) {\r\n    .brand_logo_aboutuspage .css-1wkijx5 {\r\n        grid-template-columns: repeat(1, 1fr) !important;\r\n    }\r\n\r\n    .brand__page p {\r\n        padding-top: 20px !important;\r\n        font-size: 15px !important;\r\n        line-height: 23px !important;\r\n    }\r\n\r\n    .brand__page .brands_image .css-0 {\r\n        max-width: 100% !important;\r\n    }\r\n\r\n    .brand_logo_aboutuspage .css-70qvj9 .css-0 a {\r\n        position: inherit;\r\n        bottom: 10px;\r\n    }\r\n\r\n    .brands_image .css-70qvj9 {\r\n        display: block;\r\n    }\r\n\r\n    .css-1wkijx5 .brands_image img, .bg_image img {\r\n        width: 100%;\r\n        object-fit: contain;\r\n        background: #f1f1f1;\r\n        max-width: 100% !important;\r\n    }\r\n\r\n    .brand__page .css-1nravos {\r\n\r\n        width: 100%;\r\n        margin: 0px auto;\r\n    }\r\n}\r\n\r\n@media (max-width: 580px) {\r\n    .table_grid_mob_1 li {\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .main_export_socialsect {\r\n        display: block;\r\n    }\r\n\r\n    .main_export_socialsect ul {\r\n        justify-content: center;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .drill_block_2 {\r\n        display: block;\r\n    }\r\n\r\n    .drill_block_3 {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .table_grid_mob_2 li {\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .table_grid_mob_2 button {\r\n        margin-top: 5px;\r\n    }\r\n\r\n    .drill_block_4 .drill_select_bx {\r\n        -webkit-padding-start: 0px;\r\n        padding-inline-start: 0px;\r\n    }\r\n\r\n    .drill_select_bx {\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .claim_pg_dril_clb {\r\n        margin: 0px 15px;\r\n    }\r\n\r\n    .cm_frm_claims {\r\n        margin: 0px 15px;\r\n    }\r\n\r\n    .drill_clb_bg {\r\n        margin: 35px 15px 0px;\r\n    }\r\n\r\n    .cm_frm_claims p {\r\n        display: block;\r\n        text-align: left;\r\n    }\r\n\r\n    .bg_color_btn_claims {\r\n        margin: 32px 15px 43px;\r\n    }\r\n\r\n    .sbt_dt {\r\n        margin-bottom: 90px;\r\n    }\r\n\r\n    .price_dt a {\r\n        margin: 30px 0px 9px;\r\n    }\r\n\r\n    .option_table img {\r\n        max-width: 100%;\r\n\r\n    }\r\n}\r\n\r\n@media (max-width: 560px) {\r\n    .model_dt {\r\n        width: 90% !important;\r\n    }\r\n\r\n    .det_checkt {\r\n        margin-left: 80px;\r\n    }\r\n\r\n    .flx_sp_bt .price_tl_pr {\r\n        font-weight: 700;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .pd_bm_bill_dt_pg {\r\n        margin-bottom: 50px;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .check_bx_blck .chakra-checkbox__label {\r\n\r\n        font-size: 14px;\r\n    }\r\n\r\n    .check_bx_blck {\r\n        padding: 40px 15px 0px;\r\n    }\r\n\r\n    .flx_sp_bt .price_tl_pr1 {\r\n        font-weight: 700;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .drill_block_4 li p {\r\n\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .drill_block_4 li {\r\n        margin-left: 0px;\r\n        margin-right: 15px;\r\n    }\r\n\r\n    .drill_block_3 a {\r\n\r\n        margin-top: 20px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n\r\n    .model_dt button {\r\n        font-size: 12.5px;\r\n    }\r\n\r\n    .table_grid_mob_1 {\r\n        max-width: 36%;\r\n        width: 100%;\r\n    }\r\n\r\n    .table_grid_mob_2 {\r\n        max-width: 34%;\r\n        width: 100%;\r\n    }\r\n\r\n    .table_grid_mob_1 li {\r\n\r\n        font-size: 13px;\r\n    }\r\n\r\n    .table_grid_mob_2 li {\r\n\r\n        font-size: 13px;\r\n    }\r\n\r\n    .ct_invoice {\r\n        display: block;\r\n        height: auto !important;\r\n    }\r\n\r\n    .ct_outstading {\r\n        text-align: left !important;\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .pg_bar .css-150tos1 {\r\n\r\n        max-width: 70%;\r\n    }\r\n\r\n    .btn_blog_grid a {\r\n        width: 100%;\r\n\r\n    }\r\n\r\n    .btn_blog_grid .chakra-select {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .btn_blog_grid .chakra-select__wrapper {\r\n        max-width: 100%;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n@media (max-width: 370px) {\r\n    .first_bx_accrdion {\r\n\r\n        max-width: 100px;\r\n    }\r\n\r\n    .container_padding_remove h2 {\r\n        font-size: 20px !important;\r\n    }\r\n\r\n    .check_heading {\r\n        font-size: 1.875rem !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 390px) {\r\n\r\n    .container_padding_remove h2 {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    .check_heading {\r\n        font-size: 1.875rem !important;\r\n    }\r\n}\r\n\r\n@media (min-width: 560px) and (max-width: 767px) {\r\n    .mobile_logo img {\r\n        max-width: 140px;\r\n        width: auto;\r\n    }\r\n\r\n    .searchBox_searchPage form.ais-SearchBox-form {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        max-width: 38%;\r\n        width: 100%;\r\n        top: 50%;\r\n        left: 50%;\r\n        -ms-transform: translate(-50%, -50%);\r\n        transform: translate(-50%, -50%);\r\n        text-align: center;\r\n        position: absolute;\r\n        top: -42px;\r\n    }\r\n}\r\n\r\n/*vijay css start*/\r\n/* css 13-7-2022 */\r\n.box-cr {\r\n    background: #F2F2F2 !important;\r\n    border: none !important;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    font-weight: 400;\r\n}\r\n\r\n.promo_img_banner {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    background-position: right;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n\r\n}\r\n\r\n.bg_color_promo_img_nner {\r\n    padding-right: 60px;\r\n}\r\n\r\n.bg_color_promo_img_nner img {\r\n    max-width: 590.74px;\r\n    height: 433.01px;\r\n    width: 100%;\r\n}\r\n\r\n.bg_color_promo_pg {\r\n    background: #F2F2F2;\r\n    width: 100%;\r\n    padding-right: 42px;\r\n    margin-right: 50px;\r\n    margin-left: 20px;\r\n}\r\n\r\n.input-invoice-margin {\r\n    display: flex;\r\n}\r\n\r\n.input-invoice-mi {\r\n    margin-top: -5px;\r\n    margin-left: 10px;\r\n\r\n}\r\n\r\n.radio-btn-sp .chakra-radio__control:focus,\r\n.radio-btn-sp .chakra-radio__control[data-focus] {\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.table-or {\r\n    margin-top: 30px;\r\n}\r\n\r\n.listed-or {\r\n    margin-top: 30px;\r\n}\r\n\r\n/*\r\n.table-list-mr {} */\r\n\r\n.table-or-border {\r\n\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.table-or {\r\n    margin-top: 10px;\r\n}\r\n\r\n.listed-or {\r\n    margin-top: 30px;\r\n}\r\n\r\n.table-list-mr {\r\n    margin: 0px 15px !important;\r\n\r\n}\r\n\r\n.new-user-mr {\r\n    margin-top: 30px;\r\n}\r\n\r\n.new-user-hr {\r\n\r\n\r\n    margin: 0 35px;\r\n}\r\n\r\n.new-user-br-none {\r\n    border: none;\r\n}\r\n\r\n.new-user-br-none1 {\r\n    border: none;\r\n    padding-top: 20px;\r\n}\r\n\r\n.user-checkbox-mr {\r\n    display: table !important;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.new-content-mr {\r\n    padding-top: 0px !important;\r\n}\r\n\r\n.new-content-mr1 {\r\n    padding-bottom: 0px !important;\r\n\r\n}\r\n\r\n.new-content-input-mr {\r\n    width: 50% !important;\r\n    display: block !important;\r\n}\r\n\r\n.my-price-hr {\r\n    /* / border-bottom: 1px solid #ccc; / */\r\n    margin-top: 20px;\r\n\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.my-price-text {\r\n    margin-top: 20px;\r\n\r\n}\r\n\r\n.my-price-text p {\r\n    font-size: 14px;\r\n    line-height: 30px;\r\n\r\n}\r\n\r\n.price-checkbox-mr {\r\n    display: table !important;\r\n    padding-bottom: 10px;\r\n    font-size: 12px !important;\r\n    text-transform: capitalize !important;\r\n}\r\n\r\n.price-checkbox-main {\r\n    margin: 20px 0;\r\n}\r\n\r\n.price-btn-mr {\r\n    padding: 20px 20px !important;\r\n    font-size: 14px !important;\r\n}\r\n\r\n.heading-rr {\r\n    padding-top: 0px !important;\r\n    padding-bottom: 0px !important;\r\n}\r\n\r\n.text-nn {\r\n    padding-top: 15px !important;\r\n    padding-bottom: 0px !important;\r\n}\r\n\r\n.price-radio-btn {\r\n    margin-top: 40px;\r\n}\r\n\r\n.radio-btn-sp {\r\n    margin-right: 40px;\r\n}\r\n\r\n.image-rr {\r\n    display: inline;\r\n    top: -2px;\r\n    position: absolute;\r\n    left: 100px;\r\n}\r\n\r\n.box-cr-rw {\r\n    background: #F2F2F2 !important;\r\n    padding: 15px 0 !important;\r\n}\r\n\r\n.box-cr::placeholder {\r\n    color: #000000;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    font-weight: 400;\r\n}\r\n\r\n.box-cr .css-12y4u6o {\r\n    border-color: none !important;\r\n}\r\n\r\n.box-cr input:focus {\r\n\r\n    border-color: none !important;\r\n}\r\n\r\n.test tr:nth-of-type(even) {\r\n    background: #f8f8f8 !important;\r\n\r\n}\r\n\r\n.test tr:nth-of-type(odd) td {\r\n    background: none !important;\r\n}\r\n\r\n.test td img {\r\n    max-width: 200px;\r\n}\r\n\r\n.add-border-text {\r\n    border-bottom: 1px solid;\r\n}\r\n\r\n.add-border-text p {\r\n    font-size: 14px;\r\n    text-align: left;\r\n    color: #F58220;\r\n    padding: 10px 0;\r\n    margin-top: 20px;;\r\n}\r\n\r\n.wd-94 {\r\n    margin: 0 35px;\r\n}\r\n\r\n.bg-add-to {\r\n    background: #f2f2f2;\r\n    padding: 14px 0px;\r\n}\r\n\r\n.add-to-btn-pd {\r\n    padding: 0px;\r\n    margin: 0px;\r\n}\r\n\r\n.add-to-btn {\r\n    border-radius: 10px;\r\n    color: #fff;\r\n    padding: 7px 12px 5px 14px;\r\n    font-size: 15px;\r\n    margin-left: auto;\r\n\r\n}\r\n\r\n.btn-clr-bl {\r\n    background: #4D4D4D !important;\r\n    margin-right: 10px;\r\n}\r\n\r\n.btn-clr-invoice-bl {\r\n    background: #EC7700 !important;\r\n    padding: 5px 60px !important;\r\n}\r\n\r\n.btn-clr {\r\n    background: #EC7700 !important;\r\n}\r\n\r\n.bg-invoice-to {\r\n    background: #f2f2f2;\r\n    padding: 14px 13px;\r\n    margin: 0 35px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.modal-form-group-main {\r\n    margin: 0 35px;\r\n}\r\n\r\n.modal-form-group-lv {\r\n    margin-top: 15px;\r\n    margin-bottom: 25px;\r\n    position: relative;\r\n    margin-right: 10px;\r\n}\r\n\r\n.modal-form-group-lv .input-icon-lv img {\r\n    opacity: 1;\r\n    position: absolute;\r\n    z-index: 1;\r\n    left: 8px;\r\n    top: 10px;\r\n    color: #979faf;\r\n    width: 20px;\r\n    height: 20px;\r\n    object-fit: contain;\r\n}\r\n\r\n.modal-form-group-lv .modal-form-input-lv {\r\n    display: block !important;\r\n    padding: 0px 8px 0px 34px !important;\r\n    width: 150px;\r\n    height: 40px;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n}\r\n\r\n.modal-form-group-lv .modal-form-input-btn {\r\n    display: block !important;\r\n    width: 100%;\r\n    height: 40px;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    background: #EC7700;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n}\r\n\r\n.btn-clr-invoice-tb {\r\n    background: #EC7700 !important;\r\n    padding: 5px 40px !important;\r\n    color: #fff;\r\n    font-size: 12px;\r\n}\r\n\r\n.checkbox-st {\r\n    background: #fff;\r\n\r\n    border: 1px solid #E2E2E2;\r\n    border-radius: 4px;\r\n\r\n}\r\n\r\n.tble_fd tr:nth-child(even) {\r\n    background: #F2F2F2 !important;\r\n}\r\n\r\n\r\n.hr-brder {\r\n    border: 0.1px solid #C4C4C4;\r\n    margin: 15px 0;\r\n}\r\n\r\n.dt_frman-cr {\r\n    height: 200px !important;\r\n}\r\n\r\n.model-block-none {\r\n    display: block;\r\n}\r\n\r\n.open-drawer-none {\r\n    display: none;\r\n}\r\n\r\n.wd_50_prview-wd {\r\n    width: 50%;\r\n    margin: 0 35px;\r\n}\r\n\r\n.wd_50_prview-wd-1 {\r\n    margin: 0 35px;\r\n    margin-top: 15px;\r\n}\r\n\r\n.wd_50_hr-1 {\r\n    border-bottom: 1px solid #444;\r\n    margin-top: 30px;\r\n}\r\n\r\n.lt_pr-1 {\r\n    margin-left: 40px;\r\n}\r\n\r\n.mr-t {\r\n    margin-top: 20px;\r\n}\r\n\r\n.restore-mr-1 {\r\n    display: flex;\r\n}\r\n\r\n.icon-mr {\r\n    margin-top: 15px;\r\n    margin-right: 15px;\r\n}\r\n\r\n.mr-rr1 {\r\n    position: relative;\r\n}\r\n\r\n.mr-rr1::after {\r\n    position: absolute;\r\n    border-right: none !important;\r\n}\r\n\r\n.increse-colr {\r\n    width: 130px;\r\n}\r\n\r\n.product-cod-st1 {\r\n    width: 300px;\r\n    background-color: #fff !important;\r\n    border: 1px solid #444 !important;\r\n    border-radius: none !important;\r\n}\r\n\r\n.product-cod-st1:focus {\r\n    border: 1px solid #444 !important;\r\n}\r\n\r\n/* product web gallery */\r\n.web_gallery {\r\n    display: inline-block;\r\n}\r\n\r\n/* product web gallery */\r\n.price_dt2 {\r\n    border-bottom: none !important;\r\n}\r\n\r\n.lt_pr-4 {\r\n    /* margin-right: 20px; */\r\n}\r\n\r\n.restore-mr-5 {\r\n    gap: 20px;\r\n}\r\n\r\n.lt_pr_4sbmt_det {\r\n    /* margin-right: 12px; */\r\n}\r\n\r\n/*.option_table tr:nth-child(4) {*/\r\n/*    background: rgb(242 242 242 / 50%);*/\r\n/*}*/\r\n\r\n.promo-bg-1 {\r\n    background: #2FA8DF !important;\r\n    padding: 175px 90px;\r\n    width: 657px;\r\n\r\n}\r\n\r\n.promo-bg-1 img {\r\n    margin: 0 0;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.promo-bg-2 {\r\n    font-weight: 300 !important;\r\n    font-size: 24px !important;\r\n    line-height: 28px !important;\r\n    letter-spacing: 0.15px;\r\n    color: #FFFFFF;\r\n    text-align: left !important;\r\n}\r\n\r\n.title-c {\r\n    text-align: center !important;\r\n    padding: 70px 15px;\r\n    max-width: 1200px;\r\n    letter-spacing: -0.5px;\r\n    font-weight: 700 !important;\r\n    font-size: 54px !important;\r\n    line-height: 54px !important;\r\n    margin: auto;\r\n}\r\n\r\n.title-c-bg {\r\n    background: #592C82;\r\n    width: 100%;\r\n    text-align: center;\r\n    color: #FFF;\r\n}\r\n\r\n.img-re {\r\n    object-fit: cover;\r\n    width: 100%;\r\n}\r\n\r\n.box-c-content {\r\n    width: 100%;\r\n}\r\n\r\n.parple-bg-d {\r\n    width: 100%;\r\n    height: auto;\r\n    background: ;\r\n}\r\n\r\n.parple-text-it {\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n}\r\n\r\n.parple-text-its {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n}\r\n\r\n.parple-text-it-1 {\r\n    margin: 20px 0 43px 0;\r\n}\r\n\r\n.product-bg-t-img {\r\n    width: 100% !important;\r\n    height: 433px !important;\r\n}\r\n\r\n.product-bg-t-img img {\r\n    width: 100% !important;\r\n    height: 390px !important;\r\n}\r\n\r\n.product-bg-t-paddinng {\r\n    padding: 0 300px 0 0px;\r\n    width: 800px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.product-bg-t-p-text {\r\n    font-size: 24px;\r\n    font-weight: 700 !important;\r\n    line-height: 24px;\r\n    color: #1A1A1A;\r\n    opacity: 0.5;\r\n}\r\n\r\n.product-bg-t-p-sub {\r\n    background: #EC7700;\r\n    /*height: 50px;*/\r\n    font-size: 15px;\r\n    color: #fff !important;\r\n    line-height: 45px !important;\r\n    width: 208px;\r\n\r\n}\r\n\r\n.product-bg-t-p-sub:hover {\r\n    background: #EC7700 !important;\r\n    text-decoration: none !important;\r\n    border: 1px solid #EC7700 !important;\r\n\r\n\r\n}\r\n\r\n.product-bg-t-p-sub-1 {\r\n    color: #fff !important;\r\n}\r\n\r\n.product-bg-t-p-img {\r\n    padding: 20px 0px !important;\r\n    width: 200px;\r\n}\r\n\r\n.product-bg-t {\r\n    background: #F2F2F2;\r\n}\r\n\r\n.product-bg-t-or {\r\n    display: flex !important;\r\n}\r\n\r\n/* css 13-07-2022 */\r\n.box-cr {\r\n    background: #F2F2F2 !important;\r\n    border: none !important;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    font-weight: 400;\r\n}\r\n\r\n.input-invoice-margin {\r\n    display: flex;\r\n}\r\n\r\n.input-invoice-mi {\r\n    margin-top: -5px;\r\n    margin-left: 10px;\r\n\r\n}\r\n\r\n.radio-btn-sp .chakra-radio__control:focus,\r\n.radio-btn-sp .chakra-radio__control[data-focus] {\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.table-or {\r\n    margin-top: 30px;\r\n}\r\n\r\n.listed-or {\r\n    margin-top: 30px;\r\n}\r\n\r\n/*\r\n.table-list-mr {} */\r\n\r\n.table-or-border {\r\n    /* border-bottom: 1px solid #444; */\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n}\r\n\r\n\r\n.table-or {\r\n    margin-top: 10px;\r\n}\r\n\r\n.listed-or {\r\n    margin-top: 30px;\r\n}\r\n\r\n.table-list-mr {\r\n    margin: 0px 15px !important;\r\n\r\n}\r\n\r\n.new-user-mr {\r\n    margin-top: 30px;\r\n}\r\n\r\n.new-user-hr {\r\n    /* border-bottom: 1px solid #ccc; */\r\n\r\n    margin: 0 35px;\r\n}\r\n\r\n.new-user-br-none {\r\n    border: none;\r\n}\r\n\r\n.new-user-br-none1 {\r\n    border: none;\r\n    padding-top: 20px;\r\n}\r\n\r\n.user-checkbox-mr {\r\n    display: table !important;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.new-content-mr {\r\n    padding-top: 0px !important;\r\n}\r\n\r\n.new-content-mr1 {\r\n    padding-bottom: 0px !important;\r\n\r\n}\r\n\r\n.new-content-input-mr {\r\n    width: 50% !important;\r\n    display: block !important;\r\n}\r\n\r\n.my-price-hr {\r\n    /* border-bottom: 1px solid #ccc; */\r\n    margin-top: 20px;\r\n\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.my-price-text {\r\n    margin-top: 20px;\r\n\r\n}\r\n\r\n.my-price-text p {\r\n    font-size: 14px;\r\n    line-height: 30px;\r\n\r\n}\r\n\r\n.price-checkbox-mr {\r\n    display: table !important;\r\n    padding-bottom: 10px;\r\n    font-size: 12px !important;\r\n    text-transform: capitalize !important;\r\n}\r\n\r\n.price-checkbox-main {\r\n    margin: 20px 0;\r\n}\r\n\r\n.price-btn-mr {\r\n    padding: 20px 20px !important;\r\n    font-size: 14px !important;\r\n}\r\n\r\n.heading-rr {\r\n    padding-top: 0px !important;\r\n    padding-bottom: 0px !important;\r\n}\r\n\r\n.text-nn {\r\n    padding-top: 15px !important;\r\n    padding-bottom: 0px !important;\r\n}\r\n\r\n.price-radio-btn {\r\n    margin-top: 40px;\r\n}\r\n\r\n.radio-btn-sp {\r\n    margin-right: 40px;\r\n}\r\n\r\n.image-rr {\r\n    display: inline;\r\n    top: -2px;\r\n    position: absolute;\r\n    left: 100px;\r\n}\r\n\r\n.box-cr-rw {\r\n    background: #F2F2F2 !important;\r\n    padding: 15px 0 !important;\r\n}\r\n\r\n.box-cr::placeholder {\r\n    color: #000000;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    font-weight: 400;\r\n}\r\n\r\n.box-cr .css-12y4u6o {\r\n    border-color: none !important;\r\n}\r\n\r\n.box-cr input:focus {\r\n\r\n    border-color: none !important;\r\n}\r\n\r\n.test tr:nth-of-type(even) {\r\n    background: #f8f8f8 !important;\r\n\r\n}\r\n\r\n.test tr:nth-of-type(odd) td {\r\n    background: none !important;\r\n}\r\n\r\n.test td img {\r\n    max-width: 200px;\r\n}\r\n\r\n.add-border-text {\r\n    border-bottom: 1px solid;\r\n}\r\n\r\n.add-border-text p {\r\n    font-size: 14px;\r\n    text-align: left;\r\n    color: #F58220;\r\n    padding: 10px 0;\r\n    margin-top: 20px;;\r\n}\r\n\r\n.wd-94 {\r\n    margin: 0 35px;\r\n}\r\n\r\n.bg-add-to {\r\n    background: #f2f2f2;\r\n    padding: 14px 0px;\r\n}\r\n\r\n.add-to-btn-pd {\r\n    padding: 0px;\r\n    margin: 0px;\r\n}\r\n\r\n.btn-clr-bl {\r\n    background: #4D4D4D !important;\r\n    margin-right: 10px;\r\n}\r\n\r\n.btn-clr-invoice-bl {\r\n    background: #EC7700 !important;\r\n    padding: 5px 60px !important;\r\n}\r\n\r\n.btn-clr {\r\n    background: #EC7700 !important;\r\n}\r\n\r\n.bg-invoice-to {\r\n    background: #f2f2f2;\r\n    padding: 14px 13px;\r\n    margin: 0 35px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.modal-form-group-main {\r\n    margin: 0 35px;\r\n}\r\n\r\n.modal-form-group-lv {\r\n    margin-top: 15px;\r\n    margin-bottom: 25px;\r\n    position: relative;\r\n    margin-right: 10px;\r\n}\r\n\r\n.modal-form-group-lv .input-icon-lv img {\r\n    opacity: 1;\r\n    position: absolute;\r\n    z-index: 1;\r\n    left: 8px;\r\n    top: 10px;\r\n    color: #979faf;\r\n    width: 20px;\r\n    height: 20px;\r\n    object-fit: contain;\r\n}\r\n\r\n.modal-form-group-lv .modal-form-input-lv {\r\n    display: block !important;\r\n    padding: 0px 8px 0px 34px !important;\r\n    width: 150px;\r\n    height: 40px;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n}\r\n\r\n.modal-form-group-lv .modal-form-input-btn {\r\n    display: block !important;\r\n    width: 100%;\r\n    height: 40px;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    background: #EC7700;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n}\r\n\r\n.btn-clr-invoice-tb {\r\n    background: #EC7700 !important;\r\n    padding: 5px 40px !important;\r\n    color: #fff;\r\n    font-size: 12px;\r\n}\r\n\r\n.checkbox-st {\r\n    background: #fff;\r\n\r\n    border: 1px solid #E2E2E2;\r\n    border-radius: 4px;\r\n\r\n}\r\n\r\n.tble_fd tr:nth-child(even) {\r\n    background: #F2F2F2 !important;\r\n}\r\n\r\n.hr-brder {\r\n    border: 0.1px solid #C4C4C4;\r\n    margin: 15px 0;\r\n}\r\n\r\n.dt_frman-cr {\r\n    height: 140px !important;\r\n}\r\n\r\n.dt_frman-cr2 {\r\n    height: 200px !important;\r\n}\r\n\r\n.model-block-none {\r\n    display: block;\r\n}\r\n\r\n.open-drawer-none {\r\n    display: none;\r\n}\r\n\r\n.wd_50_prview-wd {\r\n    width: 50%;\r\n    margin: 0 35px;\r\n}\r\n\r\n.wd_50_prview-wd-1 {\r\n    margin: 0 35px;\r\n    margin-top: 15px;\r\n}\r\n\r\n.wd_50_hr-1 {\r\n    border-bottom: 1px solid #444;\r\n    margin-top: 30px;\r\n}\r\n\r\n.lt_pr-1 {\r\n    margin-left: 40px;\r\n}\r\n\r\n.mr-t {\r\n    margin-top: 20px;\r\n}\r\n\r\n.restore-mr-1 {\r\n    display: flex;\r\n}\r\n\r\n.icon-mr {\r\n    margin-top: 15px;\r\n    margin-right: 15px;\r\n}\r\n\r\n.mr-rr1 {\r\n    position: relative;\r\n}\r\n\r\n.mr-rr1::after {\r\n    position: absolute;\r\n    border-right: none !important;\r\n}\r\n\r\n.increse-colr {\r\n    width: 130px;\r\n}\r\n\r\n.product-cod-st {\r\n    width: 150px;\r\n    background-color: #fff !important;\r\n    border: 1px solid #444 !important;\r\n    border-radius: none !important;\r\n}\r\n\r\n.product-cod-st1 {\r\n    background-color: #fff !important;\r\n    border: 1px solid #444 !important;\r\n    border-radius: none !important;\r\n}\r\n\r\n.product-cod-st1:focus {\r\n    border: 1px solid #444 !important;\r\n}\r\n\r\n.price_dt2 {\r\n    border-bottom: none !important;\r\n}\r\n\r\n.lt_pr-4 {\r\n    /* margin-right: 20px; */\r\n}\r\n\r\n.lt_pr_4sbmt_det {\r\n    /* margin-right: 12px; */\r\n}\r\n\r\n/*.option_table tr:nth-child(4) {*/\r\n/*    background: rgb(242 242 242 / 50%);*/\r\n/*}*/\r\n\r\n@media (max-width: 991px) {\r\n    .desktop_cart {\r\n        display: none;\r\n    }\r\n\r\n    .bg-add-to {\r\n        display: block !important;\r\n        margin-bottom: 20px;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .fmb_wd_blog {\r\n        grid-template-columns: auto !important;\r\n    }\r\n\r\n    .rm_padding_quicks li:last-child {\r\n\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .pd_add_bm_quicks {\r\n        margin-bottom: 90px;\r\n    }\r\n\r\n    .mb_pd_qucik_rm {\r\n        margin: 0 15px !important;\r\n    }\r\n\r\n    .new-user-hr {\r\n        border-bottom: 1px solid #ccc;\r\n\r\n        margin: 0 15px;\r\n    }\r\n\r\n    .add-to-btn-pd {\r\n        text-align: center;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    .dt_archive {\r\n        padding-top: 0px;\r\n    }\r\n\r\n    .archive-rr {\r\n        padding-top: 15px;\r\n    }\r\n\r\n    .bg_color_acrhove .chakra-avatar {\r\n        margin-right: 0px;\r\n    }\r\n\r\n    .model-block-none {\r\n        display: none;\r\n    }\r\n\r\n    .open-drawer-none {\r\n        display: block;\r\n    }\r\n\r\n    .modal-form-group-lv .modal-form-input-lv {\r\n        width: 100%;\r\n    }\r\n\r\n    .modal-form-group-lv {\r\n        margin-right: 0px;\r\n    }\r\n\r\n    .drawer-btn-color {\r\n        color: #EC7700 !important;\r\n        background: none !important;\r\n        box-shadow: none !important;\r\n        margin-bottom: 20px;\r\n\r\n    }\r\n\r\n    .open-dig {\r\n        width: 90%;\r\n        margin: auto;\r\n    }\r\n\r\n    .bg-invoice-to {\r\n        margin: 0px 0px;\r\n    }\r\n\r\n    .modal-form-group-main {\r\n        margin: 0 15px;\r\n    }\r\n\r\n    .modal-form-group-main1 {\r\n        padding: 15px;\r\n        margin: auto;\r\n        width: 95% !important;\r\n        margin-top: 15px;\r\n    }\r\n\r\n    .wd_50_prview-wd {\r\n        width: 100%;\r\n        margin: 0 0px;\r\n    }\r\n\r\n    .wd_50_prview-wd-1 {\r\n        margin: 0 15px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .mr-rr {\r\n        margin-top: 15px;\r\n    }\r\n\r\n    .mr-rr1 {\r\n        position: relative;\r\n        margin-top: 15px;\r\n    }\r\n\r\n    .restore-mr-5 {\r\n        display: block;\r\n    }\r\n\r\n    .lt_pr-4 {\r\n        margin-left: 0px;\r\n    }\r\n\r\n    .vj_st {\r\n        padding: 0px 15px !important;\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    /* css 13-07-2022 */\r\n    .bg-add-to {\r\n        display: block !important;\r\n        margin-bottom: 20px;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .rm_padding_quicks li:last-child {\r\n\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .pd_add_bm_quicks {\r\n        margin-bottom: 90px;\r\n    }\r\n\r\n    .mb_pd_qucik_rm {\r\n        margin: 0 15px !important;\r\n    }\r\n\r\n    .new-user-hr {\r\n        border-bottom: 1px solid #ccc;\r\n\r\n        margin: 0 15px;\r\n    }\r\n\r\n    .add-to-btn-pd {\r\n        text-align: center;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    .dt_archive {\r\n        padding-top: 0px;\r\n    }\r\n\r\n    .archive-rr {\r\n        padding-top: 15px;\r\n    }\r\n\r\n    .bg_color_acrhove .chakra-avatar {\r\n        margin-right: 0px;\r\n    }\r\n\r\n    .model-block-none {\r\n        display: none;\r\n    }\r\n\r\n    .open-drawer-none {\r\n        display: block;\r\n    }\r\n\r\n    .modal-form-group-lv .modal-form-input-lv {\r\n        width: 100%;\r\n    }\r\n\r\n    .modal-form-group-lv {\r\n        margin-right: 0px;\r\n    }\r\n\r\n    .drawer-btn-color {\r\n        color: #EC7700 !important;\r\n        background: none !important;\r\n        box-shadow: none !important;\r\n        margin-bottom: 20px;\r\n\r\n    }\r\n\r\n    .open-dig {\r\n        width: 90%;\r\n        margin: auto;\r\n    }\r\n\r\n    .bg-invoice-to {\r\n        margin: 0px 0px;\r\n    }\r\n\r\n    .modal-form-group-main {\r\n        margin: 0 15px;\r\n    }\r\n\r\n    .modal-form-group-main1 {\r\n        padding: 15px;\r\n        margin: auto;\r\n        width: 95% !important;\r\n        margin-top: 15px;\r\n    }\r\n\r\n    .wd_50_prview-wd {\r\n        width: 100%;\r\n        margin: 0 0px;\r\n    }\r\n\r\n    .wd_50_prview-wd-1 {\r\n        margin: 0 15px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .mr-rr {\r\n        margin-top: 15px;\r\n    }\r\n\r\n    .mr-rr1 {\r\n        position: relative;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .restore-mr-5 {\r\n        display: block;\r\n    }\r\n\r\n    .lt_pr-4 {\r\n        margin-left: 0px;\r\n    }\r\n\r\n    .vj_st {\r\n        padding: 0px 15px !important;\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .title-c {\r\n        padding: 30px 15px;\r\n        font-size: 30px !important;\r\n        line-height: 43px !important;\r\n    }\r\n\r\n    .bg_banner_web {\r\n        padding: 0px 0px;\r\n    }\r\n\r\n    .product-bg-t-paddinng {\r\n        padding: 30px 30px 30px 30px !important;\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .product-bg-t-or {\r\n        display: block !important;\r\n    }\r\n\r\n    .product-bg-t-p-img {\r\n        padding: 0px 0px !important;\r\n        width: 200px;\r\n    }\r\n\r\n    .product-bg-t-img img {\r\n        margin-top: 30px !important;\r\n        width: 100% !important;\r\n        height: auto !important;\r\n    }\r\n\r\n    .product-bg-t-img {\r\n        width: 100% !important;\r\n        height: auto !important;\r\n    }\r\n\r\n    /* css 13-07-2022 */\r\n}\r\n\r\n/*vijay css start*/\r\n\r\n/* rs css start ipad 4-11-2022 */\r\n@media (max-width: 1400px) {\r\n    .drill_clb_bg .css-k008qs {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media (min-width: 500px) and (max-width: 1366px) {\r\n    /* .drillcutsearchMainResult .searchDatamt{\r\n            overflow: visible!important;\r\n    margin-bottom: 250px!important;\r\n    }\r\n    .drillcutsearchMainResult .css-i6bazn{\r\n         overflow: visible!important;\r\n    } */\r\n}\r\n\r\n@media (max-width: 1366px) {\r\n    p.chakra-text.latest_product_div_contain_heading {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .searchDrillcutfilters {\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .drillcutsearchMainResult .search_Image_container {\r\n        height: 100%;\r\n    }\r\n\r\n    .model-block-none .css-k008qs {\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .model-block-none .css-k008qs .modal-form-group-lv {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .tabs-menu ul li a {\r\n        font-size: 13.5px !important;\r\n\r\n\r\n    }\r\n\r\n    .box_homepage_designs_heading {\r\n        letter-spacing: 0.15px;\r\n        font-size: 26px !important;\r\n\r\n    }\r\n\r\n    .box_width_70 {\r\n\r\n        max-width: 100%;\r\n    }\r\n\r\n    .form_login_Button {\r\n        line-height: 0px !important;\r\n    }\r\n\r\n    .ct_img_rill img {\r\n\r\n        width: 60% !important;\r\n    }\r\n\r\n    .tabs-menu ul li {\r\n        padding: 10px 14px !important;\r\n\r\n    }\r\n\r\n    p.latest_product_div_contain_price {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .brand_logo_aboutuspage .css-1wkijx5 {\r\n        grid-template-columns: repeat(2, 1fr);\r\n\r\n\r\n    }\r\n\r\n    .latest_product_div_contain_button {\r\n        margin-top: 11px;\r\n    }\r\n\r\n    .drill_clb_bg .css-k008qs {\r\n        display: block;\r\n    }\r\n\r\n    .drill_block_2 {\r\n        padding-left: 0px;\r\n    }\r\n\r\n    .downloads_page_space .orange_button_drillcut {\r\n        margin-top: 30px;\r\n    }\r\n\r\n    .download_subtags_box {\r\n        padding-left: 15px;\r\n    }\r\n\r\n    .drill_block_3 h2 {\r\n        font-size: 24px;\r\n        padding: 4px 0px 5px;\r\n    }\r\n\r\n    .pg_bar .css-150tos1 {\r\n        max-width: 62%;\r\n    }\r\n\r\n    .drill_block_1 a {\r\n        padding-top: 0px;\r\n        margin-bottom: 10px;\r\n        text-align: left;\r\n    }\r\n\r\n    .option_form {\r\n        margin: 20px 15px 0px 15px;\r\n        z-index: -1 !important;\r\n    }\r\n\r\n    .menu_open_mt {\r\n        width: 325px;\r\n        left: -10px;\r\n\r\n    }\r\n\r\n    .chiled_open_mt {\r\n        position: absolute;\r\n        width: 325px;\r\n        left: 325px;\r\n    }\r\n\r\n    .chiled_open_mt-2 {\r\n        position: absolute;\r\n        width: 325px;\r\n        left: 319px;\r\n    }\r\n\r\n    .rect_bx_ribon {\r\n        z-index: 999;\r\n    }\r\n\r\n    .main_slider_block_prduct {\r\n        min-height: auto;\r\n        height: auto;\r\n    }\r\n\r\n    .Img_block_pd_slide_prduct img {\r\n        position: inherit;\r\n        top: inherit;\r\n        left: inherit;\r\n        transform: inherit;\r\n        width: 100%;\r\n    }\r\n\r\n    #upper_logo_threesixzero img {\r\n        max-width: 95% !important;\r\n    }\r\n\r\n    .drill_club_web_ct .dril_club_noclr img {\r\n        max-width: 30% !important;\r\n        margin-top: -15px;\r\n    }\r\n\r\n    .main_block_sp_offer h6 {\r\n        font-size: 18px !important;\r\n    }\r\n\r\n    .overlay-ribbon:before {\r\n        border-left: 106px solid transparent !important;\r\n        border-right: 101px solid transparent !important;\r\n        width: 177px !important;\r\n        bottom: -1px !important;\r\n    }\r\n\r\n    .overlay-ribbon {\r\n        max-width: 205px !important;\r\n    }\r\n\r\n    .ribbon-content p {\r\n        font-size: 28px !important;\r\n        padding-top: 22px !important;\r\n    }\r\n\r\n    #upper_logo_threesixzero {\r\n\r\n        padding: 124px 0 175px 88px !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n\r\n    .half_width_class_mt {\r\n        width: 100%;\r\n    }\r\n\r\n    .about_us_content_mt {\r\n        padding: 0px 20px;\r\n    }\r\n\r\n    .cart_container .desktop_cart {\r\n        display: none !important;\r\n    }\r\n\r\n    .mob_img_bx img {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .CollectionsData {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .collection_grid {\r\n        padding: 20px;\r\n        grid-template-columns: repeat(3, 1fr);\r\n    }\r\n\r\n    .CollectionsData {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .drillcut_companies {\r\n\r\n        padding: 0px 30px;\r\n    }\r\n\r\n\r\n    .about_container .css-biwl99 {\r\n        display: block !important;\r\n        width: 100% !important;\r\n\r\n\r\n    }\r\n\r\n    #an_all_comment_box {\r\n        display: block !important;\r\n\r\n    }\r\n\r\n    .about_container .about_contain {\r\n        width: 100%;\r\n    }\r\n\r\n    .blog_section_drillcut {\r\n        flex-direction: row !important;\r\n        gap: 10px;\r\n    }\r\n\r\n    .backgorund_latest_prod_mt {\r\n        height: 250px;\r\n    }\r\n\r\n    .latest_product_div_mt {\r\n        margin: 15px 0;\r\n        flex-direction: column;\r\n        height: 100%;\r\n    }\r\n\r\n    .latest_product_contain,\r\n    .blog_section_drillcut {\r\n        flex-direction: column;\r\n    }\r\n\r\n}\r\n\r\n@media (min-width: 1270px) {\r\n    .bg_banner_web {\r\n        height: 350px !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 1270px) {\r\n    .bg_banner_web {\r\n        height: 300px !important;\r\n    }\r\n\r\n    .main_block_sp_offer h6 {\r\n        font-size: 18px !important;\r\n    }\r\n\r\n    .overlay-ribbon:before {\r\n        border-left: 108px solid transparent !important;\r\n        border-right: 96px solid transparent !important;\r\n        width: 177px !important;\r\n    }\r\n\r\n    .overlay-ribbon {\r\n        max-width: 205px !important;\r\n    }\r\n\r\n    .ribbon-content p {\r\n        font-size: 28px !important;\r\n        padding-top: 22px !important;\r\n    }\r\n\r\n    .dril_club_noclr {\r\n        background: #ededed;\r\n        width: 100%;\r\n        padding: 130px 0 150px 88px !important;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 1366px) {\r\n    .box_view_design_mt {\r\n        display: flex !important;\r\n    }\r\n\r\n    .overlaybody {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media (max-width: 1180px) {\r\n    .box_view_design_mt {\r\n        display: block !important;\r\n    }\r\n\r\n    .overlaybody {\r\n        display: none;\r\n    }\r\n\r\n    .half_mini_width_drillcut {\r\n        width: 100% !important;\r\n        background-position: center;\r\n        margin-bottom: 30px;\r\n        /* min-height: 458px;*/\r\n    }\r\n\r\n    .half_mini_width_drillcut img {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .box_design {\r\n        height: auto !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n    .first_bx_accrdion h2 {\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        padding-right: 10px;\r\n    }\r\n\r\n    .css-1nravos {\r\n        max-width: 320px;\r\n        margin-bottom: 0px;\r\n        box-shadow: 3px 3px 4px rgb(0 0 0 / 25%);\r\n        width: 100%;\r\n    }\r\n\r\n    .brands_image .css-0 {\r\n        max-width: 235px;\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    .footer_logo_main_logo {\r\n        width: 90%;\r\n    }\r\n\r\n    .orange_button_drillcut {\r\n        margin-top: 20px !important;\r\n    }\r\n\r\n    .css-zipzvv {\r\n        overflow-y: visible !important;\r\n        overflow-x: visible !important;\r\n    }\r\n\r\n    .css-zipzvv .chakra-table:first-child {\r\n        overflow-y: scroll;\r\n        overflow-x: scroll;\r\n        /* width: 90%; */\r\n        display: inline-block;\r\n    }\r\n\r\n    .CollectionsData {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .cart_dt_pp {\r\n        display: block !important;\r\n    }\r\n\r\n    #overlay {\r\n        display: none !important;\r\n    }\r\n\r\n    .width_25DrillCut {\r\n        width: 100%;\r\n    }\r\n\r\n    .searchDatamt ul {\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n\r\n    .Sort_pagination {\r\n        justify-content: center;\r\n        width: 100%;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .pagination_top {\r\n        display: none;\r\n    }\r\n\r\n    .width_75DrillCut {\r\n        width: 75%;\r\n        max-width: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n    .paginate_count {\r\n        width: 100%;\r\n    }\r\n\r\n    .searchPage_pagination_bottom {\r\n        padding: 0px 20px 20px 20px;\r\n        flex-wrap: wrap;\r\n        flex-direction: column-reverse;\r\n    }\r\n\r\n    .searchPage_pagination .ais-Pagination {\r\n        margin-left: 0px;\r\n    }\r\n\r\n    .selectbox_Box {\r\n        width: 100%;\r\n    }\r\n\r\n    .searchmobileviewmt {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .cstm_pslider {\r\n        padding: 0px !important;\r\n    }\r\n\r\n    .headericons_mobile_view .chakra-avatar__badge {\r\n        height: 18px;\r\n        width: 18px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    .header_center_mt {\r\n        padding: 15px 30px !important;\r\n    }\r\n\r\n    .dril_club_noclr {\r\n        background: #ededed;\r\n        width: 100%;\r\n        padding: 40px 0px !important;\r\n    }\r\n\r\n    .main_container {\r\n        padding: 10px 30px;\r\n    }\r\n\r\n    .logo_width_set {\r\n        margin-right: 15px;\r\n    }\r\n\r\n    .chakra-table .css-0 {\r\n        /* position: relative; */\r\n    }\r\n\r\n    .chakra-table .css-de1rql {\r\n        /* position: fixed; */\r\n        z-index: 99;\r\n    }\r\n\r\n    #upper_logo_threesixzero {\r\n\r\n        padding: 40px 0px !important;\r\n    }\r\n\r\n    .menu_open_mt button,\r\n    .chiled_header {\r\n        padding: 20px 20px;\r\n    }\r\n\r\n    .chiled_header span {\r\n        font-size: 17px !important;\r\n    }\r\n\r\n    .menu_open_mt {\r\n        width: 260px;\r\n        left: 0px;\r\n    }\r\n\r\n    .chiled_open_mt {\r\n        position: absolute;\r\n        width: 263px;\r\n        left: 261px;\r\n    }\r\n\r\n    .chiled_open_mt-2 {\r\n        position: absolute;\r\n        width: 240px;\r\n        left: 260px;\r\n    }\r\n\r\n    .pd_typs {\r\n        padding-top: 11px;\r\n    }\r\n\r\n    .bg_color_acrhove .lt_brder {\r\n        display: inherit !important;\r\n    }\r\n\r\n    .drill_club_web_ct .dril_club_wb img {\r\n        max-width: 50% !important;\r\n        margin-top: 0px;\r\n    }\r\n}\r\n\r\n/* rs css end ipad 4-11-2022 */\r\n/* mobile issue css start 10-11-2022 */\r\n@media (max-width: 369px) {\r\n    .lt_pr {\r\n        margin-left: 5px;\r\n    }\r\n}\r\n\r\n@media (max-width: 428px) {\r\n    .lt_pr {\r\n        margin-left: 0px;\r\n    }\r\n}\r\n\r\n@media (max-width: 450px) {\r\n    .text_logo_section_logo_mt {\r\n        grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 560px) {\r\n    .searchBox_searchPage {\r\n        margin: 0 !important;\r\n        padding: 0px 25px 20px !important;\r\n    }\r\n\r\n    .searchDatamt ul {\r\n        grid-template-columns: repeat(1, 1fr);\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .add-to-btn {\r\n     margin-left: 0px;\r\n    }\r\n    .bg_svdl:after {\r\n        width: auto;\r\n        left: auto;\r\n    }\r\n\r\n    .price_dt_summry {\r\n        margin-right: 0px;\r\n    }\r\n\r\n    .desktop_cart_view {\r\n        display: none !important;\r\n    }\r\n\r\n    .cart_view_mobile {\r\n        display: block;\r\n    }\r\n\r\n    .chakra-modal__content .css-z7mtfw {\r\n        flex-wrap: wrap-reverse;\r\n        /* margin-top: 10px; */\r\n        justify-content: center;\r\n        gap: 15px;\r\n        top: 0px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .chakra-modal__content .css-k008qs {\r\n        width: 100%;\r\n    }\r\n\r\n    .chakra-modal__content .css-jvwk1r {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .ArticleProductButton {\r\n        width: 96%;\r\n    }\r\n\r\n    .brands_image p {\r\n\r\n        -webkit-line-clamp: inherit;\r\n    }\r\n\r\n    .brand_logo_aboutuspage .css-70qvj9 .css-0 a {\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .brands_image img,\r\n    .bg_image img {\r\n\r\n        max-width: 100% !important;\r\n    }\r\n\r\n    .css-1wkijx5 .brand_logo_aboutuspage .css-0 a {\r\n        width: 130px;\r\n        height: 30px;\r\n        line-height: 30px;\r\n        margin-top: 15px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .css-1wkijx5 .brands_image p {\r\n        overflow: hidden;\r\n        text-overflow: unset;\r\n        display: -webkit-box;\r\n        -webkit-line-clamp: 0;\r\n        -webkit-box-orient: vertical;\r\n        font-size: 18px;\r\n        line-height: 24px;\r\n        padding: 15px 10px;\r\n    }\r\n\r\n    .css-1wkijx5 .brands_image img,\r\n    .bg_image img {\r\n        width: 100%;\r\n        object-fit: contain;\r\n        background: #f1f1f1;\r\n        max-width: 100% !important;\r\n    }\r\n\r\n    .css-1wkijx5 .brands_image .css-0 {\r\n\r\n        max-width: 100%;\r\n    }\r\n\r\n    .css-1wkijx5 .about_container .css-k008qs {\r\n        display: block !important;\r\n        margin-top: 30px !important;\r\n    }\r\n\r\n    .about_page_slider_container_contentmt .slick_arrows_custom_logo_next {\r\n        right: 0px !important;\r\n    }\r\n\r\n    .about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {\r\n        left: 0px !important;\r\n    }\r\n\r\n    .box_design {\r\n\r\n        height: auto !important;\r\n\r\n    }\r\n\r\n    .about_slider_bg_image_mt {\r\n        min-height: 600px;\r\n    }\r\n\r\n    .aboutpage_sliderBox {\r\n        max-width: 320px;\r\n    }\r\n\r\n    .chiled_header {\r\n        position: relative;\r\n        display: block !important;\r\n    }\r\n\r\n    .drillcuttv_subfilters_button_mt {\r\n        width: 60%;\r\n\r\n    }\r\n\r\n    .collectionImage {\r\n        background-color: #f2f2f4;\r\n    }\r\n\r\n    .collectionImage img {\r\n        object-fit: contain;\r\n    }\r\n\r\n    .header_center_mt .chakra-avatar__group {\r\n        margin-top: 4px;\r\n    }\r\n\r\n    .searchBox_searchPage {\r\n        margin: 0 !important;\r\n        padding: 1px 20px 0px;\r\n    }\r\n\r\n    .rectangle-bottom:after {\r\n        border-left: 37px solid transparent;\r\n        border-right: 37px solid transparent;\r\n        margin-top: -1px;\r\n    }\r\n\r\n    .drill_cut_tv_popup {\r\n        margin: 0px 10px;\r\n    }\r\n\r\n    .bg_strip_btn_save button {\r\n        line-height: 41px;\r\n\r\n        margin-top: 0px;\r\n        margin-left: 5px !important;\r\n\r\n    }\r\n\r\n    .srch_filter .form_controll {\r\n        display: block;\r\n        padding-bottom: 30px;\r\n    }\r\n\r\n    .downloads_page_content_mt {\r\n        padding: 30px 15px !important;\r\n        align-items: unset !important;\r\n    }\r\n\r\n    .text_logo_section_logo_mt {\r\n        grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\r\n    }\r\n\r\n    .logo_text_block_contain {\r\n        justify-content: center;\r\n    }\r\n\r\n    .downloads_page_content_td_mt_heading {\r\n\r\n        white-space: nowrap;\r\n        padding-left: 15px;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    .download_button_mt {\r\n        padding: 6px 15px !important;\r\n    }\r\n\r\n    .project_br .flx_bx_wd:last-child {\r\n        padding: 0px !important;\r\n        margin-bottom: 83px;\r\n    }\r\n\r\n    .contactUspage_block_Form_block .form_controll {\r\n        padding: 0px 0px;\r\n        grid-gap: 0px;\r\n        display: block;\r\n    }\r\n\r\n    .label_name_Contactform {\r\n\r\n        padding: 20px 0px 0px;\r\n    }\r\n\r\n    .contactUspage_block_Form_block {\r\n\r\n        margin-bottom: 36px;\r\n        margin-top: 30px;\r\n    }\r\n\r\n    .map_section_block {\r\n\r\n        padding: 0px 0px;\r\n    }\r\n\r\n    .account_info {\r\n        margin-bottom: 20px !important;\r\n    }\r\n\r\n    /*.slider_image_mt img {*/\r\n    /*    height: 200px;*/\r\n    /*}*/\r\n    ul.mobile_menu_list {\r\n\r\n        height: 90%;\r\n        overflow-y: scroll;\r\n    }\r\n\r\n    .first_bx_accrdion h2 {\r\n\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        padding-right: 10px;\r\n    }\r\n\r\n    .background_image_mt_content_main_text form {\r\n\r\n        width: 90%;\r\n    }\r\n\r\n    .css-14tkcur {\r\n\r\n        width: 100% !important;\r\n        display: block !important;\r\n    }\r\n\r\n    /*.css-ry7qsg {*/\r\n\r\n    /*    margin: 0px;*/\r\n    /*    margin-left: 0px !important;*/\r\n    /*    display: block !important;*/\r\n    /*    margin-top: 13px;*/\r\n    /*}*/\r\n\r\n    .brand_logo_aboutuspage .css-1wkijx5 {\r\n        grid-template-columns: repeat(1, 1fr);\r\n\r\n\r\n    }\r\n\r\n    .brand_logo_aboutuspage .brands_image {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .brands_image .css-70qvj9 {\r\n        display: block;\r\n    }\r\n\r\n    .home_page_main_slider_mt .slick-dots {\r\n\r\n        bottom: 0px !important;\r\n\r\n    }\r\n\r\n    .home_page_main_slider_mt .slick-dots {\r\n\r\n        padding-left: 0px !important;\r\n    }\r\n\r\n    .slick_slider_custom_arrows {\r\n        display: none !important;\r\n    }\r\n\r\n    .bg_color_acrhove {\r\n\r\n        display: flex;\r\n        align-items: center;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .rl_dets label {\r\n        font-weight: 500;\r\n        font-size: 18px;\r\n    }\r\n\r\n    .chiled_header a {\r\n        /* position: absolute;\r\n        right: 50px;\r\n        top: 23px; */\r\n        margin-top: 10px;\r\n        display: block;\r\n    }\r\n\r\n    .options_txt {\r\n        display: none;\r\n    }\r\n\r\n    .block_tb_dt span {\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    .pages_project_bar_heading {\r\n        padding-left: 0px;\r\n    }\r\n\r\n    .bg_color_acrhove .lt_brder {\r\n\r\n        align-items: center;\r\n    }\r\n\r\n    .lt_pr {\r\n\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .bd_crum h1 {\r\n        padding-left: 0px;\r\n    }\r\n\r\n    .sbMittal_frm .chakra-form-control {\r\n        margin-right: 20px;\r\n        max-width: 155px;\r\n        max-width: 100%;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .sbMittal_frm .chakra-form__label {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .sbMittal_frm input {\r\n        max-width: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n    .sbMittal_frm {\r\n        display: block;\r\n    }\r\n\r\n    .flx_bx_stp {\r\n        display: block;\r\n    }\r\n\r\n    .mr-rr1 {\r\n        font-size: 12px;\r\n        text-align: center;\r\n        /* letter-spacing: -0.5px; */\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .lt_pr_4sbmt_det {\r\n        margin-left: 0px !important;\r\n    }\r\n\r\n    .lt_pr_4sbmt_det {\r\n        margin-right: 7px;\r\n    }\r\n\r\n    .restore-mr-5 {\r\n\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .flx_bx_stp .css-k008qs {\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .qt_mb_pg button {\r\n        margin-left: 0px;\r\n        padding: p;\r\n        padding: 0px;\r\n        display: block;\r\n        height: 20px;\r\n        padding-top: 6px;\r\n    }\r\n\r\n    .flx_bx_wd {\r\n\r\n        padding: 0px !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n    .about-us-wrapper {\r\n        margin-top: 10px;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .nps-score {\r\n        margin: auto;\r\n    }\r\n\r\n    .css-zipzvv .option_table .css-womqfz {\r\n        max-width: 300px;\r\n        /*right: 30px;*/\r\n        /*left: 30px;*/\r\n        /*width: 100%;*/\r\n        /*left: 50%;*/\r\n        /*right: 0;*/\r\n        /*top: auto;*/\r\n\r\n\r\n        /*transform: translate(-50%, -0%);*/\r\n    }\r\n}\r\n\r\n@media (max-width: 550px) {\r\n    .modal-form-group-main1 {\r\n\r\n        width: 80% !important;\r\n\r\n        position: inherit !important;\r\n    }\r\n\r\n    .sbMittal_frm {\r\n        display: block !important;\r\n    }\r\n\r\n    .sbMittal_frm .chakra-form-control {\r\n\r\n        margin-bottom: 17px;\r\n    }\r\n\r\n    .sbMittal_frm .chakra-form-control:last-child {\r\n\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .price-checkbox-mr {\r\n        display: flex !important;\r\n    }\r\n\r\n    .price-checkbox-main .css-6x44c9 {\r\n\r\n        display: inline-grid;\r\n        margin-left: 10px;\r\n        height: 20px;\r\n\r\n    }\r\n\r\n    .text-nn {\r\n        margin-bottom: 20px !important;\r\n        max-width: 100% !important;\r\n    }\r\n\r\n    .branch_table_company_page .css-9xtqsk {\r\n        display: block;\r\n    }\r\n\r\n    .branch_table_company_page .chakra-form-control {\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .branchInformationHeading {\r\n\r\n        min-width: 100px;\r\n        max-width: 100%;\r\n    }\r\n\r\n    .tble_dt td {\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n}\r\n\r\n@media (max-width: 766px) {\r\n    .chakra-table .css-de1rql {\r\n        max-width: 90%;\r\n        left: 20px;\r\n        overflow: hidden;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .full_width_container {\r\n        max-width: 100% !important;\r\n        padding: 0 !important;\r\n        position: relative !important;\r\n        width: 100%;\r\n        height: 100%;\r\n        margin: 0;\r\n        /* overflow: hidden; */\r\n        /* position: absolute!important; */\r\n        top: 0;\r\n        left: 0;\r\n        overflow-x: hidden;\r\n    }\r\n\r\n    .prduct_image img {\r\n        max-width: 100px;\r\n        border: none;\r\n    }\r\n\r\n    .prduct_image {\r\n        top: -6px;\r\n    }\r\n\r\n    .about_contain {\r\n\r\n        padding-top: 30px !important;\r\n        padding-bottom: 30px !important;\r\n    }\r\n\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .tabs-menu ul li {\r\n        padding: 10px 10px;\r\n        margin: 4px 1px;\r\n        max-width: 110px;\r\n        width: 100%;\r\n    }\r\n\r\n    .know-us-image-main {\r\n\r\n        border: 1px solid #592c82 !important;\r\n        width: 90.5% !important;\r\n        padding-bottom: 20px !important;\r\n    }\r\n\r\n    .know-us-image-top {\r\n        width: 100% !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 1500px) {\r\n\r\n    .home_page_main_slider_mt .slick-dots,\r\n    .slick_slider_custom_arrows {\r\n        /* padding-left: 50px; */\r\n        top: unset;\r\n        /* width: 100%; */\r\n        left: 50%;\r\n        /* top: 50%; */\r\n        left: 50%;\r\n        -ms-transform: translate(-50%, -50%);\r\n        transform: translate(-50%, -50%);\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n/*@media (max-width: 1370px) {*/\r\n/*    .orange_button_drillcut {*/\r\n/*        margin-top: 30px;*/\r\n/*    }*/\r\n/*}*/\r\n\r\n@media (max-width: 1200px) {\r\n    .spec_dt {\r\n        position: inherit;\r\n        margin-left: 0px;\r\n        bottom: 0px;\r\n    }\r\n\r\n    .box_design {\r\n        margin: 0px 0px !important;\r\n        margin-bottom: 30px !important;\r\n    }\r\n\r\n    .spec_accordian_box .flxe_accrdion {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    /* .slider_image_mt img {\r\n        height: 95vh;\r\n    }\r\n    .slider_image_mt{\r\n        height: 95vh;\r\n    } */\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n    .slider_image_mt img {\r\n        height: 100%;\r\n    }\r\n\r\n    .slider_image_mt {\r\n        height: 100%;\r\n    }\r\n}\r\n\r\n/* mobile issue css start 10-11-2022 */\r\n\r\n/* vijay css */\r\nbutton.btn_drpdwn {\r\n    margin-top: 0px;\r\n}\r\n\r\nbody::-webkit-scrollbar {\r\n    width: 6px;\r\n    overflow-y: auto;\r\n    /* width of the entire scrollbar */\r\n}\r\n\r\nbody::-webkit-scrollbar-track {\r\n    background: #fff;\r\n    overflow-y: auto;\r\n    /* color of the tracking area */\r\n}\r\n\r\nbody::-webkit-scrollbar-thumb {\r\n    background-color: #f2f2f2;\r\n    border: 1px solid #8c8e8f;\r\n    /* color of the scroll thumb */\r\n    overflow-y: auto;\r\n}\r\n\r\nbody::-webkit-scrollbar {\r\n    -webkit-appearance: none;\r\n    background-color: #f2f2f2;\r\n}\r\n\r\nbody::-webkit-scrollbar:horizontal {\r\n    height: 6px;\r\n}\r\n\r\nbody::-webkit-scrollbar-thumb {\r\n    background-color: #8c8e8f;\r\n}\r\n\r\nbody::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n.drill_cut_tv_popup {\r\n    max-width: 736px !important;\r\n}\r\n\r\n.css-zipzvv::-webkit-scrollbar {\r\n    width: 10px;\r\n    overflow-y: hidden;\r\n    /* width of the entire scrollbar */\r\n}\r\n\r\n.css-zipzvv::-webkit-scrollbar-track {\r\n    background: #fff;\r\n    overflow-y: hidden;\r\n    /* color of the tracking area */\r\n}\r\n\r\n.css-zipzvv::-webkit-scrollbar-thumb {\r\n    background-color: #f2f2f2;\r\n    border: 1px solid #8c8e8f;\r\n    /* color of the scroll thumb */\r\n    overflow-y: hidden;\r\n}\r\n\r\n.css-zipzvv::-webkit-scrollbar {\r\n    -webkit-appearance: none;\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n.css-zipzvv::-webkit-scrollbar:horizontal {\r\n    height: 10px;\r\n}\r\n\r\n.css-zipzvv::-webkit-scrollbar-thumb {\r\n    background-color: #8c8e8f;\r\n}\r\n\r\n.css-zipzvv::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n\r\n.ArticleProductTitle.drillcut_purple {\r\n    padding-bottom: 7px;\r\n}\r\n\r\n.css-1dklj6k {\r\n    padding-bottom: 7px;\r\n}\r\n\r\n.dril_club_noclr {\r\n    padding: 135px 0 175px 88px !important;\r\n}\r\n\r\n.bg_color_acrhove .css-0 {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n}\r\n\r\n.lt_pr_4sbmt_det {\r\n    /* margin-right: 12px; */\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n/* vijay css */\r\n\r\nbutton.btn_drpdwn {\r\n    margin-top: 0px;\r\n}\r\n\r\n\r\n@media (max-width: 1160px) {\r\n    .spec_table_list {\r\n        display: none !important;\r\n    }\r\n\r\n    .spec_accordian_box {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media (min-width: 1160px) {\r\n    .spec_table_list {\r\n        display: block;\r\n    }\r\n\r\n    .spec_accordian_box {\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n.display-block {\r\n    display: block !important;\r\n}\r\n\r\n.ruby div[role='progressbar'] {\r\n    background-color: #c22e4f;\r\n}\r\n\r\n.sapphire div[role='progressbar'] {\r\n    background-color: #4061ad;\r\n}\r\n\r\n.emerald div[role='progressbar'] {\r\n    background-color: #008473;\r\n}\r\n\r\n.diamond div[role='progressbar'] {\r\n    background-color: #a692be;\r\n}\r\n\r\n@media (min-width: 1000px) {\r\n    .overflow-inherit {\r\n        overflow-x: inherit !important;\r\n        overflow-y: inherit !important;\r\n    }\r\n}\r\n/* 11-04 */\r\n.slick_slider_custom_arrows {\r\n    position: relative;\r\n    z-index: 9;\r\n}\r\n.slick_slider_custom_arrow {\r\n    position: absolute;\r\n    width: 20px;\r\n    z-index: 9;\r\n    top: -30px;\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .mob_img_bx {\r\n        background-color: #f2f2f2;\r\n        height: 80px;\r\n        max-width: 80px;\r\n        position: relative;\r\n        width: 80px;\r\n        display: block;\r\n    }\r\n\r\n    .mob_img_bx img {\r\n        max-width: 100%;\r\n        width: 100%;\r\n        object-fit: contain;\r\n        height: 80px;\r\n    }\r\n\r\n    .mob_pd_nm {\r\n        padding-left: 15px;\r\n        padding-top: 15px;\r\n\r\n        width: calc(100% - 95px);\r\n        display: block;\r\n        word-wrap: break-word;\r\n\r\n    }\r\n\r\n    .pd_name_bmt {\r\n        display: block;\r\n        overflow-wrap: break-word;\r\n\r\n    }\r\n}\r\n\r\n@media (max-width: 450px) {\r\n\r\n    .wd_50_prview-wd-1 td.css-1f2qau6 {\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
